var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardboardBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h2v-1h1v2h-1v1h-2zm-14 11v-1h2v1h-1v1h-2v-1zm3-10h1v3h-1zm5 3h-1v-1h-1v-1h2zm-12 2v-2h1v1h1v1zm6-1v1h-2v-2h1v1zm13-8v-2h1v2zm-17 12v1h-1v-2h1zm12-1h2v1h-2zm11 2v-2h1v2zm-12 0h1v2h-1v-1zm10 2h-1v-1h2v1zm7 0h-2v-1h2zm-30 5h-2v-1h2zm25-23h1v1h-1zm-3 1h1v1h-1zm-1 2v1h-1v-1zm-2 2v-1h1v1zm3 0v-1h1v1zm-6 1v-1h1v1zm-6 2h-1v-1h1zm4-1v1h-1v-1zm1 1v1h-1v-1zm2 0h1v1h-1zm-12 2v-1h1v1zm11-1h1v1h-1zm-17 1v1h-1v-1zm19 1h-1v-1h1zm-19 1h1v1h-1zm8 0v1h-1v-1zm-8 2h-1v-1h1zm11-1v1h-1v-1zm3 1v-1h1v1zm-10 1v-1h1v1zm-3 1h-1v-1h1zm9 0h-1v-1h1zm7-1h1v1h-1zm3 1v-1h1v1zm0 1h-1v-1h1zm0 0h1v1h-1zm-4 2h-1v-1h1zm10-1v1h-1v-1zm-31 2h-1v-1h1zm19-1h1v1h-1zm9 0h1v1h-1zm-18 1v1h-1v-1zm12 1v-1h1v1zm-19 0h1v1h-1z",
    fill: "#d8a76d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v5h-1v-3h-1v-1h1zm19 7h-2v-3h1v2h1zm0-2v-1h3v2h-1v-1zm-1-4v2h-1v-1h-1v-1zm-21 5v-1h1v-1h1v2zm16 1v2h-2v-1h1v-1zm4-8v1h-1v-2h1zm-10 3h1v2h-1v-1zm3 2h-1v-2h1v1zm5 1h-1v-2h1v1zm-15 4h-1v-1h2v1zm23-18h-1v-1h1zm-1 1v1h-1v-1zm-9 5v-1h1v1zm-2 0v1h-1v-1zm8 0v1h-1v-1zm-13 2h-1v-1h1zm5 0v-1h1v1zm-3 0v1h-1v-1zm10 0h1v1h-1zm-12 2h-1v-1h1zm9 0h-1v-1h1zm-12 0h1v1h-1zm3 1v-1h1v1zm13 1v-1h1v1zm5 0h1v1h-1zm-21 2h-1v-1h1zm21 0h1v1h-1zm-30 2h-1v-1h1zm9-1v1h-1v-1zm13 0v1h-1v-1zm-13 2v-1h1v1zm2-1h1v1h-1zm15 1v-1h1v1zm-5 0h1v1h-1zm-17 1h1v1h-1z",
    fill: "#d9a86e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h2v1h-1v1h-1v-1h-1v-1h-1v-1h2zm-10-6h1v4h-1v-1zm12 1v-1h1v3h-1v-1h-1v-1zm0-9h1v1h-2v-2h1zm-6 12h-2v-1h1v-1h1zm7-10h2v1h-2zm-9 8v1h-2v-1h1zm-8 2v-1h2v1h-1zm15 0v1h-1v-2h1zm-17 3h-1v-2h1v1zm2 1v-1h2v1h-1zm4 0h-1v-1h2v1zm9-20h1v1h-1zm0 5h1v1h-1zm0 2v1h-1v-1zm4 2v-1h1v1zm-5 2v-1h1v1zm-4 2h-1v-1h1zm5 0v-1h1v1zm-1 0h1v1h-1zm-1 2v-1h1v1zm-17 0v1h-1v-1zm18 2h-1v-1h1zm-1 0v1h-1v-1zm-19 2v1h-1v-1zm16 1h-1v-1h1zm-17 2v-1h1v1zm4-1h1v1h-1zm13 2h-1v-1h1z",
    fill: "#dcab71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h2v1h-1v1h-1v1h-1v-2h1zm26 7v1h-3v-1zm-1-18v-1h2v1h-1zm-13 6h-1v-2h1v1zm-6 8v-2h1v2zm-8 4h2v1h-2zm33 1h1v1h-2v-1zm-24 2h-1v-1h2v1zm21-21v-1h1v1zm-3 1h-1v-1h1zm-2 1v-1h1v1zm-16 3h1v1h-1zm9 0v1h-1v-1zm3 1v-1h1v1zm0 0v1h-1v-1zm-6 1h1v1h-1zm-2 1v1h-1v-1zm10 1h-1v-1h1zm-5 0h1v1h-1zm-17 3h-1v-1h1zm6-1v1h-1v-1zm-6 3v1h-1v-1zm1 1v-1h1v1zm16-1v1h-1v-1zm2 0h1v1h-1zm-20 2h1v1h-1zm9 3v-1h1v1zm-10 0v1h-1v-1zm8 0v1h-1v-1zm15 0v1h-1v-1zm2 1h-1v-1h1zm5 0h-1v-1h1zm-25 2v-1h1v1zm30-1v1h-1v-1zm-32 2h-1v-1h1zm30 0v-1h1v1zm-26 1h-1v-1h1zm-5 2h1v1h-1zm0 2h1v1h-1z",
    fill: "#d6a56b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v1h1v1h-1v1h-1v-2h-1v-1zm-4-11v-2h1v1h1v1zm34 11h1v-1h1v2h-2zM60 91h2v1h-2zm-2 3v-1h2v1h-1zm0 2h-1v-1h2v1zm-7 9v-1h2v1h-1zm25 0v-1h1v2h-1zm3-23v1h-1v-1zm-2 3v1h-1v-1zm-13 6h-1v-1h1zm2-1h1v1h-1zm-8 2v-1h1v1zm11 0h-1v-1h1zm-16 3v-1h1v1zm3-1h1v1h-1zm-2 1h1v1h-1zm-1 1v1h-1v-1zm-2 2v1h-1v-1zm1 2v1h-1v-1zm-1 3h-1v-1h1zm29 1v-1h1v1zm5 0h-1v-1h1zm-6 0v1h-1v-1zm3 0v1h-1v-1zm-9 2v-1h1v1zm10 0v-1h1v1zm3 0h-1v-1h1zm-32 1v-1h1v1zm2 1h-1v-1h1zm27 2h-1v-1h1zm-30 3h-1v-1h1zm13 3h1v1h-1zm-6 2h1v1h-1z",
    fill: "#d4a369"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95h3v3h-1v-1h-2zm-8 9v-2h1v1h1v2h-1v-1zm24-14v-1h1v2h-2v-1zm-2 1h1v1h-2v-2h1zm-1-3h2v1h-2zm-2 7v-1h1v2h-1zm-15 6v-2h1v2zm9 3h-1v-2h1v1zm4-11v1h-1v-1zm8 0v1h-1v-1zm-8 1h1v1h-1zm9 0h1v1h-1zm-20 2h1v1h-1zm8 1h-1v-1h1zm-6 1h-1v-1h1zm11-1v1h-1v-1zm-14 2v-1h1v1zm7 0h1v1h-1zm12 0h1v1h-1zm-21 2h-1v-1h1zm15-1v1h-1v-1zm3 1h-1v-1h1zm-13 0v1h-1v-1zm9 0v1h-1v-1zm-18 2v1h-1v-1zm1 2h-1v-1h1zm4-1h1v1h-1z",
    fill: "#dbaa70"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81 101v1h-3v-1h1zM71 91v1h-1v-2h1zm-10 5v-1h2v1h-1zm3 4h-1v-2h1v1zm-5 1v1h-1v-2h1zm-3 2v-1h2v1h-1zm19 1v-2h1v2zm-22 0h1v2h-1v-1zm16 1v-1h1v2h-1zm10-20h1v1h-1zm2 1v-1h1v1zm-1 0h1v1h-1zm-1 3v1h-1v-1zm-6 2v-1h1v1zm5-1v1h-1v-1zm3 1v1h-1v-1zm-23 2v1h-1v-1zm18 1v1h-1v-1zm-8 2v-1h1v1zm3-1v1h-1v-1zm3 1h-1v-1h1zm-5 1v1h-1v-1zm-13 2v-1h1v1zm-1 0v1h-1v-1zm2 0h1v1h-1zm-3 2h-1v-1h1zm14-1v1h-1v-1zm5 1v-1h1v1zm-12 0h1v1h-1zm-2 3v-1h1v1zm9-1h1v1h-1zm-12 2h-1v-1h1zm15-1h1v1h-1z",
    fill: "#daa96f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91v1h-1v1h-1v-1h-1v-1h1zm3 2v-1h2v-1h1v2zm13 9v1h-3v-1zm-7-15v1h-1v-2h1zm-12 8h-1v-1h2v1zm5 3h2v1h-2zm-16 3v1h-1v-2h1zm25-18h-1v-1h1zm-3 8h-1v-1h1zm-8 2v-1h1v1zm-7 0h1v1h-1zm0 1v1h-1v-1zm1 0h1v1h-1zm7 0h1v1h-1zm-17 5v-1h1v1zm7 0h-1v-1h1zm12 1h1v1h-1zm-18 3h-1v-1h1zm8-1h1v1h-1zm9 0h1v1h-1zm5 0v1h-1v-1zm-23 2h-1v-1h1zm21-1v1h-1v-1zm2 1v1h-1v-1zm-16 2h-1v-1h1zm18 0h-1v-1h1zm1 0v-1h1v1z",
    fill: "#d7a66c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96h1v2h-2v-1h1zm10-5v1h-1v-2h1zm-4 1v1h-1v-2h1zm6 0v1h-1v-2h1zm0 10h2v1h-2zm-16 6h1v1h-2v-1zm11-17v-1h1v1zm-5 0v1h-1v-1zm5 2v1h-1v-1zm-7 1v1h-1v-1zm-7 1v1h-1v-1zm0 3v-1h1v1zm-1 1h-1v-1h1zm0 1v-1h1v1zm19 1h-1v-1h1zm-20 3v-1h1v1zm34 0h-1v-1h1zm-2 0v1h-1v-1zm-28 2h-1v-1h1zm4-1v1h-1v-1zm15 0h1v1h-1zm6 0h1v1h-1zm7 0v1h-1v-1zm-34 2v-1h1v1zm5 1v-1h1v1zm27-1v1h-1v-1zm-32 4v-1h1v1z",
    fill: "#d5a46a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41 51v-1h3v1h-1zm11-1v1h-1v1h-1v-2zm-5 2h3v1h-3zm0-1v1h-1v-2h1zm-16 7h1v1h-2v-1zm-5 2v2h-1v-2zm23-11h1v1h-1zm12 0v1h-1v-1zm-9 2h1v1h-1zm2 0h1v1h-1zm7 1h1v1h-1zm-26 2h1v1h-1zm9 1v-1h1v1zm6-1h1v1h-1zm3 0v1h-1v-1zm-27 1v1h-1v-1zm24 1h-1v-1h1zm-14 0h1v1h-1zm-11 2h1v1h-1zm2 0h1v1h-1zm2 2v-1h1v1zm-2 1h1v1h-1zm-1 5h-1v-1h1z",
    fill: "#c28b55"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v-1h1v4h-1zm9 2v-1h-1v-1h2v1h1v1h-1zm2-5h-3v-1h3zm-16 7v-2h1v2zm4 1v-2h1v2zm15-15h1v1h-1zm-1 1h1v1h-1zm-1 3h1v1h-1zm-10 3h-1v-1h1zm3-1v1h-1v-1zm9 1v-1h1v1zm-11 1h1v1h-1zm7 0h1v1h-1zm2 1h1v1h-1zm-8 1h1v1h-1zm-7 1v1h-1v-1zm11 1h-1v-1h1zm6 0h-1v-1h1zm1-1h1v1h-1zm-2 1v1h-1v-1zm-13 4h1v1h-1zm9 1h-1v-1h1z",
    fill: "#ddac72"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62 94h-1v-1h-1v-1h2zm16-10v1h-2v-1h1zM51 95h2v1h-2zm31 12v-1h2v1h-1zm-33 8v2h-1v-2zm32-30h-1v-1h1zm-18 5v-1h1v1zm0 2h-1v-1h1zm-4 3h-1v-1h1zm-3 1v-1h1v1zm-3 3v1h-1v-1zm-2 1v1h-1v-1zm30 3h1v1h-1zm-31 2v-1h1v1zm2 0v1h-1v-1zm30 1h-1v-1h1zm-33 1v1h-1v-1zm2 1v-1h1v1zm0 2v1h-1v-1zm1 2h-1v-1h1zm-1 0v1h-1v-1zm1 1v1h-1v-1zm-3 6h-1v-1h1z",
    fill: "#d3a268"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h2v1h-1zm8 1v1h-2v-1h1zm3 2h-2v-1h2zm-22 0h2v1h-2zm20 4h1v1h-2v-1zm-20-8v1h-1v-1zm20 1h-1v-1h1zm-13 0h1v1h-1zm4 1h-1v-1h1zm-11 1v-1h1v1zm2 0v-1h1v1zm4 0h-1v-1h1zm8 0h-1v-1h1zm6 1v1h-1v-1zm-18 2h1v1h-1zm14 0h1v1h-1zm-16 2v-1h1v1zm-12 1v-1h1v1zm0 0v1h-1v-1zm0 3h-1v-1h1zm-3 0v1h-1v-1zm30 0h1v1h-1zm-29 2h-1v-1h1z",
    fill: "#c18a54"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h2v1h-3v-2zm-16 2v1h-1v1h-1v-2zM25 62h2v2h-1v-1h-1zm28-10h2v1h-2zm7 2h-2v-1h2zm-11-4v1h-1v-1zm10 0h1v1h-1zm-2 2h1v1h-1zm7 1v1h-1v-1zm-4 1h1v1h-1zm-7 1v1h-1v-1zm9 0v1h-1v-1zm-34 3h-1v-1h1zm-1 0v1h-1v-1zm2 1h-1v-1h1zm30 0h-1v-1h1zm-30 1v1h-1v-1zm-2 5h1v1h-1z",
    fill: "#c08953"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v-2h1v2zm-5 3v1h-2v-1h1zm10 3h-2v-1h2zm-5-22h1v1h-1zm-4 3h1v1h-1zm-5 2h-1v-1h1zm2 0h-1v-1h1zm0 1h1v1h-1zm-16 4v-1h1v1zm4 0h-1v-1h1zm-5 1v-1h1v1zm23 2v-1h1v1zm-36 1h-1v-1h1zm38 2h1v1h-1zm4 1h-1v-1h1zm-6 1v-1h1v1zm-1 0h1v1h-1zm4 1v1h-1v-1zm-7 2v1h-1v-1zm-2 1v1h-1v-1zm5 1h-1v-1h1zm-1 1h-1v-1h1zm4 0v1h-1v-1zm-6 3v-1h1v1z",
    fill: "#d6a56d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94h-3v-1h2v-1h1zm0-6h-1v-3h1zm3 7h-1v-3h1v1zm-7 1v-1h2v2h-1v-1zm2 2v-1h2v1h-1zm-2-14h1v1h-1zm-2 1h1v1h-1zm0 2h-1v-1h1zm4 0h-1v-1h1zm-1 1h-1v-1h1zm3 2v-1h1v1zm1 1h1v1h-1zm-1 5h-1v-1h1zm1 2v-1h1v1zm-8 0h1v1h-1zm2 1h1v1h-1zm1 2v-1h1v1z",
    fill: "#dbaa72"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57 57v-1h3v-1h1v1h1v1zm-16-4v-2h1v1h2v1zm-9 7h-1v-1h2v1zm29 1v-1h2v1h-1zm3-10v-1h1v1zm-15 1v-1h1v1zm9 0h1v1h-1zm4 2v-1h1v1zm3 0h-1v-1h1zm-16 1v-1h1v1zm13 0h-1v-1h1zm-11 0v1h-1v-1zm-26 1h1v1h-1zm39 3v1h-1v-1zm-38 6v-1h1v1z",
    fill: "#bf8852"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51 60h-1v-1h5v1zm-6-4v-1h1v2h-1zm3 0v-1h1v2h-1zm-8 1h1v1h-2v-1zm-17 3h-1v-2h1v1zm21 0h1v2h-1v-1zm-23-6h1v1h-1zm3 0v1h-1v-1zm23 1h-1v-1h1zm-9 0v1h-1v-1zm2 1v-1h1v1zm-16 1v1h-1v-1zm18 2h-1v-1h1zm2-1v1h-1v-1zm-6 2v1h-1v-1zm4 2v-1h1v1z",
    fill: "#c48d55"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94 100h2v1h1v1h-2v-1h-1zm-2 0h-1v-2h2v1h-1zm-1-20h1v2h-1v-1zm3 17v-1h2v1h-1zm-2-17v-1h1v1zm2 1h-1v-1h1zm-8 4v-1h1v1zm-21 3v1h-1v-1zm2 1h-1v-1h1zm3 0h-1v-1h1zm1-1h1v1h-1zm-16 5h-1v-1h1zm1 1h-1v-1h1zm36 3h-1v-1h1zm5 3h-1v-1h1zm-11 0h1v1h-1zm-2 2v-1h1v1zm4 1v-1h1v1z",
    fill: "#d5a46c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73 90h-3v-1h3zm13 13v-1h1v-1h1v2zM71 88h-1v-1h2v1zm25 11h-1v-2h1v1zm-10 0h2v1h-2zm-2 2v1h-1v-2h1zm6-20h1v1h-1zm-5 3h-1v-1h1zm2-1v1h-1v-1zm-2 3h1v1h-1zm-29 8v-1h1v1zm37 0h-1v-1h1zm0 1v1h-1v-1zm2 1v-1h1v1zm-1 1h-1v-1h1zm1 3h-1v-1h1zm-7 0h1v1h-1z",
    fill: "#d7a66e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83 99v-2h2v1h1v1zm7-14v2h-1v-2zm-1 4h-1v-1h2v1zm-6 1v2h-1v-2zm1 4v1h-2v-1h1zm3 1h-1v-1h2v1zm-4-9h-1v-1h1zm1-1h1v1h-1zm0 2h-1v-1h1zm3 0v-1h1v1zm-3 2h1v1h-1zm8 3h-1v-1h1zm-2 1v1h-1v-1zm0 1h1v1h-1z",
    fill: "#ddac74"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-2h3v1zm0 4h3v1h-3zm2-1v-2h1v2zm-2 1h-1v-2h1v1zm1-9h-1v-1h1zm1 1h1v1h-1zm1 1h1v1h-1zm-2 4v1h-1v-1zm-4 3v-1h1v1zm1 1v-1h1v1zm-9 0h1v1h-1zm10 1h1v1h-1zm-11 2v-1h1v1zm-9 1h-1v-1h1zm-3 0h1v1h-1zm12 1v-1h1v1z",
    fill: "#dead73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64 112h1v1h1v1h-2zm-11 5v1h-3v-1h1zm20-9v1h-2v-1h1zm-7 4v-1h1v2h-1zm-7 3v1h-1v-2h1zm2 0v1h-1v-2h1zm13-8h1v1h-1zm11 2h1v1h-1zm-9 1h1v1h-1zm-7 3v-1h1v1zm-1 0v1h-1v-1zm-14 2v1h-1v-1zm2 0v1h-1v-1zm-1 2h-1v-1h1zm6 1h-1v-1h1z",
    fill: "#d4a267"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-2v-1h2zm4-1v2h-1v-2zm-19 3v1h-1v-2h1zm4-7v-1h1v1zm-3 1h1v1h-1zm11 1h1v1h-1zm7 1h-1v-1h1zm-37 0h1v1h-1zm26 1h1v1h-1zm-27 2v-1h1v1zm29 1h-1v-1h1zm-26 1v-1h1v1zm34 0h-1v-1h1zm-32 1h-1v-1h1zm23-1v1h-1v-1zm-18 2v1h-1v-1zm-8 2v-1h1v1zm33 1h-1v-1h1z",
    fill: "#c38c56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102h-2v-2h3v1h-1zm-40-8v-1h2v1h-1zm44 9v1h-1v-2h1zm-5-23h1v1h-1zm-8 2h1v1h-1zm-1 1v1h-1v-1zm-16 4v1h-1v-1zm-4 1h1v1h-1zm6 2h-1v-1h1zm24 8h-1v-1h1zm0 0h1v1h-1zm4 1h-1v-1h1zm1 0v1h-1v-1zm-11 5v-1h1v1zm4 2h-1v-1h1z",
    fill: "#d3a26a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88 106h-2v-3h1v2h1zM71 86v1h-1v1h-1v-2zm23 16h-1v-1h2v1zm-8-19v-1h1v1zm-13 5v1h-1v-1zm-7 1h1v1h-1zm31 9h1v1h-1zm-4 2v-1h1v1zm2-1h1v1h-1zm-8 3h-1v-1h1zm2-1v1h-1v-1zm8 0h1v1h-1zm-6 1h1v1h-1zm-2 2v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#d4a36b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109v-3h1v3zm0-12h1v1h-2v-1zm32 8v-1h1v2h-1zm-5-21v-1h1v1zm-2 1v-1h1v1zm-12 5v1h-1v-1zm-4 2h1v1h-1zm-10 14v-1h1v1zm32 0h-1v-1h1zm-24 1h-1v-1h1zm-2 1h1v1h-1zm30 0h1v1h-1zm-33 2h-1v-1h1zm4-1h1v1h-1zm21 3h-1v-1h1zm-27 3v-1h1v1zm0 5v-1h1v1z",
    fill: "#d2a167"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90 97h-1v-3h1zm0-12h-2v-1h2zm-6 4h-1v-2h1v1zm1-1h1v2h-1v-1zm3 1h1v2h-1v-1zm-4 2h-1v-1h2v1zm0 3h-1v-2h1v1zm5-7h1v1h-1zm-4 4h1v1h-1zm0 3v-1h1v1zm-1 3v-1h1v1zm3 0v-1h1v1zm-2 2h1v1h-1z",
    fill: "#dead75"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50v2h-1v-1h-1v-1zm-2 4v1h-1v1h-1v-2zm-18 7v-2h1v2zm17-14h1v1h-1zm15 2h1v1h-1zm-14 2v1h-1v-1zm8 1h-1v-1h1zm2 0h-1v-1h1zm-3 1v1h-1v-1zm2 1h-1v-1h1zm-26 0v1h-1v-1zm10 2h-1v-1h1zm7 1v-1h1v1zm9 0h-1v-1h1zm-23 2h1v1h-1z",
    fill: "#c48d57"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51 117v-2h2v2zm27-7h-3v-1h3zm-17 1h1v2h-1v-1zm12 1v1h-1v-2h1zm-1-4v-1h1v1zm-1 2h-1v-1h1zm1-1h1v1h-1zm-2 3h-1v-1h1zm-11 1h-1v-1h1zm8 2v-1h1v1zm-10 0v1h-1v-1zm2 1v-1h1v1zm-7 3h-1v-1h1z",
    fill: "#d3a166"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21 57h2v1h-2zm33 5v-1h2v1h-1zm-13 0h1v2h-1v-1zm3 2v1h-1v-2h1zm-4-10h1v1h-1zm-18 1h1v1h-1zm34 0h1v1h-1zm-32 2h-1v-1h1zm16-1h1v1h-1zm-1 2h-1v-1h1zm-2 0h1v1h-1zm2 0h1v1h-1zm13 0h1v1h-1zm-29 3h-1v-1h1zm22 2h-1v-1h1z",
    fill: "#c38c54"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38 63h2v2h-1v-1h-1zm24-17v-1h1v2h-1zm2 0v-1h2v1h-1zm-11 2h-2v-1h2zm11-3h-1v-1h1zm-14 1v1h-1v-1zm-10 3h-1v-1h1zm23 0h-1v-1h1zm-28 5h-1v-1h1zm-1 5h-1v-1h1zm1 2h-1v-1h1zm1 1h-1v-1h1zm1 3v-1h1v1z",
    fill: "#c28d57"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48v-1h1v2h-1zm-2 0h1v2h-1v-1zm-4 2v-1h2v1h-1zm2 2h2v1h-2zm5-6h-1v-1h1zm1 1h-1v-1h1zm-4 0v1h-1v-1zm-6 3v-1h1v1zm13 1h-1v-1h1zm2 0h-1v-1h1zm0 2h-1v-1h1zm5 5h-1v-1h1zm1 0v-1h1v1zm-1 3v-1h1v1z",
    fill: "#c99766"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54v2h-1v-2zm2 4h1v2h-1v-1zm-3-2v1h-1v-1zm7 0h1v1h-1zm-2 2v-1h1v1zm7 1v-1h1v1zm2-1h1v1h-1zm2 0h1v1h-1zm-31 1v1h-1v-1zm15 1h-1v-1h1zm6 0h-1v-1h1zm9 1h-1v-1h1zm-11 2v-1h1v1zm13-1h1v1h-1zm-14 1h1v1h-1zm2 1v-1h1v1z",
    fill: "#c58e56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M92 103h1v1h1v1h-1v1h-1v-2zm-3 2v-2h1v1h1v1zm5-8h1v1h-2v-1zm-2-18v1h-1v-1zm-8 3v1h-1v-1zm-19 6v-1h1v1zm-2 1h-1v-1h1zm4 1v-1h1v1zm25 10v-1h1v1zm1 2h1v1h-1zm3 1v1h-1v-1zm2 1v1h-1v-1z",
    fill: "#d2a169"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111v2h-1v-1h-2v-1zm5 2v-1h1v2h-1zm27-8v-1h1v1zm-22 4h-1v-1h1zm-3 0h1v1h-1zm-5 2v1h-1v-1zm-7 2h-1v-1h1zm13-1v1h-1v-1zm-15 2v-1h1v1zm2-1h1v1h-1zm-4 2h1v1h-1zm-7 1h1v1h-1zm5 0h1v1h-1zm4 2v-1h1v1z",
    fill: "#d2a065"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M93 81h1v1h-1zm-9 3v1h-1v-1zm1 2v-1h1v1zm2-1h1v1h-1zm-2 1v1h-1v-1zm4 6h1v1h-1zm4 0h1v1h-1zm-2 2h-1v-1h1zm3 1v-1h1v1zm-3 1h-1v-1h1zm-5 1v1h-1v-1zm4 1h-1v-1h1zm7 0v-1h1v1zm-9 1v-1h1v1zm3 0h-1v-1h1zm-9 1v-1h1v1zm7 0h1v1h-1z",
    fill: "#daa971"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96 85h-1v-2h2v3h-1zm0 4h-1v-2h1v1zm4 2h1v2h-1v-1zm-6-10h1v1h-1zm5 4v1h-1v-1zm-2 1h1v1h-1zm2 1v-1h1v1zm-1 0h1v1h-1zm1 2v-1h1v1zm-5 0h1v1h-1zm6 7v-1h1v1z",
    fill: "#dbac76"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M87 84v-1h2v1h-1zm7 7v1h-1v-2h1zm2 6v-1h1v2h-1zm-5 2v2h-1v-2zm-8-11h-1v-1h1zm6 4v-1h1v1zm4 1h-1v-1h1zm0 2h1v1h-1zm-7 2h1v1h-1zm4 1v1h-1v-1zm-6 1v1h-1v-1zm1 2h-1v-1h1zm5 0v1h-1v-1z",
    fill: "#d9a870"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-2h1zm0 3v-1h1v2h-1zm29-10v1h-1v-1zm2 2v-1h1v1zm7 0v1h-1v-1zm-24 1h1v1h-1zm9 0v1h-1v-1zm9 5v-1h1v1zm-1 1h1v1h-1zm5 1h-1v-1h1zm-32 1v-1h1v1zm-3 2v1h-1v-1zm-3 2v-1h1v1zm2 1h-1v-1h1z",
    fill: "#be8751"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-2h1v1h2v2h-2zm0 2h2v4h-1v-3h-1zm-2-4h-1v-2h1v1zm-1-2h-1v-1h1zm-1 2h1v1h-1zm4 10v-1h1v1z",
    fill: "#efc58b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60v-1h1v-1h1v2zm-1-5h-1v-1h2v1zm17 4h-1v-2h1v1zm-7-4v1h-1v-1zm-10 2h-1v-1h1zm16-1v1h-1v-1zm-30 3h-1v-1h1zm14 0v-1h1v1zm17 0h1v1h-1zm-14 1h1v1h-1zm12 1h-1v-1h1z",
    fill: "#c79058"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h-1v-1h1v-1h1v1zm-36-4h1v1h1v1h-2zm25-1v1h-1v-1zm10 0v1h-1v-1zm-18 2v-1h1v1zm11 1h1v1h-1zm-27 1v1h-1v-1zm18 3h-1v-1h1zm15 0v-1h1v1zm1 1v-1h1v1z",
    fill: "#c28b53"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M90 99v1h-2v-1h1zm1-19v1h-1v-1zm-9 5v-1h1v1zm6 0h-1v-1h1zm-16 2h1v1h-1zm20 3h1v1h-1zm-2 2h1v1h-1zm2 3v-1h1v1zm-1 0h1v1h-1zm5 0h1v1h-1zm-6 1h1v1h-1zm7 0h1v1h-1zm-14 4v1h-1v-1zm7 2h1v1h-1z",
    fill: "#d8a76f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v2h-1v-1h-2v-1zm-5 1v1h-1v-2h1zm4 4v1h-1v-2h1zm-6-10h-1v-1h1zm0 1v-1h1v1zm-1 1v-1h1v1zm1 0h1v1h-1zm1 1h1v1h-1zm2 8v-1h1v1zm3 1v-1h1v1z",
    fill: "#f1c78d"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57h-1v-2h3v1h-2zm-14-7v1h-1v1h-1v-2zm1 1v-1h1v2h-1zm1-5v1h-1v-1zm-4 7h-1v-1h1zm18 3h1v1h-1zm0 3v-1h1v1zm1 1v-1h1v1z",
    fill: "#c79564"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v-1h1v2zm25-4v-2h1v2zm-18 0v-1h1v1zm5 0v-1h1v1zm3 0h-1v-1h1zm-16 1h1v1h-1zm-8 5h1v1h-1zm4 6v-1h1v1zm3-1v1h-1v-1zm-1 4v-1h1v1zm1 0h1v1h-1z",
    fill: "#c08b55"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-2v-1h1zm4 10h-1v-1h2v1zm4 0h-2v-1h2zm-9-14h-1v-1h1zm2 5v-1h1v1zm-5 1v-1h1v1zm4 1v-1h1v1zm2 0h1v1h-1zm0 1v1h-1v-1zm6 3v1h-1v-1zm0 3h1v1h-1z",
    fill: "#c89462"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93h1v2h-1v-1zm-4-10h-1v-1h1zm-2 1h1v1h-1zm2 2h-1v-1h1zm0 1v-1h1v1zm5 0h-1v-1h1zm-3 2h-1v-1h1zm4-1v1h-1v-1zm-3 1h1v1h-1zm-1 2h-1v-1h1zm2 0v-1h1v1zm-3 2v-1h1v1zm4 4h-1v-1h1z",
    fill: "#d9aa74"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M57 117v-1h2v2h-1v-1zm13-3v-2h1v2zm-17 3h2v1h-2zm20-8v-1h1v1zm1 2h-1v-1h1zm-15 0v1h-1v-1zm9 0h1v1h-1zm3 0h1v1h-1zm-12 2v-1h1v1zm1 1v-1h1v1z",
    fill: "#d19f64"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h1v1h-1v1h1v1h-2v-4zm-1-3h-1v-1h1zm-3 6h-1v-1h1zm6-1v1h-1v-1zm-2 4v1h-1v-1zm10 3v-1h1v1zm6 0v1h-1v-1zm-1 5h1v1h-1z",
    fill: "#ca9867"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h2v1h-2zm36-11h1v1h-1zm-10 6v1h-1v-1zm-5 1v1h-1v-1zm6 1h-1v-1h1zm3 1h-1v-1h1zm-4 0v1h-1v-1zm-27 3h-1v-1h1zm34-1v1h-1v-1zm-9 2v-1h1v1zm-9 1h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#c58e58"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M34 58h1v2h-1v-1zm7 4v1h-2v-1h1zm-4 1h1v1h-2v-1zm15-17h1v1h-1zm12 0h1v1h-1zm-2 2v-1h1v1zm2 1v-1h1v1zm-26 2v1h-1v-1zm-7 4v1h-1v-1zm4 9h1v1h-1z",
    fill: "#c18c56"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1zm16-1v1h-1v-1zm-5 1v1h-1v-1zm-2 2h-1v-1h1zm5 0h1v1h-1zm2 2h-1v-1h1zm-2 1h-1v-1h1zm-37 1h-1v-1h1zm34-1h1v1h-1zm3 1v-1h1v1zm0 0v1h-1v-1zm-1 2h-1v-1h1zm-36 3v1h-1v-1z",
    fill: "#bd8650"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M53 114v-1h1v-1h1v2zm12-5h2v1h-2zm-3-2v1h-1v-1zm2 0v1h-1v-1zm4 1v1h-1v-1zm1 0h1v1h-1zm-10 1h1v1h-1zm3 2h-1v-1h1zm6-1v1h-1v-1zm-16 10h-1v-1h1z",
    fill: "#d6a36a"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M64 114h-1v-2h1v1zm5-1v1h-1v-2h1zm9-6v1h-1v-1zm-1 1v1h-1v-1zm-5 2h1v1h-1zm-14 4v-1h1v1zm-1 1v-1h1v1zm3 0h-1v-1h1zm-6 1v-1h1v1zm2 0h1v1h-1zm-5 5v-1h1v1z",
    fill: "#d5a368"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M101 61v1h-1v1h-1v-2zm4 2v1h-3v-1h1zm0-1v-1h1v2h-1zm-7-10v1h-1v-1zm-9 1h1v1h-1zm12 12v-1h1v1zm5-1v1h-1v-1z",
    fill: "#c99563"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v2h-1v-1zm1 4v1h-2v-1h1zm-6-6v1h-1v-1zm4 5h-1v-1h1zm2-1h1v1h-1zm5 5h1v1h-1zm3 1h-1v-1h1zm0 0h1v1h-1zm-5 2v1h-1v-1zm4 2h-1v-1h1z",
    fill: "#c79361"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h1v1h-2v-1zm-2-1h1v1h-1zm18 0v1h-1v-1zm-12 1v1h-1v-1zm16 1v-1h1v1zm-13 0v1h-1v-1zm9 0v1h-1v-1zm-21 1v1h-1v-1zm4 0v1h-1v-1zm-6 1v1h-1v-1zm31 0v1h-1v-1z",
    fill: "#6f3e1e"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M96 89h3v1h-2v1h-1zm1-7h1v1h-2v-1zm0 11h1v1h-2v-1zm-1-11h-1v-1h1zm-2 5h1v1h-1zm4 0v1h-1v-1zm3 2h-1v-1h1z",
    fill: "#daab75"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v2h-1v-1h-1v-1zm-3-4v-1h1v1zm-1 1v-1h1v1zm1 3v-1h1v1zm-3 1v-1h1v1zm1 2v-1h1v1zm0 1v1h-1v-1zm3 1v-1h1v1zm-1 2h-1v-1h1zm-13 0v1h-1v-1z",
    fill: "#dfae74"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93h-2v-2h1v1h1zm-5 2v1h1v1h-2v-2zm4-5v-2h1v2zm-3-1v1h-1v-1zm-2 4h1v1h-1zm2 2v-1h1v1zm2 1v1h-1v-1z",
    fill: "#dfae76"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h2v1zM36 59h-1v-1h2v1zm-3 2h2v1h-2zm28-16h1v1h-1zm-23 7v1h-1v-1zm-6 4h-1v-1h1zm8 7h1v1h-1zm-2 1h1v1h-1z",
    fill: "#c48f59"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1zm3 7h1v1h-1zm8 1v-1h1v1zm-32 0v1h-1v-1zm23 1h-1v-1h1zm-8 1v-1h1v1zm-1 1h-1v-1h1zm-17 1h1v1h-1zm34 1v1h-1v-1zm-31 2h-1v-1h1zm20 3v-1h1v1z",
    fill: "#c18a52"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1v1h-1v-3h1zm3 10h-1v-2h1v1zM86 48v-1h1v1zm9 6h1v1h-1zm2 1v-1h1v1zm5 5h-1v-1h1zm-1 2v1h-1v-1z",
    fill: "#cc9866"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52v-1h1v2h-1zm1 5v1h-1v-2h1zm5 6v-1h1v2h-1zm-9-8h1v1h-1zm5 2v-1h1v1zm0 1v1h-1v-1zm-1 2h1v1h-1zm9 6h1v1h-1z",
    fill: "#c69260"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1zm10-1h1v1h-1zm-8 1v1h-1v-1zm6 0v1h-1v-1zm-13 2h-1v-1h1zm5 0v-1h1v1zm0 1h-1v-1h1zm9 0h-1v-1h1zm-10 0v1h-1v-1zm2 1h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#c68f57"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67h-1v-1h2v2h-1zm15 1h-2v-1h2zm-16 0h1v1h-2v-1zm5 0v-1h1v1zm-3 1v-1h1v1zm19 0h-1v-1h1zm-28 3h-1v-1h1z",
    fill: "#6e3d1d"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M93 84v2h-1v-1h-1v-1zm-1-2v1h-1v-1zm1 1h1v1h-1zm1 4h-1v-1h1zm0 2h-1v-1h1zm-1 0v1h-1v-1zm7 2v1h-1v-1zm-1 3h1v1h-1zm0 3v-1h1v1z",
    fill: "#daab73"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h2v2h-2zm-1-1v-1h1v2h-1zm-2 0h-1v-1h1zm-2 1h1v1h-1zm4 2h1v1h-1zm4 0v1h-1v-1zm-2 3h-1v-1h1z",
    fill: "#edc28b"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-2h1v2zm3-5v-1h1v1zm-5 1v1h-1v-1zm7 0v1h-1v-1zm3 2v-1h1v1zm5 6h-1v-1h1zm4-1h1v1h-1zm-2 2v-1h1v1zm3 2h-1v-1h1z",
    fill: "#cb9968"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1zm-2 2h-1v-1h1zm2 0v-1h1v1zm-10 1h1v1h-1zm13 1v1h-1v-1zm-6 1v1h-1v-1zm7 0v1h-1v-1zm8 3v-1h1v1zm-5 2v-1h1v1zm5 3v1h-1v-1z",
    fill: "#c69463"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85v-1h1v1zm1 2v1h-1v-1zm-3 1h1v1h-1zm7 2h1v1h-1zm0 1v1h-1v-1zm-3 1v1h-1v-1zm-1 2h1v1h-1zm2 1h1v1h-1zm1 1h1v1h-1zm-6 1h1v1h-1z",
    fill: "#dcab73"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M32 90h-2v-1h-1v-2h1v1h1v1h1zm4 1v2h-1v-2zm-5-4h-1v-1h1zm2 1h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#efc48d"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h-1v-1h2zm-13 2h1v1h-2v-1zm-7 3h1v1h-1zm44 8v1h-1v-1zm-4 1v1h-1v-1zm2 0h1v1h-1zm3 3h-1v-1h1z",
    fill: "#d1a068"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-2v-1h2zm-12 0h1v1h-2v-1zm28-4v1h-1v-1zm-31 3h1v1h-1zm-6 1h1v1h-1zm-4 2h1v1h-1zm22 0v1h-1v-1zm-23 3h1v1h-1z",
    fill: "#d4a168"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M63 108h1v2h-1v-1zm4-1h1v1h-1zm-2 1h1v1h-1zm4 1h-1v-1h1zm-10 0v1h-1v-1zm19 2h-1v-1h1zm2 0h1v1h-1zm-25 1h1v1h-1zm2 2v1h-1v-1z",
    fill: "#d5a269"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1zm3 1v-1h1v1zm2 0v-1h1v1zm-8 3v-1h1v1zm13 1v-1h1v1zm-10 0v1h-1v-1zm17 4v-1h1v1zm-2 1v-1h1v1zm2 1h-1v-1h1z",
    fill: "#c89665"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71v1h-1v-2h1zm-25-4h-1v-1h1zm2 0v-1h1v1zm2 0v-1h1v1zm10 0v-1h1v1zm-12 2h-1v-1h1zm-8 0v1h-1v-1zm5 0h1v1h-1z",
    fill: "#703f1f"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80v1h-3v-1zm-6 0h-2v-1h2zm-6 2h-1v-2h1v1zm-3-3h1v1h-1zm0 3v-1h1v1z",
    fill: "#542c12"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88v-1h2v1h-1zm1 2h1v1h-2v-1zm-3 6h-1v-1h2v1zm-1-6h-1v-1h1zm1 2h1v1h-1zm5 2v1h-1v-1z",
    fill: "#e0af77"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48v-1h3v1zm-8 0v-1h1v2h-1zm-11-2h1v1h-1zm44 15h-1v-1h1zm1 0h1v1h-1z",
    fill: "#c48f5b"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v2h-1v-2zm4 0v1h-1v-1zm-8 1v1h-1v-1zm-17 2h-1v-1h1zm4-1v1h-1v-1zm6 16v-1h1v1zm40 1v-1h1v1z",
    fill: "#c38e59"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M60 61h-1v-3h1zm2-11h1v1h-1zm-34 7h1v1h-1zm33 2v-1h1v1zm3-1v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#bb844e"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M101 77h1v3h-1v-1zm-1 6v-1h1v2h-1zm-1-3v-1h1v1zm-1 2v-1h1v1zm4 3h-1v-1h1z",
    fill: "#daab77"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h-1v-1h2zm23-24v1h-1v-1zm-27 25h1v1h-1zm4 1v-1h1v1zm4 0v1h-1v-1zm-7 2h-1v-1h1z",
    fill: "#d7a46b"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-2v-1zm5-1v-1h1v1zm-28 8h1v1h-1zm34 12v1h-1v-1zm-36 1h1v1h-1zm0 5v-1h1v1zm1 3v-1h1v1z",
    fill: "#d1a066"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87v1h-1v-2h1zm6 3h1v1h-2v-1zm-5-5v1h-1v-1zm-36 4h-1v-1h1zm41 6h1v1h-1zm-1 3h1v1h-1z",
    fill: "#d9aa72"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1zm-5 1h-1v-1h1zm4-1v1h-1v-1zm-12 11h1v1h-1zm4 8h1v1h-1zm-4 3v1h-1v-1zm1 2h-1v-1h1zm14 2h-1v-1h1z",
    fill: "#d09f65"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48 114v-1h2v1h-1zm10-23v-1h1v1zm-6 2h-1v-1h1zm-2 9h-1v-1h1zm32 4v1h-1v-1zm-13 5h-1v-1h1zm-4 3h1v1h-1z",
    fill: "#d19f65"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h-1v-3h1v1zm3 4v-1h2v1h-1zm1-3v1h-1v-1zm-1 1v1h-1v-1zm-3 1h1v1h-1z",
    fill: "#efcca2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-3h1v1zm-2-5h1v2h-1v-1zm-4 7v-1h2v1h-1zm8-1h-1v-1h1z",
    fill: "#d9a66d"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61 109h1v-1h1v2h-2zm3-4h1v1h-1zm0 3v-1h1v1zm2-1h1v1h-1zm-6 2v-1h1v1zm7 1v-1h1v1z",
    fill: "#d8a56c"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h-1v-1h2v1zm-37 4h-1v-1h1zm11-1h1v1h-1zm10 0v1h-1v-1zm-21 2v1h-1v-1zm-1 2h1v1h-1zm4 1v-1h1v1z",
    fill: "#d3a167"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M53 112v-1h2v1h-1zm28-5v1h-1v-1zm-3 1h1v1h-1zm-19 3v-1h1v1zm-2 1v1h-1v-1zm-2 2v-1h1v1zm-3 5h1v1h-1z",
    fill: "#d29f66"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v2h-1v-1zM56 45v1h-1v-1zm12 1v1h-1v-1zm-8 3h-1v-1h1zm-7 13v1h-1v-1zm-13 4v-1h1v1z",
    fill: "#c28d59"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h1v1h-2zm-32 1h-1v-1h1zm1 0h1v1h-1zm53 10h-1v-1h1zm-56 2h-1v-1h1z",
    fill: "#bd8552"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v2h-1v-2zm3-8v1h-1v-1zm-1 4v1h-1v-1zm-34 5v1h-1v-1zm37 2h-1v-1h1zm-39 5h1v1h-1z",
    fill: "#bc854f"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M99 59v2h-1v-2zm3 2v1h-1v-2h1zm-6-11v1h-1v-1zm-1 3h1v1h-1zm-1 2v-1h1v1z",
    fill: "#ca9664"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1zm30-1h1v1h-1zm17 5v-1h1v1zm3 1h1v1h-1zm1 2v-1h1v1zm-57 2h1v1h-1zm2 1v1h-1v-1z",
    fill: "#bf8754"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v1h-2v-2h1v1zm-4 2h1v2h-1v-1zm-25-9h-1v-1h1zm25 3h1v1h-1z",
    fill: "#c38f56"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M90 58h1v1h2v1h-3zm4 4v2h-1v-2zm-1-1v-1h1v1z",
    fill: "#c5905c"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-4v-1h2v-1h1v-1h1z",
    fill: "#6d3c1c"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v-1h1v2h-1zm-1-11v-1h1v1zm7 5v1h-1v-1zm-1 1v1h-1v-1zm-4 1v1h-1v-1zm-1 3h-1v-1h1z",
    fill: "#d7a872"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M94 82v1h-1v1h-1v-2zm4 16v-2h1v1h1v1zm-6-9v-1h1v1z",
    fill: "#d7a870"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M38 92h-1v-2h1v1zm-5-7v1h-1v-1zm7 6h1v1h-1zm-2 3h-1v-1h1zm5 2h-1v-1h1zm2 6h-1v-1h1z",
    fill: "#eec48a"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-2v-1h1zm-3-3h-1v-1h1zm-1 0v1h-1v-1zm1 1v1h-1v-1zm5 2h1v1h-1zm-2 2h1v1h-1z",
    fill: "#f4ca90"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1zm20 9v-1h1v1zm5-1v1h-1v-1zm-23 1v1h-1v-1zm6 4v-1h1v1zm2 3h-1v-1h1zm9 0v1h-1v-1z",
    fill: "#d5a369"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109v2h-1v-2zm-12 2h1v1h-2v-1zm14-3h1v1h-1zm-20 8v1h-1v-1zm1 1h1v1h-1z",
    fill: "#d09e63"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1zm-11 2h1v1h-1zm29 2h1v1h-1zm-64 8h-1v-1h1zm-5 18h-1v-1h1zm100-1h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1zm-4 4h1v1h-1zm13 6v1h-1v-1zm1 1v-1h1v1zm10 1h-1v-1h1zm-8 5v-1h1v1z",
    fill: "#c99764"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1zm-3 4v-1h1v1zm-10 2v1h-1v-1zm-3 8v1h-1v-1zm-3 3h1v1h-1zm2 1v-1h1v1z",
    fill: "#bf8a54"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1zm-28 3v-1h1v1zm1 0h1v1h-1zm-6 4v1h-1v-1zm1 3v1h-1v-1zm1 5h1v1h-1z",
    fill: "#c38e58"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1zm5 0h1v1h-1zm2 0h1v1h-1zm-9 14h1v1h-1zm4 1v1h-1v-1zm-2 1v1h-1v-1z",
    fill: "#c18d54"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1zm-5 3v-1h1v1zm-1 1h1v1h-1zm-28 2h-1v-1h1zm24 0v-1h1v1zm-19 4v-1h1v1z",
    fill: "#bf8851"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1zm-1 3v-1h1v1zm20 7h-1v-1h1zm-1 1h1v1h-1zm-55 3h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#bc8451"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h1v3h-1zm-2 2v1h-1v-1zm6 5v-1h1v1zm1 2h-1v-1h1z",
    fill: "#cd9967"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-2h1v2zm-8-2h-1v-1h1zm8-1v1h-1v-1zm1 5h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#c08952"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-2v-1h1zm-3 2h-1v-1h2v1zm-1 2v-1h1v1zm1 3v1h-1v-1z",
    fill: "#b8804d"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-2h1v1zm-30-6v1h-1v-1zm30 8h-1v-1h1zm-3 2h-1v-1h1zm2-1h1v1h-1z",
    fill: "#c49057"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v2h-1v-2zm-4 1h-1v-1h1zm1-1h1v1h-1zm-1 2v-1h1v1zm12 9v-1h1v1z",
    fill: "#c5915f"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60v-1h-1v-1h2v2zm-4-4v1h-1v-1zm3 1v1h-1v-1zm2 3h1v1h-1z",
    fill: "#ca9865"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1zm13 2h-1v-1h1zm-25 2v-1h1v1zm35 1v-1h1v1zm-1 1v-1h1v1zm5 1h-1v-1h1z",
    fill: "#714020"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76v-2h1v1h1v1zm5-2v1h-2v-1h1zm-7 3v-1h1v1z",
    fill: "#6d4021"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1zm7 0h-1v-1h1zm-6 0v1h-1v-1zm2 1h-1v-1h1zm1 0v-1h1v1zm2 2h-1v-1h1z",
    fill: "#572e14"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v-2h1v2zm0 1h2v1h-2zm2-5v1h-1v-1zm-1 9h-1v-1h1z",
    fill: "#f1c892"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1zm-15 3v1h-1v-1zm-2 2v1h-1v-1zm2 0v1h-1v-1zm-12 3h-1v-1h1zm3-1h1v1h-1z",
    fill: "#d09f67"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1zm2 2v1h-1v-1zm-7 3v-1h1v1zm7 1v1h-1v-1zm-2 1h1v1h-1zm2 0h1v1h-1z",
    fill: "#eec38c"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1zm-13 4v1h-1v-1zm36 13h-1v-1h1zm-3 1h-1v-1h1zm8-1v1h-1v-1zm-5 1h1v1h-1z",
    fill: "#cf9e66"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1zm5 1v-1h1v1zm-6 1v-1h1v1zm3 2h1v1h-1zm3 0v1h-1v-1zm1 2v1h-1v-1z",
    fill: "#f0c68c"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v-2h1v2zm2 4v1h-1v-1zm37 5v-1h1v1zm6 0v-1h1v1zm-36 3v-1h1v1z",
    fill: "#d4a269"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1zm0 5h1v1h-1zm1 3h-1v-1h1zm-2 0h1v1h-1zm11 2h-1v-1h1zm14 0h1v1h-1z",
    fill: "#d2a066"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M72 107h-2v-1h2zm3 0h-1v-1h2v1zm-13-5v1h-1v-1zm-4 4v1h-1v-1z",
    fill: "#d6a46a"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M99 104h1v1h-1zm-30 4v-1h1v1zm12-1h1v1h-1zm-17 1h1v1h-1zm15 1h1v1h-1zm-24 2h1v1h-1z",
    fill: "#d3a067"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110h1v3h-1v-1zm22-4h1v1h-1zm-31 5h1v1h-1zm6 1v1h-1v-1z",
    fill: "#d4a268"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M77 107v1h-2v-1h1zm-14 4v2h-1v-2zm8-3v-1h1v1zm3-1v1h-1v-1z",
    fill: "#d6a469"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110v2h-1v-2zm-11 6h1v1h-2v-1zm5-1h-1v-1h1zm-15 2v1h-1v-1z",
    fill: "#cf9d62"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1zm9 2v-1h1v1zm-5 0v1h-1v-1zm31 13v1h-1v-1zm-53 6v-1h1v1z",
    fill: "#c18c58"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1zm-10 4h1v1h-1zm17 5v1h-1v-1zm10 2v1h-1v-1zm-5 5h-1v-1h1z",
    fill: "#c99765"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1zm9 2h-1v-1h1zm-9 1v-1h1v1zM39 63h-1v-1h1zm-2 2v1h-1v-1z",
    fill: "#c28d58"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1zm-6 4h-1v-1h1zm-7 6v1h-1v-1zm0 5h-1v-1h1zm3 1h1v1h-1z",
    fill: "#bd8852"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61v-1h2v2h-1v-1zm12-13v1h-1v-1zM47 59v-1h1v1z",
    fill: "#c59158"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1zm2 1h-1v-1h1zm11 4h1v1h-1zm3 0v1h-1v-1zm-4 2h1v1h-1z",
    fill: "#cc9a69"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1zm-8 3h-1v-1h1zm11 1h-1v-1h1zm-12 0v1h-1v-1zm11 1h-1v-1h1z",
    fill: "#c59362"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1zm-9 5v-1h1v1zm2 1v-1h1v1zm19 10h-1v-1h1zm-4 1v-1h1v1z",
    fill: "#c4905a"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51v-1h1v2h-1zm-1-1v-1h1v1zm-29 6v-1h1v1zm16-1h1v1h-1z",
    fill: "#c68f59"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h2v1h-1zm28-9h1v1h-1zm-35 7h1v1h-1zm3 2v-1h1v1z",
    fill: "#c18b55"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h-1v-3h1zm-14-8v1h-1v-1zm21 11v-1h1v1z",
    fill: "#cb9967"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1zm-45 1h1v1h-1zm8 10v-1h1v1zm58 1h-1v-1h1zm-67 2v1h-1v-1z",
    fill: "#bf8853"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1zm0 5v1h-1v-1zm2 3v-1h1v1zm0 6h1v1h-1zm7 1h-1v-1h1z",
    fill: "#c4905e"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v-1h1v2h-1zM32 53h-1v-1h1zm64 10v-1h1v1zm-1 1h1v1h-1z",
    fill: "#c6935e"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v2h-1v-2zm8 5v-1h1v1zm-2 2h1v1h-1zm1 4v-1h1v1z",
    fill: "#cb9765"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60v1h-1v-2h1zm-9-6h-1v-1h1zm5 3h-1v-1h1zm8 8h-1v-1h1z",
    fill: "#c89563"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1zm1 5v-1h1v1zm4 0h-1v-1h1zm-7 1h-1v-1h1zm-34 5v1h-1v-1z",
    fill: "#ba834d"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-2h1v1zm-2-3h1v1h-1zm2 0h1v1h-1zm1 3v1h-1v-1z",
    fill: "#c6915d"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v-1h1v-1h1v2zm3-3h1v1h-1zm-3 1v1h-1v-1z",
    fill: "#6b3e1d"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h3v1zm-3-1h1v1h-1zm15 3h1v1h-1z",
    fill: "#633516"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1zm3-1v1h-1v-1zm-6 2h-1v-1h1zm-17 3v-1h1v1zm-6 1v-1h1v1z",
    fill: "#5a3117"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79v-1h1v1zm-9 4h1v1h-1zM54 93h-1v-1h1zm38 14v-1h1v1zm-43 10v1h-1v-1z",
    fill: "#d3a269"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79v-1h1v1zm-1 1h-1v-1h1zm-2 4v-1h1v1zm4 8h-1v-1h1zm-2 2h-1v-1h1z",
    fill: "#d5a670"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v2h-1v-1zm-4-4v1h-1v-1zm0 4h1v1h-1zm-1 2h1v1h-1z",
    fill: "#f0c58e"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1zm-15 5h1v1h-1zm-13 11h1v1h-1zm1 11v-1h1v1zm1 0h1v1h-1z",
    fill: "#cf9e64"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-2h1v2zm2-3v1h-1v-1zm4 3v1h-1v-1zm-3 3v-1h1v1z",
    fill: "#ecc18a"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M96 86v1h-1v-1zm0 1h1v1h-1zm0 2v1h-1v-1zm5 0v1h-1v-1zm-1 9h1v1h-1z",
    fill: "#d8a973"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88v1h-1v-1zm-2 3h1v1h-1zm5 1h-1v-1h1zm-4 1h1v1h-1zm-39 25h1v1h-1z",
    fill: "#e2b179"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1zm0 7v-1h1v1zm31 0h-1v-1h1zm3 2v-1h1v1zm-29 5h1v1h-1z",
    fill: "#d2a067"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M36 104v1h-3v-2h1v1zm-6-1h1v1h-1z",
    fill: "#edc89e"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v2h-1zm1-2h-1v-1h1zm1-1h1v1h-1zm-2 2h-1v-1h1z",
    fill: "#edc087"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M41 107v-2h1v2zm3-4v1h-1v-1zm-2 2v-1h1v1zm2 0v1h-1v-1z",
    fill: "#ecbf86"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1zm-4 5v-1h1v1zm8 1v1h-1v-1zm25 12h1v1h-1z",
    fill: "#c38e5a"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1zm5 5h1v1h-1zm-41 3v1h-1v-1zm62 7v-1h1v1z",
    fill: "#c28c59"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1zm-15 6h1v1h-1zm7 0h1v1h-1zm-22 7v-1h1v1z",
    fill: "#c38d57"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1zm0 5h-1v-1h1zm11 0h-1v-1h1zM44 65h1v1h-1z",
    fill: "#c08a54"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M60 46h-2v-1h2zm8 1v-1h1v1zM35 66v-1h1v1z",
    fill: "#c18c57"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1zm-9 4v-1h1v1zm17 5h1v1h-1zm-2 3h1v1h-1z",
    fill: "#ca9866"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1zm12 0h1v1h-1zM36 59h1v1h-1zm1 4v-1h1v1z",
    fill: "#c5905a"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1zm1 0v-1h1v1zm-5 0h1v1h-1zM36 61h1v1h-1z",
    fill: "#c7925c"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1zm2 0v-1h1v1zm-33 5h1v1h-1zm-1 5v1h-1v-1z",
    fill: "#c38e57"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M47 64v1h-1v-2h1zm7-16h1v1h-1zm-6 12h1v1h-1z",
    fill: "#c28e55"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50v-1h2v1h-1zm22 10h1v1h-1zm-56 4v-1h1v1z",
    fill: "#c08855"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h1v1h-1zm2 2v-1h1v1zm0 1h-1v-1h1zm1 0v1h-1v-1z",
    fill: "#c99667"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1zm-4 2h1v1h-1zm26 2h1v1h-1zm-26 3h1v1h-1z",
    fill: "#c18a53"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1zm-1 1h1v1h-1zm8 5h1v1h-1zm22 2h1v1h-1z",
    fill: "#c48e58"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54v-1h1v2h-1zm6 0h1v1h-1zm2 1h1v1h-1z",
    fill: "#bf8850"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M69 54v1h1v1h-2v-2zm-2 2h1v1h-1z",
    fill: "#b67e4b"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1zm3-1v1h-1v-1zM26 67v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#ba824f"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M89 54h2v1h-2zm-1 2v-1h1v1zm1 0h1v1h-1z",
    fill: "#c5905e"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1zm-4 2v-1h1v1zm2 0v1h-1v-1zm-41 2h1v1h-1z",
    fill: "#c7925e"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1zm11 0h-1v-1h1zm-4 2h-1v-1h1zm17 3v1h-1v-1z",
    fill: "#6f3e1d"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h-2v-2h2z",
    fill: "#6b3a1a"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1zm-9 1h-1v-1h1zm2-1h1v1h-1zm23 4v-1h1v1z",
    fill: "#6c3b1b"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M48 72v-1h1v2h-1zm5-3v1h-1v-1zm-8 2h1v1h-1z",
    fill: "#714322"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v1h-1v-2h1zm31-12h-1v-1h1zM52 82v1h-1v-1z",
    fill: "#502c14"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v-1h1v2zm5-4h1v1h-1z",
    fill: "#704324"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h2v1h-2zm-14 5h-1v-2h1v1z",
    fill: "#633619"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-2v-1h1zm4 1h-1v-1h2v1z",
    fill: "#603418"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-3h1v1zm2-3v1h-1v-1z",
    fill: "#6f4223"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1zm-22 7h1v1h-1zm-3 3h-1v-1h1zm-8 1v-1h1v1z",
    fill: "#4d2810"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1zm-3 1h-1v-1h1zm-22 4h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#593016"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76h1v1h-1zm-1 7v-1h1v1zm0 1v1h-1v-1zm0 5v1h-1v-1z",
    fill: "#f0c791"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1zm-21 3v-1h1v1zm5 0h-1v-1h1zm-7 1v-1h1v1z",
    fill: "#593017"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-2v-1h2zm11-3h1v1h-1zm-14 4h-1v-1h1z",
    fill: "#552d13"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77h1v1h-1zm2 20h1v1h-1zm0 3v-1h1v1zm1 2h-1v-1h1z",
    fill: "#d3a470"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M99 78h1v1h-1zm1 8v-1h1v1zm3 0h-1v-1h1zm-1 9v1h-1v-1z",
    fill: "#d6a773"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M61 81v-1h3v1h-1zm9-1h-1v-1h1z",
    fill: "#532d12"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M101 80h-1v-1h1zm-2 0h1v1h-1zm3 0v1h-1v-1zm-2 1h1v1h-1z",
    fill: "#dcad79"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h2v1zm-15 2h1v2h-1v-1z",
    fill: "#532d13"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81v-1h1v1zm1 1v-1h1v1zm-2 0h1v1h-1zm1 3h-1v-1h1z",
    fill: "#dbac78"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82h-1v-1h2v1zm-6 2v-1h1v2h-1z",
    fill: "#512c12"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1zm-5 1v-1h1v1zm0 0v1h-1v-1zm-1 2h-1v-1h1z",
    fill: "#502b11"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82h1v1h-1zm4 1v1h-1v-1zm-1 1v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#d9aa76"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-2h1v1zm8-1v1h-1v-1zm-7 2h-1v-1h1z",
    fill: "#4d2911"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84h-1v-1h2v1zm1 5h-1v-2h1v1z",
    fill: "#dcad75"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M99 99h1v2h-1v-1zm-6-14v-1h1v1zm5 10h1v1h-1z",
    fill: "#d6a76f"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1zm7 5h-1v-1h1zm-3 0h1v1h-1zm3 2h1v1h-1z",
    fill: "#f2c88e"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1zm-8 2v1h-1v-1zm-8 4h-1v-1h1zm39 11v-1h1v1z",
    fill: "#d6a56c"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91v-2h1v2zm-1-3h1v1h-1zm6 9h-1v-1h1z",
    fill: "#f3c98f"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M86 90v-2h1v2zm-1 2h-1v-1h1zm-3 1v-1h1v1z",
    fill: "#e1b078"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M43 100v-2h1v2zm-4-7v1h-1v-1zm2 7v-1h1v1z",
    fill: "#edc389"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101h1v2h-1v-1zm-1-6h1v1h-1zm1 4v-1h1v1z",
    fill: "#f3c68b"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v1h-1zm1 3v-1h1v1zm4 0h-1v-1h1zm-3 1v-1h1v1z",
    fill: "#f0cda3"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1zm-2 2v1h-1v-1zm-4 3h-1v-1h1zm3-1h1v1h-1z",
    fill: "#dba86f"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h-1v-1h1zm-1 1h1v1h-1zm3 0v1h-1v-1zm-6 1h1v1h-1z",
    fill: "#daa76e"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v-1h1v1zm3 0v1h-1v-1zm-19 2v1h-1v-1zm8 0h1v1h-1z",
    fill: "#d7a56c"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1h-1v-1h3v1z",
    fill: "#edc085"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56h-1v-1h2v1zm-9-14h1v1h-1z",
    fill: "#c89663"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1zm-13 4v-1h1v1zm-14 6v1h-1v-1z",
    fill: "#c28e58"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1zM47 66h-1v-1h1zm-8 1h1v1h-1z",
    fill: "#c18d56"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1zM49 58h1v1h-1zm0 2h1v1h-1z",
    fill: "#c69058"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1zm-34 9h1v1h-1zm9 13h1v1h-1z",
    fill: "#c5915b"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1zm0 19h-1v-1h1zm-21 3h1v1h-1z",
    fill: "#be8956"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1zm-21 5h-1v-1h1zm-5 12v1h-1v-1z",
    fill: "#be8953"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1zm-40 8h-1v-1h1zm19 14h-1v-1h1z",
    fill: "#c5915d"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1zm-1 11v-1h1v1zm6 6h-1v-1h1z",
    fill: "#c99663"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1zm-19 4v1h-1v-1zm63 15v-1h1v1z",
    fill: "#c58f5b"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1zm-1 1h-1v-1h1zm15 6v-1h1v1z",
    fill: "#c99767"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1zm4 5v1h-1v-1zm9 1v1h-1v-1z",
    fill: "#c99665"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1zm1 1h1v1h-1zm8 1h-1v-1h1z",
    fill: "#bf8a56"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1zm16 7v-1h1v1zm-6 2h-1v-1h1z",
    fill: "#c28b56"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1zm26 7v1h-1v-1zm-5 6h-1v-1h1z",
    fill: "#ca9864"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49v-1h1v1zm0 13h-1v-1h1zm-5 2v-1h1v1z",
    fill: "#c89562"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1zm-10 4v1h-1v-1zm22 4h1v1h-1z",
    fill: "#c38c57"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1zm-32 3v1h-1v-1zm14 1v1h-1v-1z",
    fill: "#c38d56"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1zm66 14v1h-1v-1zm1 3h-1v-1h1z",
    fill: "#c28f5c"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1zm58 3h1v1h-1zm0 2v1h-1v-1z",
    fill: "#c38e5c"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1zm51 7h-1v-1h1zm1 3h1v1h-1z",
    fill: "#be8653"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1zm54 8h-1v-1h1zm-2 3v-1h1v1z",
    fill: "#c48c59"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1zm36 2h-1v-1h1zm16 8v-1h1v1z",
    fill: "#c38b58"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50v1h-1v-1zm4 9v-1h1v1zm5 0h-1v-1h1z",
    fill: "#c79565"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51h-1v-1h1zm-13 2h1v1h-1zm-2 4h-1v-1h1z",
    fill: "#c89463"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1zm32 1h1v1h-1zm2 5h-1v-1h1z",
    fill: "#bb8350"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1zm48 5v-1h1v1zm3 4v1h-1v-1z",
    fill: "#c18956"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-2v-1zm22 2v-1h1v1z",
    fill: "#c39160"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M113 51h1v1h-1zm-90 50v-1h1v1zm20 19h-1v-1h1z",
    fill: "#aaf",
    fillOpacity: 0.012
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1zm-17 9h-1v-1h1zm15 3v1h-1v-1z",
    fill: "#c18a55"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1zm-16 8v-1h1v1zm31 0h1v1h-1z",
    fill: "#c58f57"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1zm3 4h-1v-1h1zm13 0h1v1h-1z",
    fill: "#be8750"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1zm-22 5h1v1h-1zm1 3h-1v-1h1z",
    fill: "#c28b54"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1zm-32 3h1v1h-1zm28 1h-1v-1h1z",
    fill: "#c38c55"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1zm3 2v1h-1v-1zm5 12h-1v-1h1z",
    fill: "#c18d5b"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v-1h1v1zm5 4h-1v-1h1zm-2 2v-1h1v1z",
    fill: "#c69461"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1zm0 2h1v1h-1zm5 6h1v1h-1z",
    fill: "#c6915b"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-2h1v2zm-1-3h1v1h-1z",
    fill: "#c39059"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1zm1 3v-1h1v1zm-6 4v-1h1v1z",
    fill: "#b9824d"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55v-1h1v1zm-3 7v-1h1v1zm-3 2h1v1h-1z",
    fill: "#c99562"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1zm-7 5h1v1h-1zm-30 4h1v1h-1z",
    fill: "#bc8550"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h2v1h-2zm-2 0v-1h1v1z",
    fill: "#b47c49"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h-1v-2h1v1zm2 0h-1v-1h1z",
    fill: "#b27a47"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1zm-6 3h1v1h-1zm9 2v-1h1v1z",
    fill: "#c89159"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M56 59h1v2h-1v-1zm-1-2h-1v-1h1z",
    fill: "#c08951"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1zm2 3h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#b9824c"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-2h1zm0 1h1v1h-1z",
    fill: "#b7804a"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M114 57v-1h1v1zm-96 2v1h-1v-1zm44 60h1v1h-1z",
    fillOpacity: 0.012
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1zm3 3h1v1h-1zm-5 2v-1h1v1z",
    fill: "#c38e55"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M93 58h1v1h-2v-1zm-2 5h1v1h-1z",
    fill: "#c8935f"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1zm2 2h-1v-1h1zm2 2v-1h1v1z",
    fill: "#c69259"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h-1v-1h1zm-13 0v1h-1v-1zm9 7v-1h1v1z",
    fill: "#c7935e"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1zm-1 1v1h-1v-1zm-24 6h1v1h-1z",
    fill: "#825130"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1zm7 2v1h-1v-1zm7 2h1v1h-1z",
    fill: "#c28e5b"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-2v-1h1zm6-4v-1h1v1z",
    fill: "#673717"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1zm-3 0h1v1h-1zm32 5v1h-1v-1z",
    fill: "#734222"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1zm17 0v1h-1v-1zm7 6v1h-1v-1z",
    fill: "#724121"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67v1h-1v-2h1zm5 1h-1v-1h1z",
    fill: "#c59161"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M73 78h2v1h-2zm4-11v1h-1v-1z",
    fill: "#4b240b"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1zm7 1v-1h1v1zm28 2h-1v-1h1z",
    fill: "#724122"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1zM58 83v1h-1v-1zm-6 3h1v1h-1z",
    fill: "#4e2810"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M101 69h-2v-1h2zm2-1v1h-1v-1z",
    fill: "#c18d5d"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-2v-1h1zm46 3h-1v-1h1z",
    fill: "#7a4928"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M65 70v1h-2v-1h1zm15-1v1h-1v-1z",
    fill: "#693919"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h2v1h-2zm-1 1h-1v-1h1z",
    fill: "#6d3d1c"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1zm5 1h-1v-1h1zm-11 1h-1v-1h1z",
    fill: "#6c3c1b"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1zm-7 3h-1v-1h1zm-6 0h1v1h-1z",
    fill: "#693c1e"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1zm3 1v-1h1v1zm-14 3v-1h1v1z",
    fill: "#623618"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1zm1 1h1v1h-1zm-14 2h1v1h-1z",
    fill: "#613417"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-2v-1h2zm-2 2v-1h1v1z",
    fill: "#6d4022"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M52 74v-1h1v2h-1zm-3 2h-1v-1h1z",
    fill: "#66391c"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1zm-4 0h1v1h-1zm-7 4v-1h1v1z",
    fill: "#63361a"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75h-1v-1h2v1zm-1 0v1h-1v-1z",
    fill: "#65381b"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h2v1h-1zm-13 3v-1h1v1z",
    fill: "#64361c"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M65 75h-3v-1h3z",
    fill: "#5f3215"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v2h-1v-1zm-3 2v-1h1v1z",
    fill: "#64371a"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1zm17 1h-1v-1h1zm-40 5h-1v-1h1z",
    fill: "#5c3115"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1zm-4 1h-1v-1h1zm-26 7h-1v-1h1z",
    fill: "#582f15"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1zm-14 5v-1h1v1zm3 0v-1h1v1z",
    fill: "#552c12"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76v1h-2v-1h1zm0 7v1h-1v-1z",
    fill: "#f0c790"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1zm-8 1h-1v-1h1zm-4 1h-1v-1h1z",
    fill: "#572f15"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1zm2 1v-1h1v1zm-3 0v1h-1v-1z",
    fill: "#593117"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1zm-20 1v-1h1v1zm17 0h-1v-1h1z",
    fill: "#562d14"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78h1v1h-1zm-46 35h-1v-1h1zm5 7h-1v-1h1z",
    fill: "#e5b67e"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M100 78h1v1h-1zm1 5v-1h1v1zm1 7v1h-1v-1z",
    fill: "#d8a975"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80v-1h1v2h-1zm1 7h-1v-1h1z",
    fill: "#f2c993"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1zm-19 1h1v1h-1zm3 0h1v1h-1z",
    fill: "#562e14"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80v-1h1v1zm-2 0h1v1h-1zm7 21v1h-1v-1z",
    fill: "#d3a46e"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h1v1h-1zm0 1v1h-1v-1zm3 18v-1h1v1z",
    fill: "#d4a56f"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80v1h-1v-1zm0 7v-1h1v1zm1 2h-1v-1h1z",
    fill: "#dcad77"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M28 82h-1v-1h1zm0 1v-1h1v1zm-3 4h1v1h-1z",
    fill: "#f2c992"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84h1v2h-1v-1zm15-2h-1v-1h1z",
    fill: "#4f2a10"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h-1v-1h1zm1 2h-1v-1h1zm1 3h1v1h-1z",
    fill: "#ddae78"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1zm-18 33h1v1h-1zm-12 4v1h-1v-1z",
    fill: "#d2a267"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1zm4 26v-1h1v1zm5 0h-1v-1h1z",
    fill: "#d0a066"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1zm3 1v-1h1v1zm2 1h1v1h-1z",
    fill: "#f2c790"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h-1v-1h2v2h-1z",
    fill: "#4e2a12"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1zm-4 30v1h-1v-1zm-8 4h-1v-1h1z",
    fill: "#d1a065"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1zm-4 1v1h-1v-1zm-27 18v-1h1v1z",
    fill: "#cc9b61"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1zm0 1v1h-1v-1zm5 1v1h-1v-1z",
    fill: "#4c2810"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86h1v-1h1v2h-2z",
    fill: "#ddae76"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85v1h-1v-1zm-1 7v-1h1v1zm1 6v1h-1v-1z",
    fill: "#d7a874"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1zm-17 8h1v1h-1zm42 11h-1v-1h1z",
    fill: "#d2a168"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1zm-5 18v1h-1v-1zm11 0v1h-1v-1z",
    fill: "#d2a268"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M82 86v1h-1v-1zm-9 3h1v1h-1zm9 13h-1v-1h1z",
    fill: "#daa970"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87v-1h1v1zm8 1h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#d6a771"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M91 90h1v1h-2v-1zm0-3v1h-1v-1z",
    fill: "#ddad75"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87h1v1h-1zm0 3v-1h1v1zm6 4v-1h1v1z",
    fill: "#dbac74"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88v2h-1v-2zm11 7v1h-1v-1z",
    fill: "#ecc38d"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v2h-1v-1zM59 89v1h-1v-1z",
    fill: "#d19e65"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1zm-5 3v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#d4a36a"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M99 91v1h-1v-1zm1 2h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#daab74"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1zm1 5h-1v-1h1zm2 0v-1h1v1z",
    fill: "#efc58a"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1zm1 6v1h-1v-1zm5 8v1h-1v-1z",
    fill: "#d3a168"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v2h-1v-2zm0-7v1h-1v-1z",
    fill: "#e8b97e"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1zm-7 5h-1v-1h1zm5 2v-1h1v1z",
    fill: "#f0cba1"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1zm0 3h-1v-1h1zm0 5v1h-1v-1z",
    fill: "#f1c489"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1zm0 4v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#ebbc81"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101h-1v-1h1zm5 1v-1h1v1zm-1 1v-1h1v1z",
    fill: "#f3cfa5"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-2h1zm3 1h1v1h-1z",
    fill: "#f1cca2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-2h1zm-5-4v1h-1v-1z",
    fill: "#eecca2"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1zm4 2h1v1h-1zm2 10v-1h1v1z",
    fill: "#d9a76e"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h2v1zm-4-2v1h-1v-1z",
    fill: "#ecc79d"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106v1h-2v-1h1zm-1 6v-1h1v1z",
    fill: "#edc086"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1zm8-1v1h-1v-1zm-14 7v1h-1v-1z",
    fill: "#d7a56b"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1zm2 0v1h-1v-1zm-13 2v-1h1v1z",
    fill: "#d3a066"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M49 114h1v2h-1v-1zm5 4v1h-1v-1z",
    fill: "#cf9d63"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M46 117v-1h1v-1h1v2z",
    fill: "#eab97f"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-2v-1z",
    fill: "#b6997b",
    fillOpacity: 0.275
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#cc9666"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1zM40 53v1h-1v-1z",
    fill: "#c48e56"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1zm-18 3h1v1h-1z",
    fill: "#c58f59"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1zm3 18h1v1h-1z",
    fill: "#cb9764"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1zm36 13h1v1h-1z",
    fill: "#c4905d"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1zM51 62h1v1h-1z",
    fill: "#c28e56"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1zm17 13v-1h1v1z",
    fill: "#ca9969"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1zM37 66v1h-1v-1z",
    fill: "#bc8753"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1zm36 19h1v1h-1z",
    fill: "#c08c58"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1zm-5 3v1h-1v-1z",
    fill: "#c08b56"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1zm26 21v1h-1v-1z",
    fill: "#c5915e"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1zm42 12h-1v-1h1z",
    fill: "#c58e5b"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-2v-1h1z",
    fill: "#c08b57"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1zm9 3v-1h1v1z",
    fill: "#bf8a55"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1zm30 16h1v1h-1z",
    fill: "#be8955"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1zm-9 18v-1h1v1z",
    fill: "#c18c59"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1zm15 4h1v1h-1z",
    fill: "#ca9768"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1zm-37 7h1v1h-1z",
    fill: "#c48f57"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1zM37 67v-1h1v1z",
    fill: "#c08c55"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1zm-19 6v-1h1v1z",
    fill: "#c9925c"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1zm16 5v1h-1v-1z",
    fill: "#c99666"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1zm-16 5v1h-1v-1z",
    fill: "#c38f57"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1zm-1 17h1v1h-1z",
    fill: "#c38d58"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1zm-22 9v-1h1v1z",
    fill: "#bc8751"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1zm-45 5v-1h1v1z",
    fill: "#c48b54"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M99 48h1v2h-1v-1z",
    fill: "#ca9767"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48h1v1h-1zm5 5v-1h1v1z",
    fill: "#c49363"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1zm-2 18v-1h1v1z",
    fill: "#bd8a54"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1zm12 1v-1h1v1z",
    fill: "#bf8953"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v2h-1v-2z",
    fill: "#c28a56"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1zm-34 9h-1v-1h1z",
    fill: "#bf8b54"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1zM34 67h1v1h-1z",
    fill: "#bf8a57"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1zm19 8v1h-1v-1z",
    fill: "#c79563"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1zm12 5v1h-1v-1z",
    fill: "#cd9b6a"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1zm10 12v-1h1v1z",
    fill: "#c99664"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1zm7 8h1v1h-1z",
    fill: "#cc9967"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1zm7 0v1h-1v-1z",
    fill: "#cb9766"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1v1h-1zm-3 4h1v1h-1z",
    fill: "#c89664"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1zm-9 11v-1h1v1z",
    fill: "#bd8751"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1zm-21 3h1v1h-1z",
    fill: "#c58d58"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1zm28 7h-1v-1h1z",
    fill: "#ca9663"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1zm67 14v1h-1v-1z",
    fill: "#c18e5b"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1zm16 13h1v1h-1z",
    fill: "#c38e5b"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M33 52v-1h1v2h-1z",
    fill: "#c58d5a"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1zm-10 5v1h-1v-1z",
    fill: "#bb8650"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-2h1z",
    fill: "#b77f4c"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1zM32 62h-1v-1h1z",
    fill: "#bc8450"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1zm20 3h-1v-1h1z",
    fill: "#c49261"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1zm3 7v1h-1v-1z",
    fill: "#ce9a68"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h1v1h-1zm7 5h1v1h-1z",
    fill: "#ca9868"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1zm3 7h-1v-1h1z",
    fill: "#c68f58"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1zm63 9v1h-1v-1z",
    fill: "#c7935f"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1zm-37 9v1h-1v-1z",
    fill: "#c08954"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1zm15 17h-1v-1h1z",
    fill: "#c38f5f"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1zm4 5h-1v-1h1z",
    fill: "#c4915f"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1zm6 1h-1v-1h1z",
    fill: "#c38b55"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1zm-10 2h-1v-1h1z",
    fill: "#c48d56"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1zm4 7h1v1h-1z",
    fill: "#bc854e"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1zM31 65v-1h1v1z",
    fill: "#bb834f"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1zm5 0h1v1h-1z",
    fill: "#be8553"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1zm12 8v-1h1v1z",
    fill: "#cc9766"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M109 54h-1v-1h1zm2 1v-1h1v1z",
    fill: "#c59262"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54v-1h1v1zm-8 17v1h-1v-1z",
    fill: "#c18d5e"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1zm-35 1h1v1h-1z",
    fill: "#c08950"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1zm-26 7h1v1h-1z",
    fill: "#bf8952"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1zm13 1h-1v-1h1z",
    fill: "#b77e4c"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1zm3 9h-1v-1h1z",
    fill: "#bc8455"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M99 55h-1v-1h1zm6 10h1v1h-1z",
    fill: "#cb9865"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M19 55h1v1h-1zm37 9h-1v-1h1z",
    fill: "#c18d57"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1zm1 1h1v1h-1z",
    fill: "#b57d4a"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1zm-1 4v-1h1v1z",
    fill: "#b37b48"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1zM30 66v-1h1v1z",
    fill: "#b57e4b"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1zM15 66v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1zm1 5v-1h1v1z",
    fill: "#bc8453"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v2h-1v-1z",
    fill: "#c28d5b"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1zm1 1h1v1h-1z",
    fill: "#c48f5d"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M102 57h-1v-1h1zm4 2v1h-1v-1z",
    fill: "#cc9a67"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1zm11 1v-1h1v1z",
    fill: "#c79059"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1zm-2 3h1v1h-1z",
    fill: "#c38e56"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1zm-26 4v1h-1v-1z",
    fill: "#c48f56"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1zM26 70h1v1h-1z",
    fill: "#b7814e"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1zm-69 8h-1v-1h1z",
    fill: "#c48f5c"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57h2v1h-2z",
    fill: "#c89360"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1zm13 7h1v1h-1z",
    fill: "#c7925f"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1zm2 3h-1v-1h1z",
    fill: "#c28a57"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58h1v1h-1zm-2 5h1v1h-1z",
    fill: "#ca9564"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59h-1v-1h1zm-2 1h1v1h-1z",
    fill: "#c79562"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#c7935a"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1zm-8 5v-1h1v1z",
    fill: "#c18b52"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1zm3 0h-1v-1h1z",
    fill: "#b8814c"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1zm13 12v-1h1v1z",
    fill: "#713f1f"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1zm13 4v-1h1v1z",
    fill: "#c89361"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1zm-2 5v-1h1v1z",
    fill: "#be8752"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1zm12 4h-1v-1h1z",
    fill: "#c28d56"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1zm4 2h-1v-1h1z",
    fill: "#c28c54"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1zm-10 3v1h-1v-1z",
    fill: "#845027"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1zm-8 2h-1v-1h1z",
    fill: "#844e2a"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1zm-2 7v1h-1v-1z",
    fill: "#572c10"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v2h-1v-1z",
    fill: "#c7955f"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62v1h-1v-1zm-1 2v1h-1v-1z",
    fill: "#c7945f"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M22 64h-1v-1h1zm26 0h1v1h-1z",
    fill: "#c38f55"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1zm-11 1h1v1h-1z",
    fill: "#c18c55"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h2v1z",
    fill: "#c08c54"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1zm28 6h1v1h-1z",
    fill: "#84502e"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1zm26 6v-1h1v1z",
    fill: "#84502c"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1zm-27 6h-1v-1h1z",
    fill: "#784626"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1zm-42 9h-1v-1h1z",
    fill: "#7b4a29"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1zm5 1v1h-1v-1z",
    fill: "#bd8952"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1zM44 86h-1v-1h1z",
    fill: "#522a10"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1zm9 5h1v1h-1z",
    fill: "#754322"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1zm-15 3v1h-1v-1z",
    fill: "#845331"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1zm33 6v-1h1v1z",
    fill: "#7e4e2b"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1zm-8 3h-1v-1h1z",
    fill: "#734221"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1zm13 6h-1v-1h1z",
    fill: "#754423"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1zm6 3v1h-1v-1z",
    fill: "#744121"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65h1v1h-1zm3 1v1h-1v-1z",
    fill: "#814b28"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65h1v1h-2v-1z",
    fill: "#88532e"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1zm-48 2h-1v-1h1z",
    fill: "#c49059"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M98 65h1v1h-1zm4 0v1h-1v-1z",
    fill: "#c4905f"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v-1h1v1zm3 1v1h-1v-1z",
    fill: "#c59160"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M31 67h-2v-1h2z",
    fill: "#bc8755"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M31 66h1v1h-1zm-1 3v-1h1v1z",
    fill: "#b78250"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1zm-2 1v1h-1v-1z",
    fill: "#b98452"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-2v-1z",
    fill: "#bd8854"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1zm49 3v1h-1v-1z",
    fill: "#8d5932"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1zm-9 0v1h-1v-1z",
    fill: "#693818"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v2h-1z",
    fill: "#6d3c1b"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67v-1h1v2h-1z",
    fill: "#542e17"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v1h-1zm3 1h-1v-1h1z",
    fill: "#8a542f"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67h-1v-1h1zm2 1h-1v-1h1z",
    fill: "#c38f5d"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M105 67h-1v-1h1zm-3 1h-1v-1h1z",
    fill: "#c79363"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1zm60 0v1h-1v-1z",
    fill: "#bd8a55"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1zm-14 4h1v1h-1z",
    fill: "#7e4d2b"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1zm-6 2h1v1h-1z",
    fill: "#683818"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1zm-2 5v1h-1v-1z",
    fill: "#4f280e"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#c28e5e"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1zm56 3h-1v-1h1z",
    fill: "#916039"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1zm52 3v1h-1v-1z",
    fill: "#7b4929"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1zm-14 4v-1h1v1z",
    fill: "#724323"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1zm-8 2v1h-1v-1z",
    fill: "#6f4120"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1zm-6 1h1v1h-1z",
    fill: "#724422"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1zm-3 1v-1h1v1z",
    fill: "#724222"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1zm35 4v1h-1v-1z",
    fill: "#754425"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1zm19 5h-1v-1h1z",
    fill: "#6b3a1b"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1zm13 3v1h-1v-1z",
    fill: "#663516"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70v-1h1v1zm5 0h-1v-1h1z",
    fill: "#b57f4f"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70v-1h2v1h-1z",
    fill: "#b78350"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1zm54 2h1v1h-1z",
    fill: "#804d2b"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1zm-15 2h1v1h-1z",
    fill: "#7f4e2e"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-2v-1z",
    fill: "#754624"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-2v-1h1z",
    fill: "#683819"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1zm9 4v-1h1v1z",
    fill: "#6e3e1e"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M82 70v-1h1v2h-1z",
    fill: "#613719"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1zm-6 1h-1v-1h1z",
    fill: "#855431"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1zm48 3h1v1h-1z",
    fill: "#734524"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1zm-2 2v-1h1v1z",
    fill: "#724423"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M51 70h1v1h-2v-1z",
    fill: "#6f4320"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1zm5 2v-1h1v1z",
    fill: "#613312"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1zm51 0h1v1h-1z",
    fill: "#784728"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-2h1z",
    fill: "#704221"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1zm3 1h1v1h-1z",
    fill: "#6e4120"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1zm34 4h-1v-1h1z",
    fill: "#6d3f1f"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1zm8 0h-1v-1h1z",
    fill: "#653818"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1zm19 0v-1h1v1z",
    fill: "#663718"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h2v1z",
    fill: "#643818"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1zm11 5h-1v-1h1z",
    fill: "#5c3112"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1zm6 6v1h-1v-1z",
    fill: "#532a0f"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1zm3 6v-1h1v1z",
    fill: "#5f3518"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1zm-3 1h-1v-1h1z",
    fill: "#7e4f2e"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72v1h-1v-1zm1 0h1v1h-1z",
    fill: "#7c4d2d"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1zm-9 1h1v1h-1z",
    fill: "#714325"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1zm-4 3h-1v-1h1z",
    fill: "#683b1d"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1zm-7 1h1v1h-1z",
    fill: "#6b3e1f"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1zm-19 4v1h-1v-1z",
    fill: "#65381a"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1zm-12 3v1h-1v-1z",
    fill: "#66391b"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1zm-18 4v-1h1v1z",
    fill: "#623518"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1zm1 0v-1h1v1z",
    fill: "#603517"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M34 73h2v1h-2z",
    fill: "#744625"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M44 73h1v1h-2v-1z",
    fill: "#6e4123"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#62361a"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1zm-9 2h-1v-1h1z",
    fill: "#613519"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1zm-9 3h-1v-1h1z",
    fill: "#5d3116"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#613212"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M97 74v-1h2v1h-1z",
    fill: "#835b40"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h2v1h-2z",
    fill: "#734527"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1zm6 0h1v1h-1z",
    fill: "#6c3f20"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h2v1h-2z",
    fill: "#6a3d1e"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1zm12 1h-1v-1h1z",
    fill: "#603316"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-2v-1h2z",
    fill: "#5e3114"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1zm-12 4h1v1h-1z",
    fill: "#592f13"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h-1v-1h1zm0 6h-1v-1h1z",
    fill: "#f8ce99"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h2v1z",
    fill: "#6b3e20"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1zm-7 3v1h-1v-1z",
    fill: "#683b1e"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75v1h-2v-1h1z",
    fill: "#5b3015"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#5e3317"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76v-1h2v1h-1z",
    fill: "#5b3014"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1zm12 1v-1h1v1z",
    fill: "#5a2f13"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1zm1 0h1v1h-1z",
    fill: "#66381e"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1zm-3 1v1h-1v-1z",
    fill: "#65371d"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1zm-10 1v1h-1v-1z",
    fill: "#62381b"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#5d3518"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1zm-15 4v-1h1v1z",
    fill: "#5f361a"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h1v1h-2v-1z",
    fill: "#5b3216"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1zm-19 3v1h-1v-1z",
    fill: "#5b3217"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1zm-29 7v1h-1v-1z",
    fill: "#562d15"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1zm-2 5h-1v-1h1z",
    fill: "#532b12"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v2h-1v-1z",
    fill: "#4a230d"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77v-1h1v1zm1 28v-1h1v1z",
    fill: "#cfa06c"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M103 77h-1v-1h1zm-2 22v1h-1v-1z",
    fill: "#d4a570"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h-1v-1h1zm-39 27v-1h1v1z",
    fill: "#ddab72"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v1h-1v-1zm8 9h-1v-1h1z",
    fill: "#f2c68f"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1zm-5 1v-1h1v1z",
    fill: "#64381b"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1zm6 1v1h-1v-1z",
    fill: "#572e15"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77v1h-1v-1zm-46 35v1h-1v-1z",
    fill: "#e7b980"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M101 78h-1v-1h1zm0 22h1v1h-1z",
    fill: "#d5a672"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M103 78v-1h1v1zm-5 2h1v1h-1z",
    fill: "#dbac77"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h-1v-2h1v1z",
    fill: "#fbd19c"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v-1h1v1zm0 3v-1h1v1z",
    fill: "#f3ca94"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78h1v1h-1zm0 4v-1h1v1z",
    fill: "#f4cb95"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M39 80h-1v-2h1v1z",
    fill: "#65391d"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1zm2 0h1v1h-1z",
    fill: "#5e331a"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#5f351c"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1zm-11 4h-1v-1h1z",
    fill: "#5a2f16"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1zm3 0v1h-1v-1z",
    fill: "#5a3014"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1zm4 0h-1v-1h1z",
    fill: "#582d14"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h2v1h-1z",
    fill: "#552b12"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78h1v1h-1zm-3 1h1v1h-1z",
    fill: "#c7965e"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1zm-3 7v-1h1v1z",
    fill: "#f0c690"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#5d331a"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#552d12"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1zm-14 5h-1v-1h1z",
    fill: "#572f14"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v-1h1v1zm4 3v1h-1v-1z",
    fill: "#dbab73"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80h-1v-1h1zm4 27h-1v-1h1z",
    fill: "#cf9f67"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M95 80h-1v-1h1zm0 13v1h-1v-1z",
    fill: "#d5a56f"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M99 79v1h-1v-1zm4 10v1h-1v-1z",
    fill: "#d8a974"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1zm2 0v-1h1v1z",
    fill: "#5e361b"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h2v1z",
    fill: "#563015"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1zm-4 1h-1v-1h1z",
    fill: "#573016"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-2v-1h2z",
    fill: "#532b11"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80v1h-1v-1zm-8 26h1v1h-1z",
    fill: "#cc9a61"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1zm5 6v-1h1v1z",
    fill: "#f2c78f"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1zm0 0v1h-1v-1z",
    fill: "#5a3218"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M59 81h1v1h-2v-1z",
    fill: "#512b13"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1zm-15 2v-1h1v1z",
    fill: "#522d13"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1zm11 23h-1v-1h1z",
    fill: "#ce9d65"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M87 82h-1v-1h1zm11 24h-1v-1h1z",
    fill: "#d6a36b"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M90 81v1h-2v-1h1z",
    fill: "#d6a36c"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v-1h1v1zm6 12v1h-1v-1z",
    fill: "#d8a870"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1zm5 5v-1h1v1z",
    fill: "#f3c891"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1zm7 3v1h-1v-1z",
    fill: "#f3c88f"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1zm5 15v-1h1v1z",
    fill: "#eec48c"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1zm1-1h1v1h-1z",
    fill: "#532e14"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h2v1h-2z",
    fill: "#502b10"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M86 82v1h-1v-1zm13 22h-1v-1h1z",
    fill: "#d3a16a"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M89 83h-1v-1h1zM52 93h1v1h-1z",
    fill: "#d3a169"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1zm1 6v1h-1v-1z",
    fill: "#eec58d"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1zm12 12h-1v-1h1z",
    fill: "#f1c78e"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h-1v-1h2v1z",
    fill: "#4d290f"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M76 83v1h-1v-1zm-27 26h1v1h-1z",
    fill: "#cd9c62"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1zm-24 25h1v1h-1z",
    fill: "#ce9d63"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M99 84v1h-1v-2h1z",
    fill: "#d9aa75"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83v1h-1v-1zm1 12v-1h1v1z",
    fill: "#d8a976"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M32 86h-1v-2h1v1z",
    fill: "#efc58c"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1zm1 4v-1h1v1z",
    fill: "#efc48e"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1zm-7 2h-1v-1h1z",
    fill: "#f3c991"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1zm-4 1h1v1h-1z",
    fill: "#4b2810"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-1zm-8 4h-1v-1h1z",
    fill: "#49260e"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1zm-3 2v-1h1v1z",
    fill: "#522e17"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1zm-27 32h-1v-1h1z",
    fill: "#e1b279"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M91 85v1h-1v-2h1z",
    fill: "#deae76"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87v-2h1v2z",
    fill: "#efc68f"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M30 85v1h-1v-1zm-4 5h1v1h-1z",
    fill: "#eec38e"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1zm0 1v-1h1v1z",
    fill: "#f1c68f"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1zm-4 2h-1v-1h1z",
    fill: "#4a2710"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1zm-20 34h-1v-1h1z",
    fill: "#d3a267"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1zm3 25v1h-1v-1z",
    fill: "#d5a56c"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M98 86h-1v-1h1zm0 6h1v1h-1z",
    fill: "#dcad76"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87v-1h1v1zm5 7v-1h1v1z",
    fill: "#edc38b"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#f3ca8f"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h1v1h-1zm3 0v1h-1v-1z",
    fill: "#4d280f"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M102 86h1v2h-1v-1z",
    fill: "#daab76"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-2v-1h1z",
    fill: "#49270d"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1zm-9 3h1v1h-1z",
    fill: "#edc28c"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1zm1 2v-1h1v1z",
    fill: "#f0c68b"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1zm-8 22v-1h1v1z",
    fill: "#cd9b62"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M90 89v-1h1v2h-1z",
    fill: "#dfb078"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1zm0 1v-1h1v1z",
    fill: "#eabf88"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1zm-1 3v-1h1v1z",
    fill: "#ebc089"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1zm40 13v1h-1v-1z",
    fill: "#d3a26c"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1zm14 15h-1v-1h1z",
    fill: "#efc289"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1zm4 4v-1h1v1z",
    fill: "#edc289"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1zm-1 9v-1h1v1z",
    fill: "#f1c78c"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h1v1h-1zm16 13v-1h1v1z",
    fill: "#d7a66d"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M95 90v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#d8a872"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h-1v-2h1v1z",
    fill: "#ecc18c"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1zm14 11h-1v-1h1z",
    fill: "#f0c389"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1zm3 19h-1v-1h1z",
    fill: "#d09e65"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h-1v-1h1zm0 7h-1v-1h1z",
    fill: "#daaa77"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1zm4 2v-1h1v1z",
    fill: "#efc48c"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1zm27 20h1v1h-1z",
    fill: "#d9a56b"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1zm45 14h-1v-1h1z",
    fill: "#d7a369"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1zm26 17v1h-1v-1z",
    fill: "#d2a166"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93h1v1h-1zm0 6v-1h1v1z",
    fill: "#ebbf89"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M27 95h-1v-2h1v1z",
    fill: "#ebc08b"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1zm3 2h1v1h-1z",
    fill: "#e0af75"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M29 94h1v1h-1zm2 4h-1v-1h1z",
    fill: "#f2cfa5"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1zm8 7h-1v-1h1z",
    fill: "#efcda3"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-2h1v2z",
    fill: "#efcda2"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1zm1 1v1h-1v-1z",
    fill: "#f4c88d"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94h1v1h-2v-1z",
    fill: "#d7a76f"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h-1v-1h1zm0 4v-1h1v1z",
    fill: "#d8a971"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h-1v-1h1zm-1 3h1v1h-1z",
    fill: "#e9bd87"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M27 97h-1v-2h1v1z",
    fill: "#e9be89"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1zm1 1v1h-1v-1z",
    fill: "#ecc392"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1zm5 6v1h-1v-1z",
    fill: "#f1cea4"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97h-1v-2h1v1z",
    fill: "#f2c58a"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M103 96h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#dbaa78"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1zm4 2v1h-1v-1z",
    fill: "#ebc99f"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97v-1h1v1zm1 3v-1h1v1z",
    fill: "#d6a673"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1zm-1 3v1h-1v-1z",
    fill: "#edcaa0"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1zm3 12h1v1h-1z",
    fill: "#eac79e"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98v1h-2v-1h1z",
    fill: "#e5ba85"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M30 98v1h-1v-1zm0 2v-1h1v1z",
    fill: "#f2d1a6"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100h-1v-1h1zm6 3v-1h1v1z",
    fill: "#f1cfa4"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1zm1 5h-1v-1h1z",
    fill: "#f4cfa9"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99v1h-1v-1zm47 4v-1h1v1z",
    fill: "#d6a46b"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M82 99v2h-1v-2z",
    fill: "#dbaa71"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M26 102v-2h1v2z",
    fill: "#e7bc87"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M28 101v-1h1v2h-1z",
    fill: "#e5bc8b"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#f8d3ad"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100v1h-2v-1h1z",
    fill: "#ebc187"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1zm1 2h1v1h-1z",
    fill: "#f0c388"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1zm1 10v1h-1v-1z",
    fill: "#e7b87d"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v1h-1v-2h1z",
    fill: "#efc792"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102h1v1h-1zm-3 5h1v1h-1z",
    fill: "#eec99f"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1zm4-1v1h-1v-1z",
    fill: "#eec389"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M103 103h-1v-1h1zm-34 12h1v1h-1z",
    fill: "#d1a06b"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#edc79f"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1zm-2 3v1h-1v-1z",
    fill: "#eec187"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1zm1 1v-1h1v1z",
    fill: "#eec188"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1zm-4 2v-1h1v1z",
    fill: "#dcaa70"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h-1v-1h1zm28 1v-1h1v1z",
    fill: "#d8a66c"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#ecc28f"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1zm-3 2v-1h1v1z",
    fill: "#daa86f"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106v1h-1v-1zm-17 6v-1h1v1z",
    fill: "#d1a169"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1zm0 1v-1h1v1z",
    fill: "#eabd85"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h-1v-2h1v1z",
    fill: "#ecbf85"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1zm1 5h-1v-1h1z",
    fill: "#e7b77d"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h1v1h-2v-1z",
    fill: "#d09d64"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1zm-2 12v-1h1v1z",
    fill: "#e6b77c"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1zm2 2h-1v-1h1z",
    fill: "#eabd82"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1zm0 3h1v1h-1z",
    fill: "#e5b67b"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1zm-18 7h1v1h-1z",
    fill: "#ce9c61"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110h-1v-1h1zm-18 2h1v1h-1z",
    fill: "#d7a56a"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111h-1v-1h1zm-15 6h-1v-1h1z",
    fill: "#d09e64"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v-1h1v1zm0 5v-1h1v1z",
    fill: "#d5a268"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M42 112h-1v-1h1zm2 2h-1v-1h1z",
    fill: "#e6b77f"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-2h1v1z",
    fill: "#e7b880"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h1v1h-1zm-1 4v-1h1v1z",
    fill: "#e8ba7f"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112h1v1h-1zm0 2h1v1h-1z",
    fill: "#eabc81"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114h-1v-1h1zm-16 6v1h-1v-1z",
    fill: "#d3a266"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M45 116h-1v-1h1zm1-1h1v1h-1z",
    fill: "#e9b87e"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M51 115v1h-1v-1zm-3 6h1v1h-1z",
    fill: "#d2a064"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M57 117h1v1h-1zm-3 2v-1h1v1z",
    fill: "#cd9b60"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M50 118h1v1h-2v-1z",
    fill: "#d3a165"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#dfdfbf",
    fillOpacity: 0.031
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#c0a788",
    fillOpacity: 0.161
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#ad997f",
    fillOpacity: 0.196
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#ffc",
    fillOpacity: 0.02
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#c7a787",
    fillOpacity: 0.125
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#b79576",
    fillOpacity: 0.322
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#b78f6a",
    fillOpacity: 0.573
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#bb8f64",
    fillOpacity: 0.8
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#bf9263",
    fillOpacity: 0.949
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#b98d63",
    fillOpacity: 0.937
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#b1916d",
    fillOpacity: 0.22
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40h1v1h-1z",
    fill: "#b6a388",
    fillOpacity: 0.11
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#c49972",
    fillOpacity: 0.894
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#c89668",
    fillOpacity: 0.984
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#bb9670",
    fillOpacity: 0.651
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#af9a7f",
    fillOpacity: 0.188
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#b6a37f",
    fillOpacity: 0.11
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#b2956f",
    fillOpacity: 0.314
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#b89369",
    fillOpacity: 0.557
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#bd9065",
    fillOpacity: 0.78
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#bd8c5f",
    fillOpacity: 0.925
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#be8c5e"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#c48e5e"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#c78f59"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#c39362"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#cc9764"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#b6885b",
    fillOpacity: 0.631
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#c59c77",
    fillOpacity: 0.537
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#d09f6f"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#cc9868"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#c1956b",
    fillOpacity: 0.937
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#b49271",
    fillOpacity: 0.58
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#ae9a86",
    fillOpacity: 0.149
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#b6aa91",
    fillOpacity: 0.082
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#b29472",
    fillOpacity: 0.263
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#b49169",
    fillOpacity: 0.494
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#b88f5e",
    fillOpacity: 0.733
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#be915d",
    fillOpacity: 0.91
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#c2935d"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#c58f56"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#c8905a"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#bf8855"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#c1915f"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#cb935e"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#c08d5d",
    fillOpacity: 0.937
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#b59977",
    fillOpacity: 0.176
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M88 43h-1v-1h1z",
    fill: "#bfa27f",
    fillOpacity: 0.173
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42h1v1h-1z",
    fill: "#cc9d70",
    fillOpacity: 0.929
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#ce9d6e"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#c79b6b"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#c8976d"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#c1956c",
    fillOpacity: 0.906
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#bd9a72",
    fillOpacity: 0.506
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#ada38e",
    fillOpacity: 0.098
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#b4a596",
    fillOpacity: 0.067
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#b69472",
    fillOpacity: 0.235
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#b88d64",
    fillOpacity: 0.467
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#b8895d",
    fillOpacity: 0.698
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#bb8c5d",
    fillOpacity: 0.878
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#bc8d5a",
    fillOpacity: 0.992
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#c6905c"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#cc9563"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#c48e5d"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#c69060"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#c48e5a"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#c5925b"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#ce9863"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#bc8e64",
    fillOpacity: 0.616
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#c79d72",
    fillOpacity: 0.647
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#d29f6c"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#cb9b6c"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#c79866"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#cd9865"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#c89a6a"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#bd9671",
    fillOpacity: 0.855
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#b69373",
    fillOpacity: 0.4
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#b9a2a2",
    fillOpacity: 0.043
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#b98",
    fillOpacity: 0.059
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#b3926c",
    fillOpacity: 0.212
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#ba8f66",
    fillOpacity: 0.439
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#bb9061",
    fillOpacity: 0.667
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#ba8e60",
    fillOpacity: 0.859
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#bb8c5b",
    fillOpacity: 0.984
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#c6905b"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#c78c56"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#c78d57"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#c38b57"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#bf8b58"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#be8b56"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#c19058"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#c79259"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#c29059"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#c69258"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#c3915b"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45h-1v-1h1z",
    fill: "#c59461"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#c08c5c",
    fillOpacity: 0.941
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#b38b6e",
    fillOpacity: 0.173
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#c09e7d",
    fillOpacity: 0.271
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#cc9d6f",
    fillOpacity: 0.973
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1z",
    fill: "#c7996b"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#cd9b6b"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#cc9865"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#ca9966"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#c89768"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#c89869"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#cf9b68"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#c69769"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#ba9266",
    fillOpacity: 0.784
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#b5966e",
    fillOpacity: 0.325
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#b9b9a2",
    fillOpacity: 0.043
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#b19574",
    fillOpacity: 0.18
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#b08e69",
    fillOpacity: 0.408
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#b7895e",
    fillOpacity: 0.655
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#bb8b5f",
    fillOpacity: 0.847
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#ba885a",
    fillOpacity: 0.976
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#c48d5a"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#cb945c"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#c58f58"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#c18b58"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#c38f58"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#c99260"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#b98e69",
    fillOpacity: 0.561
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#b9a273",
    fillOpacity: 0.043
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#ca9b72",
    fillOpacity: 0.776
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h-1v-1h1z",
    fill: "#d09c6e"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1z",
    fill: "#c9976a"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#cb9869"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#cd9a69"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#c89766"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#ca9968"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#cb9969"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#cb9867"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#c49565",
    fillOpacity: 0.992
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45v1h-1v-1z",
    fill: "#bf986f",
    fillOpacity: 0.69
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46h-1v-1h1z",
    fill: "#b19b79",
    fillOpacity: 0.231
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#aaa",
    fillOpacity: 0.035
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#bc9d7f",
    fillOpacity: 0.165
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#b4946c",
    fillOpacity: 0.376
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#b98f62",
    fillOpacity: 0.62
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#b78c5d",
    fillOpacity: 0.824
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#bb8c59",
    fillOpacity: 0.957
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#c58f5a"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#c9915d"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#be9065",
    fillOpacity: 0.918
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#b39e82",
    fillOpacity: 0.145
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#bc9877",
    fillOpacity: 0.42
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#d09d71"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46v1h-1v-1z",
    fill: "#cb986a"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#cb9769"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#ca946a"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46v1h-1v-1z",
    fill: "#ce9466"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M100 47v-1h1v1z",
    fill: "#d39c67"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v-1h1v1z",
    fill: "#c29663",
    fillOpacity: 0.961
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M103 47h-1v-1h1z",
    fill: "#bd996a",
    fillOpacity: 0.608
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M103 46h1v1h-1z",
    fill: "#b49576",
    fillOpacity: 0.161
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#bfbfff",
    fillOpacity: 0.016
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#ac967f",
    fillOpacity: 0.133
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#ac8c69",
    fillOpacity: 0.341
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#b48e60",
    fillOpacity: 0.588
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#b88d61",
    fillOpacity: 0.808
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#bd8e5f",
    fillOpacity: 0.949
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#c38d5c"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#c7915c"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#c8925c"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#c18953"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#cc9560"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#bd956d",
    fillOpacity: 0.549
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#bba17f",
    fillOpacity: 0.118
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#c4966c",
    fillOpacity: 0.886
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#c69363"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#c29361"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48h-1v-1h1z",
    fill: "#c89765"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v1h-1v-1z",
    fill: "#cc9767"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48v-1h1v1z",
    fill: "#cc9669"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47h1v1h-1z",
    fill: "#c9966b"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M103 48v-1h1v1z",
    fill: "#be9368",
    fillOpacity: 0.918
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M104 48v-1h1v1z",
    fill: "#b99a71",
    fillOpacity: 0.545
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M106 47v1h-1v-1z",
    fill: "#b19a83",
    fillOpacity: 0.129
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#c6aaaa",
    fillOpacity: 0.035
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#b79675",
    fillOpacity: 0.153
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#b18b61",
    fillOpacity: 0.337
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#b5865b",
    fillOpacity: 0.557
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#b7885d",
    fillOpacity: 0.769
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#bd8c5e",
    fillOpacity: 0.925
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#bd8a58"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#c59059"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#c18a56"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#be8952"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#c18e59"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#bb8b5d",
    fillOpacity: 0.906
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#b2a17f",
    fillOpacity: 0.118
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#b9926e",
    fillOpacity: 0.573
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49v-1h1v1z",
    fill: "#cb9a6b"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h-1v-1h1z",
    fill: "#c18f5e"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M105 48v1h-1v-1z",
    fill: "#cc9a6c"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M105 49v-1h1v1z",
    fill: "#c1956e",
    fillOpacity: 0.894
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48v1h-1v-1z",
    fill: "#b89574",
    fillOpacity: 0.514
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h1v1h-1z",
    fill: "#ada391",
    fillOpacity: 0.11
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#a59678",
    fillOpacity: 0.067
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1z",
    fill: "#b4916e",
    fillOpacity: 0.2
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#b18a63",
    fillOpacity: 0.412
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#b6895d",
    fillOpacity: 0.62
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1z",
    fill: "#b3865b",
    fillOpacity: 0.812
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v1h-1v-1z",
    fill: "#b7885b",
    fillOpacity: 0.941
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#bd8a59"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#c28854"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#c08652"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#c18752"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#c68c57"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#bd8953"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#c28a54"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#c7905a"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#c08a53"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#c18b54"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#c28c56"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#c28b58"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#bf8858"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#b18b63",
    fillOpacity: 0.502
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#b69e81",
    fillOpacity: 0.208
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#c0986f",
    fillOpacity: 0.953
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#c3925f"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#cc9867"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49v1h-1v-1z",
    fill: "#c79663"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M104 50v-1h1v1z",
    fill: "#ca9567"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M106 50v-1h1v1z",
    fill: "#c9996c"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M108 49v1h-1v-1z",
    fill: "#bb926b",
    fillOpacity: 0.875
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50h-1v-1h1z",
    fill: "#b89671",
    fillOpacity: 0.467
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v-1h1v1z",
    fill: "#bfa599",
    fillOpacity: 0.078
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#ba9c89",
    fillOpacity: 0.102
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1z",
    fill: "#bb9270",
    fillOpacity: 0.267
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#ba8960",
    fillOpacity: 0.478
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M26 50v1h-1v-1z",
    fill: "#bc8a5b",
    fillOpacity: 0.702
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#bc8a58",
    fillOpacity: 0.855
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#be8856",
    fillOpacity: 0.969
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#c18b5b"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#c38c5c"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#bf8653"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#bf8957"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#c68b57"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#b98b5e",
    fillOpacity: 0.886
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#b39784",
    fillOpacity: 0.106
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#aff",
    fillOpacity: 0.012
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#be9873",
    fillOpacity: 0.694
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#c29261"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#c49362"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#cc9968"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50v1h-1v-1z",
    fill: "#c99867"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50h1v1h-1z",
    fill: "#c79365"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h-1v-1h1z",
    fill: "#c69364"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M108 51h-1v-1h1z",
    fill: "#cc9761"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v1h-1v-1z",
    fill: "#c89865"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M110 51h-1v-1h1z",
    fill: "#bb936a",
    fillOpacity: 0.839
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M111 51h-1v-1h1z",
    fill: "#b89977",
    fillOpacity: 0.412
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50h1v1h-1z",
    fill: "#9c9c9c",
    fillOpacity: 0.051
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#c6aa9b",
    fillOpacity: 0.071
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#b69475",
    fillOpacity: 0.263
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51v1h-1v-1z",
    fill: "#b98a64",
    fillOpacity: 0.506
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#bc8c61",
    fillOpacity: 0.741
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#bc8c5e",
    fillOpacity: 0.898
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#b98754",
    fillOpacity: 0.996
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#c68e59"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#c08b5a"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#c28f58"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#c28e59"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#c58f5d"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#bf8753"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#bc8752"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#c18750"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#b58f69",
    fillOpacity: 0.475
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#ad9779",
    fillOpacity: 0.329
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#c29368",
    fillOpacity: 0.988
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#c88c55"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#c28f60"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#c59363"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1z",
    fill: "#cc9a68"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M103 52v-1h1v1z",
    fill: "#c79465"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51v1h-1v-1z",
    fill: "#c69666"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M107 52v-1h1v1z",
    fill: "#c49462"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52h-1v-1h1z",
    fill: "#c5935f"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M110 52h-1v-1h1z",
    fill: "#c59562"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M111 52h-1v-1h1z",
    fill: "#c69865"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v1h-1v-1z",
    fill: "#bf9568",
    fillOpacity: 0.788
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h-1v-1h1z",
    fill: "#b29677",
    fillOpacity: 0.325
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53v-1h1v1z",
    fill: "#91916d",
    fillOpacity: 0.027
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M16 52h1v1h-1z",
    fill: "#ba966f",
    fillOpacity: 0.333
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53v-1h1v1z",
    fill: "#b78f64",
    fillOpacity: 0.647
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#b78b5d",
    fillOpacity: 0.863
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53v-1h1v1z",
    fill: "#ba8858",
    fillOpacity: 0.996
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1z",
    fill: "#c68e58"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#c78f57"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#c08a56"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#c18f5f"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#c2905e"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#bf8c56"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#c08d58"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#c08856"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#bf8854"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#c8915b"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#ba824e"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#b9864f"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#bb854e"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#c58958"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#b58963",
    fillOpacity: 0.871
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#ada296",
    fillOpacity: 0.086
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#b89b7f",
    fillOpacity: 0.071
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#b88e66",
    fillOpacity: 0.839
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#c38a59"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#c18a5a"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#be8b5b"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#c08e5d"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M102 52h1v1h-1z",
    fill: "#cd9a6a"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M103 53v-1h1v1z",
    fill: "#c89566"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53h-1v-1h1z",
    fill: "#c89466"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53h-1v-1h1z",
    fill: "#c49264"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52v1h-1v-1z",
    fill: "#c39063"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M109 53v-1h1v1z",
    fill: "#c39162"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h-1v-1h1z",
    fill: "#ca9661"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M112 52h1v1h-1z",
    fill: "#c49664",
    fillOpacity: 0.992
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h1v1h-1z",
    fill: "#be966c",
    fillOpacity: 0.698
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M114 52h1v1h-1z",
    fill: "#b99779",
    fillOpacity: 0.231
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54v-1h1v1z",
    fill: "#a68268",
    fillOpacity: 0.192
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M17 54h-1v-1h1z",
    fill: "#b98d5c",
    fillOpacity: 0.984
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53h1v1h-1z",
    fill: "#c8905c"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1z",
    fill: "#c18f58"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53h1v1h-1z",
    fill: "#bf8b50"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#c48c55"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#c6925c"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#c28f59"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#b6804b"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#b7804c"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#c38d5e"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#b79070",
    fillOpacity: 0.463
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#b18e6a",
    fillOpacity: 0.506
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#c68f5f"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#c0895a"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#bf8859"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#c08859"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#bd8856"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#c08d5b"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#c99564"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53v1h-1v-1z",
    fill: "#c96"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h-1v-1h1z",
    fill: "#cc9969"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54h-1v-1h1z",
    fill: "#c79463"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53v1h-1v-1z",
    fill: "#c29161"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h1v1h-1z",
    fill: "#c79560"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53v1h-1v-1z",
    fill: "#ce9962"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53h1v1h-1z",
    fill: "#bc936a",
    fillOpacity: 0.937
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54h-1v-1h1z",
    fill: "#9b7f69",
    fillOpacity: 0.18
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54v1h-1v-1z",
    fill: "#785a3c",
    fillOpacity: 0.067
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54h1v1h-1z",
    fill: "#b08455",
    fillOpacity: 0.82
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54v1h-1v-1z",
    fill: "#ca9059"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1z",
    fill: "#c48a54"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#c58e55"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v1z",
    fill: "#c58e57"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#c8935d"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#c4915a"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#b9804d"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#c18652"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#b48862",
    fillOpacity: 0.855
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#bbbbae",
    fillOpacity: 0.075
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#b19b85",
    fillOpacity: 0.18
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#b88b5e",
    fillOpacity: 0.933
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#bd8454"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#ba8253"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#bd8656"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#c18c5a"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1z",
    fill: "#c08b59"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#ca9563"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h-1v-1h1z",
    fill: "#c59360"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54h1v1h-1z",
    fill: "#c69563"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M113 54v1h-1v-1z",
    fill: "#c79462"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55h-1v-1h1z",
    fill: "#cd9661"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M114 54h1v1h-1z",
    fill: "#b78d66",
    fillOpacity: 0.839
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54v1h-1v-1z",
    fill: "#6e4d42",
    fillOpacity: 0.09
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55v1h-1v-1z",
    fill: "#b89069",
    fillOpacity: 0.38
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v-1h1v1z",
    fill: "#c48b50"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#c7945d"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#c6945c"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#bc854d"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#b67f49"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#bc824e"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#b98456"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#af9071",
    fillOpacity: 0.416
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#af8b66",
    fillOpacity: 0.702
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#c38953"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#be8654"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#bd8654"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h1v1h-1z",
    fill: "#c99763"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h1v1h-1z",
    fill: "#ce9c6b"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55h1v1h-1z",
    fill: "#cb9561"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55v1h-1v-1z",
    fill: "#cb986a",
    fillOpacity: 0.984
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v-1h1v1z",
    fill: "#9b7657",
    fillOpacity: 0.322
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57v-1h1v1z",
    fill: "#796d55",
    fillOpacity: 0.082
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v1h-1v-1z",
    fill: "#b58c58",
    fillOpacity: 0.882
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M18 57v-1h1v1z",
    fill: "#cb9359"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M20 56v1h-1v-1z",
    fill: "#c6915e"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57v-1h1v1z",
    fill: "#c58e53"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#c8945d"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#c4925b"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#c6905a"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#bd864e"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#b7804b"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#b17946"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#bc814e"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#af855f",
    fillOpacity: 0.788
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#dadada",
    fillOpacity: 0.027
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#b29374",
    fillOpacity: 0.353
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#b78353",
    fillOpacity: 0.996
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#b9814d"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#b9824f"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56h1v1h-1z",
    fill: "#ce9d69"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M110 56h1v1h-1z",
    fill: "#cd9a67"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M112 57v-1h1v1z",
    fill: "#d29b6b"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v1h-1v-1z",
    fill: "#ab805c",
    fillOpacity: 0.682
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M17 58v-1h1v1z",
    fill: "#916f4c",
    fillOpacity: 0.576
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M19 57v1h-1v-1z",
    fill: "#cb9660"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58h-1v-1h1z",
    fill: "#c69159"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57h1v1h-1z",
    fill: "#c8945c"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#be8852"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#c7935c"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#c28d55"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#b8814b"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#b9824b"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#ba814f"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#b87f4c"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#b37847"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#b27747"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#b27849"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#b07742"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#ac7c4f",
    fillOpacity: 0.992
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#ac9272",
    fillOpacity: 0.341
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#99907f",
    fillOpacity: 0.118
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#af8763",
    fillOpacity: 0.831
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#ba7f49"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#b07d4c"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#b47f4e"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#bb8551"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#c18b56"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#c38c59"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1z",
    fill: "#c68f5c"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58h-1v-1h1z",
    fill: "#cb9866"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M101 57v1h-1v-1z",
    fill: "#cf9b69"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M110 57v1h-1v-1z",
    fill: "#ce9b6a"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h-1v-1h1z",
    fill: "#bd8e66",
    fillOpacity: 0.953
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58v-1h1v1z",
    fill: "#84664e",
    fillOpacity: 0.204
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M18 59h-1v-1h1z",
    fill: "#5c4033",
    fillOpacity: 0.216
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M19 58v1h-1v-1z",
    fill: "#b6875d",
    fillOpacity: 0.965
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58v1h-1v-1z",
    fill: "#cb9357"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#c49158"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#bb854d"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#bb844c"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#b9824a"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#b57d46"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#b47a46"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#b17745"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#b67c4d"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#b27848"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#ba7c48"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#b0723f"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#9a6b45",
    fillOpacity: 0.906
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#7d583d",
    fillOpacity: 0.439
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#875e3e",
    fillOpacity: 0.773
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#96633a"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#ae7545"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#b67d49"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#b37845"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#b77d4a"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#ba834f"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#ba8550"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#c58c59"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#c6915c"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#c59260"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58v1h-1v-1z",
    fill: "#c69462"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M111 58v1h-1v-1z",
    fill: "#c89666"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59v-1h1v1z",
    fill: "#9a7251",
    fillOpacity: 0.576
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60h-1v-1h1z",
    fill: "#946b4d",
    fillOpacity: 0.753
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60h-1v-1h1z",
    fill: "#d0975f"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60v-1h1v1z",
    fill: "#c58e54"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#b57e49"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#b9814b"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#aa7242"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#a86f41"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#9a6338"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#8f5931"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#8e5228"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#824925"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#6d3a1a"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#8b522a"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#804f2b"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#7c4e2a"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#9f693f"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#b47645"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#b47745"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1z",
    fill: "#b67c4b"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#c68e5b"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#c6925f"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M109 59v1h-1v-1z",
    fill: "#c69564"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M111 60v-1h1v1z",
    fill: "#a47c58",
    fillOpacity: 0.875
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h1v1h-1z",
    fill: "#6d5136",
    fillOpacity: 0.11
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M11 60v1h-1v-1z",
    fill: "#c5c5ad",
    fillOpacity: 0.086
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M11 61v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60v1h-1v-1z",
    fill: "#724d35",
    fillOpacity: 0.412
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61h-1v-1h1z",
    fill: "#bf8c5c"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61h-1v-1h1z",
    fill: "#c59156"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61v-1h1v1z",
    fill: "#c58d55"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61v-1h1v1z",
    fill: "#c48d54"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#c18951"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#c68e56"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#ca935b"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#b67d4e"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#ab7148"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#9f673e"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61h-1v-1h1z",
    fill: "#8f582e"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#885128"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#87502a"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#89532d"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#87532c"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#89522d"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#603014"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#864f2d"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#87522f"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#764522"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#724321"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#955e39"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#ae754c"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1z",
    fill: "#b4794c"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h-1v-1h1z",
    fill: "#ba7f4f"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#c69261"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#ca9665"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M107 61h-1v-1h1z",
    fill: "#cd9b69"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60v1h-1v-1z",
    fill: "#c49160"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M110 61v-1h1v1z",
    fill: "#c79968"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M112 60v1h-1v-1z",
    fill: "#ac8d6c",
    fillOpacity: 0.388
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M10 62v-1h1v1z",
    fill: "#988b7c",
    fillOpacity: 0.467
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M12 62h-1v-1h1z",
    fill: "#856e59",
    fillOpacity: 0.725
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M13 62h-1v-1h1z",
    fill: "#b2907f",
    fillOpacity: 0.118
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M18 62v-1h1v1z",
    fill: "#51331e",
    fillOpacity: 0.098
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61v1h-1v-1z",
    fill: "#a37650",
    fillOpacity: 0.894
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62v-1h1v1z",
    fill: "#c99157"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1z",
    fill: "#c08854"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#c8925b"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#c28c55"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#c59057"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#c59058"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#c48e57"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#bb844d"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#bb834b"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#ba8350"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#b7804e"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1z",
    fill: "#b07a48"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#a36e3e"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#925b30"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#89522a"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#834b27"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#854d2a"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#89522e"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#88512d"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#88512e"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#854d29"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#844d23"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#7f4721"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#643312"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#582b10"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#7a4626"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#834a26"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#7c4421"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#7c4826"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#774624"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#734526"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1z",
    fill: "#a06a42"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#b87e50"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#c38b59"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#c79460"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#c89561"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1z",
    fill: "#ca9763"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M108 61h1v1h-1z",
    fill: "#c99163"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62h-1v-1h1z",
    fill: "#bf9669",
    fillOpacity: 0.757
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62v-1h1v1z",
    fill: "#dfbf9f",
    fillOpacity: 0.031
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M10 62h1v1h-1z",
    fill: "#f5e3da",
    fillOpacity: 0.11
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M11 62h1v1h-1z",
    fill: "#bfa591",
    fillOpacity: 0.831
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M12 63v-1h1v1z",
    fill: "#856e58",
    fillOpacity: 0.851
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M14 62v1h-1v-1z",
    fill: "#887663",
    fillOpacity: 0.212
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63h-1v-1h1z",
    fill: "#835c3a",
    fillOpacity: 0.616
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62h1v1h-1z",
    fill: "#cc945d"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M22 63h-1v-1h1z",
    fill: "#c18d52"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62h1v1h-1z",
    fill: "#bf8a52"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62v1h-1v-1z",
    fill: "#be8753"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h1v1h-1z",
    fill: "#c08955"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#bb8250"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1z",
    fill: "#bb8450"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#c49056"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#c28c52"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#bf884f"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#bd8753"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#b7814f"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#a76f41"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#9f673b"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#8f592e"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#85512a"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#854f2c"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#87512d"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1z",
    fill: "#824c28"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#834d29"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#814b27"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#7c4622"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#7a4521"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#77421e"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#78431e"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#603212"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#774524"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#794525"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#733e1e"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#7b4524"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#7f4e2b"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#5c341c"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#7e4b27"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#9c633a"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#b37a4e"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#bf8755"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#c8945f"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M99 62v1h-1v-1z",
    fill: "#c79461"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M106 63v-1h1v1z",
    fill: "#c79665"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M108 62h1v1h-1z",
    fill: "#ca915c"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62v1h-1v-1z",
    fill: "#cb9c72",
    fillOpacity: 0.969
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62h1v1h-1z",
    fill: "#c19c7b",
    fillOpacity: 0.243
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M12 64h-1v-1h1z",
    fill: "#fffff7",
    fillOpacity: 0.133
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64h-1v-1h1z",
    fill: "#d1bc9f",
    fillOpacity: 0.808
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64v-1h1v1z",
    fill: "#8f7961",
    fillOpacity: 0.925
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M15 64h-1v-1h1z",
    fill: "#847365",
    fillOpacity: 0.286
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63v1h-1v-1z",
    fill: "#66442d",
    fillOpacity: 0.263
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v-1h1v1z",
    fill: "#ae8153",
    fillOpacity: 0.984
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h-1v-1h1z",
    fill: "#bc874f"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64v-1h1v1z",
    fill: "#bd8453"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M25 63v1h-1v-1z",
    fill: "#bf8555"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64v-1h1v1z",
    fill: "#bb844f"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#bc8452"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#c08c53"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#b07d4a"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#a37140"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#8e5a2f"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#845029"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#814b26"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#8a522e"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#8c5633"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#85512f"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#7d4925"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1z",
    fill: "#784421"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1z",
    fill: "#794522"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#7c4725"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#76421f"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1z",
    fill: "#75401e"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#75411f"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#76431f"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#73401c"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#5c2f11"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#532a0e"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#794524"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#713c1c"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#794322"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#603822"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#875331"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#8f5630"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#8d5630"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#a26c43"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#b98455"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M97 63v1h-1v-1z",
    fill: "#c89560"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M107 63v1h-1v-1z",
    fill: "#c79467"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h1v1h-1z",
    fill: "#cc9a63"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63v1h-1v-1z",
    fill: "#c09c79",
    fillOpacity: 0.627
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64v1h-1v-1z",
    fill: "#ffffe0",
    fillOpacity: 0.098
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64h1v1h-1z",
    fill: "#e1ccb4",
    fillOpacity: 0.71
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M14 65v-1h1v1z",
    fill: "#a78f76",
    fillOpacity: 0.98
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M15 65v-1h1v1z",
    fill: "#877564",
    fillOpacity: 0.4
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v1h-1v-1z",
    fill: "#2a002a",
    fillOpacity: 0.024
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M20 65v-1h1v1z",
    fill: "#916843",
    fillOpacity: 0.769
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65h-1v-1h1z",
    fill: "#bb864f"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h1v1h-1z",
    fill: "#bf8550"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65h-1v-1h1z",
    fill: "#be8551"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M28 65h-1v-1h1z",
    fill: "#bf8751"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#b77f4b"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#bc8551"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#ba854f"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#c38c53"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#c08a59"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#b5804f"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#ab7648"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#9b663b"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#8c562e"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#7f4c25"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#7e4e27"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#804e2a"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#885431"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#7e4a28"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#784625"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#764424"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#764423"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#734120"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#744221"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#764422"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1z",
    fill: "#764421"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#73401d"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#764320"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#73411e"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#744321"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#6b3a18"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#54290c"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1z",
    fill: "#764222"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#6f3a1a"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#774020"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#7b482a"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#5f351f"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#7e4a29"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#8f5631"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#905a34"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#855029"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#905b32"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#ad784d"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#c4905b"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M99 64v1h-1v-1z",
    fill: "#c79360"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M108 64h1v1h-1z",
    fill: "#c4976e",
    fillOpacity: 0.941
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65v-1h1v1z",
    fill: "#9e826b",
    fillOpacity: 0.176
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M14 65v1h-1v-1z",
    fill: "#ffd",
    fillOpacity: 0.059
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M15 66h-1v-1h1z",
    fill: "#e8d3b6",
    fillOpacity: 0.62
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66h-1v-1h1z",
    fill: "#ab9578",
    fillOpacity: 0.996
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66v-1h1v1z",
    fill: "#82684e",
    fillOpacity: 0.573
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h-1v-1h1z",
    fill: "#796d61",
    fillOpacity: 0.082
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M21 65v1h-1v-1z",
    fill: "#71492e",
    fillOpacity: 0.369
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h-1v-1h1z",
    fill: "#b68157"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h-1v-1h1z",
    fill: "#bc8750"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M24 65h1v1h-1z",
    fill: "#c0874e"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65h1v1h-1z",
    fill: "#bb8452"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#b27c49"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#b8824f"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#b9844f"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#bd8853"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#c08c56"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#c18b57"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#c28d5e"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#b37e51"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#a56f45"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#905a31"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#825028"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#824f29"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#875330"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#7b4b28"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#784623"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1z",
    fill: "#754220"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#72401f"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#703f1e"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#724120"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#734121"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#713f1e"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#72411d"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#73421e"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#74431f"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#6f3e1b"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#4f2509"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#51280e"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#683515"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#6f3b1b"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#754628"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1z",
    fill: "#562e17"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1z",
    fill: "#764323"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#8a552f"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h1v1h-1z",
    fill: "#89542d"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#9c663c"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#bc8759"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#c6915f"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#c4915e"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65v1h-1v-1z",
    fill: "#c6935c"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M107 66v-1h1v1z",
    fill: "#d09d6b"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M109 66h-1v-1h1z",
    fill: "#aa8267",
    fillOpacity: 0.592
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67v-1h1v1z",
    fill: "#f7dfc0",
    fillOpacity: 0.541
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M16 67v-1h1v1z",
    fill: "#d9bc9b"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v1h-1v-1z",
    fill: "#9d8569",
    fillOpacity: 0.804
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h1v1h-1z",
    fill: "#736045",
    fillOpacity: 0.259
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M20 67v-1h1v1z",
    fillOpacity: 0.027
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M21 66h1v1h-1z",
    fill: "#956845",
    fillOpacity: 0.796
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h1v1h-1z",
    fill: "#c58b58"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67h-1v-1h1z",
    fill: "#b98450"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h1v1h-1z",
    fill: "#ba834b"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66v1h-1v-1z",
    fill: "#bb834e"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67h-1v-1h1z",
    fill: "#c08a55"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#bd8955"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#c28e57"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#c08d52"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#bc894f"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#c6925a"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#b98555"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#ab764a"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1z",
    fill: "#98633a"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#814d28"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#834e2c"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#885333"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#875431"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#85542f"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#7f4d29"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#784622"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#764521"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#764623"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#794825"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#784724"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#6c3b1a"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#6f3f1c"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#703f1d"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#6d3d1a"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#6e3d1a"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#6d3b1a"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#623417"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#4e250c"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#50270d"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#6c4123"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M86 67h-1v-1h1z",
    fill: "#784525"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67h-1v-1h1z",
    fill: "#804a29"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h1v1h-1z",
    fill: "#935e36"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#8d5830"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#ab7749"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67h-1v-1h1z",
    fill: "#bf8c59"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M99 67h-1v-1h1z",
    fill: "#c18d5c"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v1h-1v-1z",
    fill: "#c69262"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v1h-1v-1z",
    fill: "#c49060"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M107 67h-1v-1h1z",
    fill: "#c7925d"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66v1h-1v-1z",
    fill: "#bd8f67",
    fillOpacity: 0.91
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66h1v1h-1z",
    fill: "#745748",
    fillOpacity: 0.137
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67h1v1h-1z",
    fill: "#0ff",
    fillOpacity: 0.004
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67v1h-1v-1z",
    fill: "#f2dec0",
    fillOpacity: 0.498
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67h1v1h-1z",
    fill: "#efd2ab"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M18 67h1v1h-1z",
    fill: "#c2a078",
    fillOpacity: 0.969
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v-1h1v1z",
    fill: "#886f53",
    fillOpacity: 0.584
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M21 68h-1v-1h1z",
    fill: "#4a4a4a",
    fillOpacity: 0.094
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M21 67h1v1h-1z",
    fill: "#6a472a",
    fillOpacity: 0.349
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M22 67h1v1h-1z",
    fill: "#b17b4e"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67v1h-1v-1z",
    fill: "#b97f4c"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68h-1v-1h1z",
    fill: "#b88150"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M27 68h-1v-1h1z",
    fill: "#b9814e"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67v1h-1v-1z",
    fill: "#bb8451"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67v1h-1v-1z",
    fill: "#b47f4d"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h1v1h-1z",
    fill: "#b5804e"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1z",
    fill: "#ba8553"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#b88351"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#bb8553"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#bf8a58"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#bf8c53"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#c19157"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#bd8d57"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#b28051"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#9c6a3e"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#905c35"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#834f2a"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#824e2b"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#814c2a"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#86542f"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#85532f"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#83512f"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#814e2e"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M54 67h1v1h-1z",
    fill: "#774623"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#744320"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#72411f"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#764525"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#71401f"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#683717"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#693817"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#5f3316"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#663515"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#693e21"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68h-1v-1h1z",
    fill: "#764223"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67v1h-1v-1z",
    fill: "#794424"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68h-1v-1h1z",
    fill: "#7a4524"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67h1v1h-1z",
    fill: "#814d29"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M90 67v1h-1v-1z",
    fill: "#85512b"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h-1v-1h1z",
    fill: "#8f5a32"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#925d35"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M93 67v1h-1v-1z",
    fill: "#88532b"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#945e36"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#b88456"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M95 67h1v1h-1z",
    fill: "#c38e5e"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68v-1h1v1z",
    fill: "#c28e5d"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67v1h-1v-1z",
    fill: "#c38f5c"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M106 67h1v1h-1z",
    fill: "#c58f66"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M107 67h1v1h-1z",
    fill: "#8a6045",
    fillOpacity: 0.506
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M17 68h1v1h-1z",
    fill: "#ebd4b4",
    fillOpacity: 0.471
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v1h-1v-1z",
    fill: "#f5d5ad",
    fillOpacity: 0.992
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M20 68v1h-1v-1z",
    fill: "#eac9a0"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69v-1h1v1z",
    fill: "#9f8767",
    fillOpacity: 0.863
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69v-1h1v1z",
    fill: "#6a553f",
    fillOpacity: 0.424
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M23 69h-1v-1h1z",
    fill: "#966b47",
    fillOpacity: 0.867
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69h-1v-1h1z",
    fill: "#bd8151"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68v1h-1v-1z",
    fill: "#b57d4e"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h-1v-1h1z",
    fill: "#ba8251"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69h-1v-1h1z",
    fill: "#be8655"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69v-1h1v1z",
    fill: "#ba8150"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M28 69v-1h1v1z",
    fill: "#b7804f"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68v1h-1v-1z",
    fill: "#bb8653"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#b98352"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#b78152"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#bb8555"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#bc8657"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#be8958"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#bb8954"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#be8b59"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#ba8658"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#ab774c"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#84542f"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#7d4b2a"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#835030"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#875533"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#865433"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#7e4b2b"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#7c4b28"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#784725"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1z",
    fill: "#714321"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#6e3d1e"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#693819"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#653718"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#5e3418"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#48230c"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#643313"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#683616"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#693d20"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69h-1v-1h1z",
    fill: "#532e16"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M87 69h-1v-1h1z",
    fill: "#764324"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68v1h-1v-1z",
    fill: "#754222"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69v-1h1v1z",
    fill: "#794624"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69h-1v-1h1z",
    fill: "#7c4925"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M91 69h-1v-1h1z",
    fill: "#834d2a"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h1v1h-1z",
    fill: "#8c5532"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M93 69h-1v-1h1z",
    fill: "#945e3a"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#915a36"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68v1h-1v-1z",
    fill: "#8a542e"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69h-1v-1h1z",
    fill: "#a16b43"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M97 69h-1v-1h1z",
    fill: "#bc875a"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68v1h-1v-1z",
    fill: "#c38f5e"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68h1v1h-1z",
    fill: "#c08c5a"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69v-1h1v1z",
    fill: "#ca9468"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M107 68v1h-1v-1z",
    fill: "#aa7c5d",
    fillOpacity: 0.82
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M107 69v-1h1v1z",
    fill: "#43281a",
    fillOpacity: 0.075
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M115 69h-1v-1h1z",
    fill: "#8d8d8d",
    fillOpacity: 0.035
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M115 68h1v1h-1z",
    fill: "#aa9c8f",
    fillOpacity: 0.153
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M116 68h1v1h-1z",
    fill: "#ad9e93",
    fillOpacity: 0.196
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M19 69v1h-1v-1z",
    fill: "#e9d6b6",
    fillOpacity: 0.416
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M20 70h-1v-1h1z",
    fill: "#f0d0a7",
    fillOpacity: 0.973
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69h1v1h-1z",
    fill: "#fed5a5"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69h1v1h-1z",
    fill: "#bda383",
    fillOpacity: 0.973
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M22 69h1v1h-1z",
    fill: "#997b5d",
    fillOpacity: 0.953
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69v1h-1v-1z",
    fill: "#b88659"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70v-1h1v1z",
    fill: "#b77e4e"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70v-1h1v1z",
    fill: "#b87f4e"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70v-1h1v1z",
    fill: "#b98151"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#ba8654"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#ba8554"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#b88453"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#b78353"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#ba8558"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#b37f52"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#a16f42"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#97653a"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#86522d"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#7f4e2c"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#875634"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#81502e"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#774625"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#734323"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#714121"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#734322"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#703f20"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#6d3c1d"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#69391a"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#643415"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#623515"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#5a3015"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#462008"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#4c250e"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#643413"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#673716"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M83 69h1v1h-1z",
    fill: "#532d16"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M84 70v-1h1v1z",
    fill: "#6f3e1f"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h1v1h-1z",
    fill: "#723f20"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70h-1v-1h1z",
    fill: "#724021"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70v-1h1v1z",
    fill: "#724020"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69v1h-1v-1z",
    fill: "#794725"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70v-1h1v1z",
    fill: "#7d4929"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v-1h1v1z",
    fill: "#7f4b29"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#8c5833"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70v-1h1v1z",
    fill: "#915c3a"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M95 69h1v1h-1z",
    fill: "#8b5633"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M96 70v-1h1v1z",
    fill: "#915d35"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69v1h-1v-1z",
    fill: "#ac774d"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v-1h1v1z",
    fill: "#be8a5b"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M100 70h-1v-1h1z",
    fill: "#c08c5b"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M100 69h1v1h-1z",
    fill: "#c39060"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M102 70h-1v-1h1z",
    fill: "#c08e60"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M102 69h1v1h-1z",
    fill: "#be8d61"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M103 70v-1h1v1z",
    fill: "#c28f5d"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69h1v1h-1z",
    fill: "#bd8c64",
    fillOpacity: 0.988
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M106 70v-1h1v1z",
    fill: "#8a5c43",
    fillOpacity: 0.325
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70h-1v-1h1z",
    fill: "#a69b90",
    fillOpacity: 0.09
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M113 70h-1v-1h1z",
    fill: "#5f4939",
    fillOpacity: 0.314
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M113 69h1v1h-1z",
    fill: "#7d634d",
    fillOpacity: 0.58
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M115 69v1h-1v-1z",
    fill: "#78604a",
    fillOpacity: 0.843
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M116 69v1h-1v-1z",
    fill: "#806b57",
    fillOpacity: 0.847
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M117 70h-1v-1h1z",
    fill: "#b6a798",
    fillOpacity: 0.467
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M117 69h1v1h-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M19 70h1v1h-1z",
    fill: "#ebd4b5",
    fillOpacity: 0.353
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71v-1h1v1z",
    fill: "#f0d1a4",
    fillOpacity: 0.925
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71v-1h1v1z",
    fill: "#fbd9a6"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M22 70h1v1h-1z",
    fill: "#d8b891"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M24 71h-1v-1h1z",
    fill: "#a57e5c"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70h1v1h-1z",
    fill: "#ab7d58"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70h1v1h-1z",
    fill: "#b58155"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70v1h-1v-1z",
    fill: "#b27e4b"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v-1h1v1z",
    fill: "#b17e4d"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h-1v-1h1z",
    fill: "#b27f4e"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#b98556"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#ba8659"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#b78557"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#a67546"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#96663a"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#86552e"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#855330"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#875532"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#885633"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#84522f"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#81502f"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1z",
    fill: "#814f2f"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#7e4d2c"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#7d4c2b"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#794a2a"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h1z",
    fill: "#764827"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#6f4321"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v1h-1v-1z",
    fill: "#6f4220"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#724221"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M56 71h-1v-1h1z",
    fill: "#6e3c1c"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#70401f"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#6b3b1b"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#6a3a1a"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#653615"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#643615"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#653716"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#643716"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#5e3010"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#451d05"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#4e260e"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#6c3e1d"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#663817"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#5f3110"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#653715"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M83 71v-1h1v1z",
    fill: "#4f2b13"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#68391a"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M86 70v1h-1v-1z",
    fill: "#6d3b1d"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M89 70h1v1h-1z",
    fill: "#754424"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v1h-1v-1z",
    fill: "#794927"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M91 71v-1h1v1z",
    fill: "#794926"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v1h-1v-1z",
    fill: "#7c4c29"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M95 70h1v1h-1z",
    fill: "#935e3a"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M97 71h-1v-1h1z",
    fill: "#96623c"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M99 71h-1v-1h1z",
    fill: "#9d6640"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M99 70h1v1h-1z",
    fill: "#b78058"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M101 70v1h-1v-1z",
    fill: "#c08c5e"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M102 71h-1v-1h1z",
    fill: "#bd8c57"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M103 71h-1v-1h1z",
    fill: "#bd8a5a"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71h-1v-1h1z",
    fill: "#c58e5c"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M105 70v1h-1v-1z",
    fill: "#c69362"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71v-1h1v1z",
    fill: "#9c7a5b",
    fillOpacity: 0.647
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M107 70h1v1h-1z",
    fill: "#2a5555",
    fillOpacity: 0.024
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h1v1h-1z",
    fill: "#463b30",
    fillOpacity: 0.184
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M110 71h-1v-1h1z",
    fill: "#5c463b",
    fillOpacity: 0.424
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M110 70h1v1h-1z",
    fill: "#705949",
    fillOpacity: 0.694
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70v1h-1v-1z",
    fill: "#725642",
    fillOpacity: 0.902
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70h1v1h-1z",
    fill: "#aa8a6e"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M114 70v1h-1v-1z",
    fill: "#bd9c80",
    fillOpacity: 0.965
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M115 70v1h-1v-1z",
    fill: "#ceb195",
    fillOpacity: 0.604
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M115 71v-1h1v1z",
    fill: "#bfac99",
    fillOpacity: 0.157
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71h1v1h-1z",
    fill: "#e8dab1",
    fillOpacity: 0.271
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71h1v1h-1z",
    fill: "#f0d4a5",
    fillOpacity: 0.886
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h-1v-1h1z",
    fill: "#ffd5a3"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v-1h1v1z",
    fill: "#e7c499"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M25 72h-1v-1h1z",
    fill: "#9c7c5c"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72h-1v-1h1z",
    fill: "#9f7855"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M27 71v1h-1v-1z",
    fill: "#b2855a"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v1h-1v-1z",
    fill: "#af7e4c"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#b48151"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#a7744d"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#9e6b45"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#8e5a37"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#8a5734"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h1v1h-1z",
    fill: "#82522d"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#875636"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#865534"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#82502f"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#784828"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#754525"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#744424"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#704323"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#6d4120"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#6b3e1e"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#6c3d1c"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#6d3d1d"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#673919"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#673a19"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#663819"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#613314"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#613515"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#5d3111"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#431d06"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#4e2710"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#6a3c1b"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#5d2f0e"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#663716"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M85 71h1v1h-1z",
    fill: "#6a381a"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71v1h-1v-1z",
    fill: "#6c3c1c"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v1h-1v-1z",
    fill: "#774525"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h-1v-1h1z",
    fill: "#794828"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72v-1h1v1z",
    fill: "#7e4c2b"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v-1h1v1z",
    fill: "#8b5a35"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72h-1v-1h1z",
    fill: "#935b37"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72v-1h1v1z",
    fill: "#955c37"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M100 71h1v1h-1z",
    fill: "#a97348"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h-1v-1h1z",
    fill: "#bd8b5f"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71v1h-1v-1z",
    fill: "#bd8c61"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M105 72h-1v-1h1z",
    fill: "#a37854",
    fillOpacity: 0.996
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71h1v1h-1z",
    fill: "#694a33",
    fillOpacity: 0.522
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M107 71v1h-1v-1z",
    fill: "#715744",
    fillOpacity: 0.494
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M108 72h-1v-1h1z",
    fill: "#7f614a",
    fillOpacity: 0.792
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M108 71h1v1h-1z",
    fill: "#a78366",
    fillOpacity: 0.961
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v-1h1v1z",
    fill: "#bd9674"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v-1h1v1z",
    fill: "#e2ba96"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72h-1v-1h1z",
    fill: "#debc9c",
    fillOpacity: 0.941
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M112 71h1v1h-1z",
    fill: "#e9ccae",
    fillOpacity: 0.596
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M114 72h-1v-1h1z",
    fill: "#f3e2c5",
    fillOpacity: 0.173
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h-1v-1h1z",
    fill: "#e9d4bf",
    fillOpacity: 0.188
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v1h-1v-1z",
    fill: "#efd0a8",
    fillOpacity: 0.831
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h1v1h-1z",
    fill: "#f7d4a2"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M24 73v-1h1v1z",
    fill: "#f7daab"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v-1h1v1z",
    fill: "#b19571"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73v-1h1v1z",
    fill: "#9a7958"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M27 72h1v1h-1z",
    fill: "#9d724d"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M29 72v1h-1v-1z",
    fill: "#84542d"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#7e4e2a"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#835333"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#865636"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#825332"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72h1v1h-1z",
    fill: "#7c4d2e"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h1v1z",
    fill: "#7a4c2b"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1z",
    fill: "#754625"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#724426"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#704325"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#6e4020"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#6c3e1f"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#683b1a"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#683c1c"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#633718"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#64381a"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#613517"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#603416"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#603618"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#5c3213"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#582e11"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#411c07"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#4c2611"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#693b1a"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#623413"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#5e300f"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#633513"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#5d3316"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73h-1v-1h1z",
    fill: "#522e18"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h1v1h-1z",
    fill: "#653617"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72h1v1h-1z",
    fill: "#683718"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h1v1h-1z",
    fill: "#774626"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M96 73v-1h1v1z",
    fill: "#7d4d29"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72v1h-1v-1z",
    fill: "#875731"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M98 73v-1h1v1z",
    fill: "#895a32"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72h1v1h-1z",
    fill: "#956840"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M100 72h1v1h-1z",
    fill: "#885c3d"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M101 72h1v1h-1z",
    fill: "#8c6248"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72v1h-1v-1z",
    fill: "#947052"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h1v1h-1z",
    fill: "#916c4e"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M104 72h1v1h-1z",
    fill: "#af8563"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M106 73h-1v-1h1z",
    fill: "#be9670"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M107 73h-1v-1h1z",
    fill: "#dcb68c"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M108 72v1h-1v-1z",
    fill: "#f2c89a"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v1h-1v-1z",
    fill: "#f1c69a"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v1h-1v-1z",
    fill: "#eec8a3",
    fillOpacity: 0.859
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73v-1h1v1z",
    fill: "#e8c6aa",
    fillOpacity: 0.529
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M111 73v-1h1v1z",
    fill: "#e6cdb4",
    fillOpacity: 0.161
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h1v1h-1z",
    fill: "#ebd7c4",
    fillOpacity: 0.153
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h-1v-1h1z",
    fill: "#f2d0ab",
    fillOpacity: 0.867
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v1h-1v-1z",
    fill: "#f8d1a3"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74h-1v-1h1z",
    fill: "#fbddaf"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73h1v1h-1z",
    fill: "#c4a883"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h-1v-1h1z",
    fill: "#927055"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h1v1h-1z",
    fill: "#946a4f"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73v1h-1v-1z",
    fill: "#825532"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#7f512c"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#7a4c2d"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#774929"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#784a29"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#764728"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#744627"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#714324"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#6e4022"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#6c3e1e"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#6f4121"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#704322"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1z",
    fill: "#6b3d1d"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#6b3d20"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#6a3d21"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#673a1d"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1z",
    fill: "#66391a"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#693c1b"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#65391b"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#66391d"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#65381c"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#64371b"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#5c3316"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#5c3216"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#5d3317"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#562d10"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#542b0e"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#4e280f"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#3b1905"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#49230c"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#653717"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#5e2f0f"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#593115"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#502b15"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1z",
    fill: "#633417"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1z",
    fill: "#653213"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M86 74v-1h1v1z",
    fill: "#663415"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73h1v1h-1z",
    fill: "#6d3e1f"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74h-1v-1h1z",
    fill: "#704122"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v-1h1v1z",
    fill: "#724223"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M94 74h-1v-1h1z",
    fill: "#754323"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M95 74v-1h1v1z",
    fill: "#764a29"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M97 73v1h-1v-1z",
    fill: "#7c5132"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M100 73v1h-1v-1z",
    fill: "#946d4f"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74h-1v-1h1z",
    fill: "#ae8968"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73v1h-1v-1z",
    fill: "#be9b76"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73h1v1h-1z",
    fill: "#d7b285"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M104 74h-1v-1h1z",
    fill: "#e6bb8a"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74h-1v-1h1z",
    fill: "#ebc194"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74v-1h1v1z",
    fill: "#ecca9e"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M106 74v-1h1v1z",
    fill: "#e1c499",
    fillOpacity: 0.929
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M108 74h-1v-1h1z",
    fill: "#dfc298",
    fillOpacity: 0.69
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M108 73h1v1h-1z",
    fill: "#ddc09b",
    fillOpacity: 0.353
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M109 73h1v1h-1z",
    fill: "#ceb6aa",
    fillOpacity: 0.082
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74v1h-1v-1z",
    fill: "#e9cba0",
    fillOpacity: 0.643
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h1v1h-1z",
    fill: "#fdd2a1"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74v1h-1v-1z",
    fill: "#f4ce9a"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M27 75h-1v-1h1z",
    fill: "#fcdba6"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M27 74h1v1h-1z",
    fill: "#d6b891"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h1v1h-1z",
    fill: "#8a6a51"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h1v1z",
    fill: "#8d6749"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74h1v1h-1z",
    fill: "#784d2d"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#744727"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#704224"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#754728"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#6c3f1f"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#6a3d20"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#633618"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#65391a"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#673a1b"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#683b1c"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#613319"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#603317"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#5b2f13"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#582f13"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#582e13"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#552c10"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#52290b"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#4b260d"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#361906"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#492209"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#5e3011"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#5c2d0f"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#623517"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#552f16"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-1z",
    fill: "#61351a"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#693615"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M87 74v1h-1v-1z",
    fill: "#633617"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75h-1v-1h1z",
    fill: "#643718"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h1v1h-1z",
    fill: "#6c3c1a"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1z",
    fill: "#6d3b17"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v1h-1v-1z",
    fill: "#6c3c19"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75v-1h1v1z",
    fill: "#71472a"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h-1v-1h1z",
    fill: "#785037"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75v-1h1v1z",
    fill: "#7a5137"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M96 74v1h-1v-1z",
    fill: "#7b5539"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v-1h1v1z",
    fill: "#9a785b"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74v1h-1v-1z",
    fill: "#ab8c6d"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75v-1h1v1z",
    fill: "#cfa87d"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M100 75h-1v-1h1z",
    fill: "#e4b787"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74v1h-1v-1z",
    fill: "#e4b888"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v-1h1v1z",
    fill: "#e2b786"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M103 74v1h-1v-1z",
    fill: "#e1b889"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M104 74v1h-1v-1z",
    fill: "#e9ba85"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M105 75h-1v-1h1z",
    fill: "#e1bb8d",
    fillOpacity: 0.886
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M106 75h-1v-1h1z",
    fill: "#dcc4a1",
    fillOpacity: 0.408
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M106 74h1v1h-1z",
    fill: "#d1c4aa",
    fillOpacity: 0.153
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M23 76v-1h1v1z",
    fill: "#e9ca9d",
    fillOpacity: 0.608
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M25 75h1v1h-1z",
    fill: "#f1ca92"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M26 75h1v1h-1z",
    fill: "#efcb93"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M28 75v1h-1v-1z",
    fill: "#f8d6a4"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M28 76v-1h1v1z",
    fill: "#e7c89e"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75v1h-1v-1z",
    fill: "#957859"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#8e6c5b"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1z",
    fill: "#7c563e"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1z",
    fill: "#6c4220"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1z",
    fill: "#6f4222"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#6c4021"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#6e4223"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fill: "#64391b"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#63381a"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#5f3416"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#60351a"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#5f3418"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M70 76h-1v-1h1z",
    fill: "#592f14"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#572d13"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#51280c"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#4a250d"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#371a09"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#49220a"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#5d3012"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#5b2e10"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#5d3114"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#4e2a14"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#502a11"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#623412"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h-1v-1h1z",
    fill: "#5f3414"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75v1h-1v-1z",
    fill: "#633819"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76v-1h1v1z",
    fill: "#663a1c"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M90 75v1h-1v-1z",
    fill: "#714528"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M91 76h-1v-1h1z",
    fill: "#764a32"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h1v1h-1z",
    fill: "#724933"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M93 75v1h-1v-1z",
    fill: "#815e48"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M93 76v-1h1v1z",
    fill: "#8a694f"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h1v1h-1z",
    fill: "#b9936f"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v1h-1v-1z",
    fill: "#dbb186"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76h-1v-1h1z",
    fill: "#e7bb8a"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76v-1h1v1z",
    fill: "#e6b982"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75h1v1h-1z",
    fill: "#e0b37d"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M100 76h-1v-1h1z",
    fill: "#ddb07c"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v1h-1v-1z",
    fill: "#daac79"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M102 76h-1v-1h1z",
    fill: "#d7aa76"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M103 75v1h-1v-1z",
    fill: "#d1a273"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M103 76v-1h1v1z",
    fill: "#d5a171"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M104 75h1v1h-1z",
    fill: "#cca884",
    fillOpacity: 0.667
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M23 77v-1h1v1z",
    fill: "#eecea2",
    fillOpacity: 0.596
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76v1h-1v-1z",
    fill: "#fcd09c"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76v1h-1v-1z",
    fill: "#f8d19d"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#f5d6a9"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#9f8468"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#896d56"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#7f5d40"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#6a3f1f"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#6d4323"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#6a4020"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#6d4222"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#6e4021"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#6a3c20"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#66391e"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#673a1f"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#683a1f"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#67391e"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#613318"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#5d3418"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#5b3215"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#593015"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#5b3218"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#512a11"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#4f260b"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#48220c"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#36190b"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#582d11"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#5a3016"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1z",
    fill: "#4c2814"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#4f270e"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#592f11"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#724228"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77h-1v-1h1z",
    fill: "#774c35"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#77523f"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#765745"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77h-1v-1h1z",
    fill: "#907058"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M92 76v1h-1v-1z",
    fill: "#b48f6e"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77h-1v-1h1z",
    fill: "#d1a77b"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77h-1v-1h1z",
    fill: "#eaba85"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77v-1h1v1z",
    fill: "#e5b97b"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M96 76v1h-1v-1z",
    fill: "#e0b477"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h-1v-1h1z",
    fill: "#ddac77"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M98 77h-1v-1h1z",
    fill: "#d8a473"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77h-1v-1h1z",
    fill: "#d3a26f"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M100 76h1v1h-1z",
    fill: "#cd9e6a"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M102 77h-1v-1h1z",
    fill: "#d0a26e"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77v-1h1v1z",
    fill: "#d6b689",
    fillOpacity: 0.647
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M24 77v1h-1v-1z",
    fill: "#edcfa5",
    fillOpacity: 0.573
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M24 78v-1h1v1z",
    fill: "#fcd19d"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M26 77v1h-1v-1z",
    fill: "#f5cb97"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78v-1h1v1z",
    fill: "#f5ca96"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M27 78v-1h1v1z",
    fill: "#f5cb95"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#f5cc94"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#f7daa8"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#a28869"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#94745c"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#845b3d"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#643a1b"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#683e1f"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#6a4021"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#6a3e1f"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#683c1d"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#65381d"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#66381d"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#62341a"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#61331a"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1z",
    fill: "#63361c"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#63361b"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#623519"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#613418"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#5e3519"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1z",
    fill: "#5c3519"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#5a3316"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#5a3216"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#5b3417"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1z",
    fill: "#5b3316"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#5c3417"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#5b3317"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#542b12"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#552c14"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#532a13"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#502810"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#512811"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1z",
    fill: "#4d250e"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#4b2109"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#451f0c"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#37180a"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#5c3114"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#53290d"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#593218"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#502f1d"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1z",
    fill: "#633d28"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1z",
    fill: "#784f38"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78h-1v-1h1z",
    fill: "#6c4733"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78v-1h1v1z",
    fill: "#7f5c47"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1z",
    fill: "#9a7658"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#c19a71"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#dcb17f"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v-1h1v1z",
    fill: "#eaba80"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77v1h-1v-1z",
    fill: "#e1b378"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78v-1h1v1z",
    fill: "#d6a76c"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M95 77v1h-1v-1z",
    fill: "#cd9d66"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M96 77v1h-1v-1z",
    fill: "#c99963"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M96 78v-1h1v1z",
    fill: "#c3935d"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h1v1h-1z",
    fill: "#c89961"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78v-1h1v1z",
    fill: "#ce9f69"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M102 78v-1h1v1z",
    fill: "#dcaf7c"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h1v1h-1z",
    fill: "#d9b78f",
    fillOpacity: 0.62
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v-1h1v1z",
    fill: "#e8cea8",
    fillOpacity: 0.533
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M28 78v1h-1v-1z",
    fill: "#f6cd96"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79h-1v-1h1z",
    fill: "#f6cc93"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#f2c58c"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#f0c892"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#fcd9a7"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#c7a77f"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1z",
    fill: "#8f6a51"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#7b4e31"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#683d23"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#61371d"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#623a1f"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#62391b"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#643a1c"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#603518"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#5e341b"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#5b3017"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#5c3118"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#583016"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#5a3116"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#582e14"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#572d14"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#572c13"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#562b13"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#522a11"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1z",
    fill: "#512910"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#4f260e"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#45200c"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#381503"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#44210a"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#5b3219"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#67412a"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#694732"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#664633"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1z",
    fill: "#72533f"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M83 79v-1h1v1z",
    fill: "#7f5d49"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1z",
    fill: "#9d795c"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1z",
    fill: "#c8a077"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1z",
    fill: "#daad7a"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78v1h-1v-1z",
    fill: "#e9ba84"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M89 79v-1h1v1z",
    fill: "#ddad74"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78h1v1h-1z",
    fill: "#c9975f"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h-1v-1h1z",
    fill: "#c29158"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M95 78v1h-1v-1z",
    fill: "#cd9d67"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M96 79h-1v-1h1z",
    fill: "#d0a16b"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h-1v-1h1z",
    fill: "#d2a36d"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78h1v1h-1z",
    fill: "#d6a772"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h-1v-1h1z",
    fill: "#daaa79"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79h-1v-1h1z",
    fill: "#dfb07b"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79v-1h1v1z",
    fill: "#daba8e",
    fillOpacity: 0.569
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79v1h-1v-1z",
    fill: "#e7cda6",
    fillOpacity: 0.506
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80v-1h1v1z",
    fill: "#f5cc96"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M27 79h1v1h-1z",
    fill: "#f3ca92"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79v1h-1v-1z",
    fill: "#f5cb93"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h-1v-1h1z",
    fill: "#f6cb93"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#edc692"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#f4d2a0"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#b99972"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#9c754e"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#764929"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#66371f"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80v-1h1v1z",
    fill: "#66381c"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#62391e"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#60381d"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#61381b"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#5f371a"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#5e3518"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#5c3319"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79h1v1h-1z",
    fill: "#5c3219"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#552c13"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#4f2c0f"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#4e290e"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#4f260d"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#4a2209"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#472207"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M75 79h1v1h-1z",
    fill: "#482610"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#472919"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#604331"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#715141"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#72513d"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#8e6c52"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#a48161"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#c59e73"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#e0b787"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#e3b884"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79v1h-1v-1z",
    fill: "#e1b47b"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h-1v-1h1z",
    fill: "#c89760"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80v-1h1v1z",
    fill: "#c29159"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M102 79h1v1h-1z",
    fill: "#dbab79"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h1v1h-1z",
    fill: "#e0b27f"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M104 80v-1h1v1z",
    fill: "#dabc94",
    fillOpacity: 0.525
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81v-1h1v1z",
    fill: "#e5caa4",
    fillOpacity: 0.475
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#fad09b"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h1v1z",
    fill: "#f1c891"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M28 80h1v1h-1z",
    fill: "#f7cd95"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#f4ca93"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#eec48d"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#ebc28a"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#f6d29a"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#e9c691"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#966f4a"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#74472a"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#623418"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#63371b"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#5d3319"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#5e361c"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#5c3419"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#552f15"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#522b11"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#522c12"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#522c11"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#542d12"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#502a0e"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#4b2509"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#48240b"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#4a260f"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#56321f"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#613e2f"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#6f4d3b"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#7e5b46"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#8d6750"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#b9906a"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#d4a779"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#e2b380"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#e6b67f"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#dfb079"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1z",
    fill: "#d7a86d"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80h1v1h-1z",
    fill: "#d1a264"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v1h-1v-1z",
    fill: "#ce9d62"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80h1v1h-1z",
    fill: "#c6935b"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v-1h1v1z",
    fill: "#d5a36b"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h1v1h-1z",
    fill: "#d7a56d"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81v-1h1v1z",
    fill: "#d7a976"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M103 80h1v1h-1z",
    fill: "#dfb381"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81h-1v-1h1z",
    fill: "#d9bc97",
    fillOpacity: 0.482
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81v1h-1v-1z",
    fill: "#e6c9a3",
    fillOpacity: 0.447
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M28 81h1v1h-1z",
    fill: "#f6cc95"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M29 82v-1h1v1z",
    fill: "#f2c792"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#f5c98f"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#f4c78e"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#ebc087"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#f2ce94"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#e0c08d"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#a37c54"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#7a4e2f"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1z",
    fill: "#5c331a"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#593217"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#593118"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#562e15"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#562f15"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#542e14"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#532e13"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#542e13"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#532c11"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#532c13"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#522c14"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#512b11"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#4f290e"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#502a0f"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#512a0e"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#4e270c"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#4c250a"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#613823"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#724e3b"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#7c5c49"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#735541"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#97755b"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#b38e66"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#d5ab79"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#e4b781"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#e1b37b"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#ddaf76"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#d8ab70"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#d3a46b"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#cb9965"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1z",
    fill: "#cf9f66"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82v-1h1v1z",
    fill: "#d4a46f"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M97 81h1v1h-1z",
    fill: "#dfb07a"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M99 82v-1h1v1z",
    fill: "#ddae7a"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81h1v1h-1z",
    fill: "#d5a874"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h-1v-1h1z",
    fill: "#ddb180"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M105 82h-1v-1h1z",
    fill: "#d8b896",
    fillOpacity: 0.439
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82v1h-1v-1z",
    fill: "#e8cda6",
    fillOpacity: 0.408
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1z",
    fill: "#f6ce99"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82h1v1h-1z",
    fill: "#f1c890"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#f1c691"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#f2c78e"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#f4c992"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#f2c890"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#f0c893"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h1v1h-1z",
    fill: "#a58157"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#754e2e"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#592f17"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#583017"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#572f16"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#552d16"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#532d14"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#553016"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#522e15"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#512d14"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#4f2c13"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#4f2a0f"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#512911"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#542b15"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#532a14"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#512812"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#502913"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#4f270f"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#4d240b"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#4c250b"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#522e13"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#6a452c"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#75503a"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#7e5b45"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#896951"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#8e6a52"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#ba936c"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#d3a976"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#e5b57c"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#e3b379"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#d1a167"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h-1v-1h1z",
    fill: "#d4a26a"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v1h-1v-1z",
    fill: "#daaa72"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M94 82h1v1h-1z",
    fill: "#d9aa73"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83h-1v-1h1z",
    fill: "#d4a775"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83v-1h1v1z",
    fill: "#dfad7c"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h1v1h-1z",
    fill: "#deb792",
    fillOpacity: 0.404
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v-1h1v1z",
    fill: "#e9cca7",
    fillOpacity: 0.376
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83h1v1h-1z",
    fill: "#f2cb96"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84h-1v-1h1z",
    fill: "#ecc28c"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#f1c692"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#f3c990"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#f5ca93"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#f2c690"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#efc58e"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84v-1h1v1z",
    fill: "#eec994"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#b08a60"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1z",
    fill: "#7e5636"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#552d14"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#562f14"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#522d14"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#502c12"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#502812"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#512913"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#4f2711"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#4c260c"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#482408"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#4d2a10"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#5c3a22"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#795743"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#815e4d"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#7f5d47"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#947356"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#b49069"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#daaf79"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#e5b780"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#e2b176"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84v-1h1v1z",
    fill: "#daa86b"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M102 84v-1h1v1z",
    fill: "#d9ab79"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84h-1v-1h1z",
    fill: "#ddac7b"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84v-1h1v1z",
    fill: "#d7b691",
    fillOpacity: 0.384
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84h1v1h-1z",
    fill: "#eacda7",
    fillOpacity: 0.341
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1z",
    fill: "#f1c995"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85v-1h1v1z",
    fill: "#edc48e"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M28 84v1h-1v-1z",
    fill: "#f2c991"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84v1h-1v-1z",
    fill: "#edc38d"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84v1h-1v-1z",
    fill: "#eec38f"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#f0c68d"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#f1c58f"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v1h-1v-1z",
    fill: "#ebc388"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84h1v1h-1z",
    fill: "#f0ca94"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#b99468"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#7e5734"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#552e12"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#552d11"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#583014"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#562e13"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#4d2a12"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1z",
    fill: "#49260d"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1z",
    fill: "#4b260e"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#47220b"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#6b4831"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M63 85v-1h1v1z",
    fill: "#89664e"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1z",
    fill: "#805d47"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#9b7255"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#c2936c"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#cb9d70"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#e3b680"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#d7a36a"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#c9955a"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#c8935a"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#c9945e"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M98 85h-1v-1h1z",
    fill: "#deaf79"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M103 84v1h-1v-1z",
    fill: "#dcae7b"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85v-1h1v1z",
    fill: "#daac7d"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M104 85v-1h1v1z",
    fill: "#d5b497",
    fillOpacity: 0.337
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86v-1h1v1z",
    fill: "#e5c8a1",
    fillOpacity: 0.31
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86v-1h1v1z",
    fill: "#efc894"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1z",
    fill: "#eec38d"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#eec78b"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#ebc78e"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#bb9768"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#856039"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#5a3313"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#542b16"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#4f2a11"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#4e290f"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#4b270f"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#4c2811"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1z",
    fill: "#4a2711"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#492710"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#46240d"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#48250d"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#6f4a34"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#886652"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#89674f"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#a47d5c"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h1z",
    fill: "#d2a67a"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1z",
    fill: "#e3b47f"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#dfaf75"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#d9a96d"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#d0a064"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#cc9b62"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#c7945e"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#cd9c5f"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85h1v1h-1z",
    fill: "#d7a871"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85h1v1h-1z",
    fill: "#d8ab7f"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M104 85h1v1h-1z",
    fill: "#dbbf9f",
    fillOpacity: 0.282
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87h-1v-1h1z",
    fill: "#dec9a1",
    fillOpacity: 0.278
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#ebc692"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1z",
    fill: "#efc690"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#f1c690"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#f2c88d"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#f1c98f"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#c2a06c"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#8b6842"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#5d381e"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#4a250f"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#4d2a0f"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#4d2b0f"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#4b270d"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#4c270e"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#46240e"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#41210d"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#472615"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#5c3b25"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#886444"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#ac8464"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#c2966e"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M63 86v1h-1v-1z",
    fill: "#e2b27e"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#ddac78"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#cd9c67"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1z",
    fill: "#c5945d"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#ca9a61"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#d3a36a"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M104 87h-1v-1h1z",
    fill: "#d6ad83",
    fillOpacity: 0.992
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M105 87h-1v-1h1z",
    fill: "#d6bea1",
    fillOpacity: 0.247
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87v1h-1v-1z",
    fill: "#e7cfa7",
    fillOpacity: 0.251
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M25 88h-1v-1h1z",
    fill: "#e7c490",
    fillOpacity: 0.996
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88h-1v-1h1z",
    fill: "#eec58f"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87h1v1h-1z",
    fill: "#efc68e"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v-1h1v1z",
    fill: "#f0c68e"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#ecc78d"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#c29f74"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1z",
    fill: "#8a644a"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#613a25"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#492410"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#4b2712"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#47260f"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87h1v1h-1z",
    fill: "#462611"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#462711"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M53 88v-1h1v1z",
    fill: "#442312"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#411f0d"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87h1v1h-1z",
    fill: "#4b280f"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#734e30"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#a17a58"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#b68d66"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#d2a677"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#dcae7d"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#d09f6a"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#c8975e"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#c99760"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#cc9b63"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h-1v-1h1z",
    fill: "#d9a86f"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M103 87h1v1h-1z",
    fill: "#d9b186",
    fillOpacity: 0.973
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M104 87h1v1h-1z",
    fill: "#d2baa1",
    fillOpacity: 0.204
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89h-1v-1h1z",
    fill: "#e9cfa8",
    fillOpacity: 0.231
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M25 89h-1v-1h1z",
    fill: "#e9c591",
    fillOpacity: 0.988
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v1h-1v-1z",
    fill: "#edc58d"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88h1v1h-1z",
    fill: "#edc38c"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#ebc08a"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#f0c58d"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#f3c98e"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#f2ca94"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#c8a27b"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#8d674b"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1z",
    fill: "#5f3723"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#47220d"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h1v1h-1z",
    fill: "#48260f"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#46270e"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#45260b"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#44240e"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88h1v1h-1z",
    fill: "#43220e"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1z",
    fill: "#422208"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#553415"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1z",
    fill: "#89653f"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h-1v-1h1z",
    fill: "#c19969"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#daae78"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#d2a16b"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#ce9b64"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#cb995f"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1z",
    fill: "#d6a56a"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1h1v1z",
    fill: "#ddae77"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M103 89h-1v-1h1z",
    fill: "#d8a873"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M104 88v1h-1v-1z",
    fill: "#d7ae83",
    fillOpacity: 0.957
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M105 89h-1v-1h1z",
    fill: "#dcbfa8",
    fillOpacity: 0.173
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89v1h-1v-1z",
    fill: "#e6caa3",
    fillOpacity: 0.208
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90v-1h1v1z",
    fill: "#e8c38f",
    fillOpacity: 0.98
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M28 90h-1v-1h1z",
    fill: "#eac189"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#f5c88e"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#f0c689"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#f3cb91"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#d3ad7f"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#8c6446"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#623d22"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v1h-1v-1z",
    fill: "#432109"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#43240e"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#43280d"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1z",
    fill: "#482711"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#5e3820"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#986e49"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#cca170"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#dbad79"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#cc9961"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#ca985b"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#d09d68"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#d09e66"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#ddac73"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v1h-1v-1z",
    fill: "#deaf77"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M103 90v-1h1v1z",
    fill: "#d6ad82",
    fillOpacity: 0.933
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M105 90h-1v-1h1z",
    fill: "#dcc0a5",
    fillOpacity: 0.145
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v-1h1v1z",
    fill: "#dfc4a4",
    fillOpacity: 0.188
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90h1v1h-1z",
    fill: "#eac593",
    fillOpacity: 0.969
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#f2c691"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91v-1h1v1z",
    fill: "#ecc18b"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M30 90v1h-1v-1z",
    fill: "#eec28a"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91v-1h1v1z",
    fill: "#efc28a"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#ecc28a"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#f5ca91"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#f3ca90"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#dfb580"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#9f744b"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#875c3b"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#845a38"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#6a4528"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#805a3a"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#bc8f62"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#d4a36d"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90v1h-1v-1z",
    fill: "#cb9a62"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#c99861"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#ce9c64"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91v-1h1v1z",
    fill: "#e3b27a"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M103 91h-1v-1h1z",
    fill: "#dcac79"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M103 90h1v1h-1z",
    fill: "#d4ae80",
    fillOpacity: 0.894
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M104 91v-1h1v1z",
    fill: "#d6c1ad",
    fillOpacity: 0.098
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M24 91v1h-1v-1z",
    fill: "#e6ceaa",
    fillOpacity: 0.165
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M25 91v1h-1v-1z",
    fill: "#e6c18f",
    fillOpacity: 0.953
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#f0c48e"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91h1v1h-1z",
    fill: "#efc38e"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91h1v1h-1z",
    fill: "#efc592"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M29 92v-1h1v1z",
    fill: "#edc795"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1z",
    fill: "#ebc38e"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#ebbe86"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#f4c993"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#d7ab78"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#b78a56"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#bf9061"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#ca9a69"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#ce9d66"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#cd9b61"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#dfae75"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92v-1h1v1z",
    fill: "#d9a973"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M95 91h1v1h-1z",
    fill: "#d5a771"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v-1h1v1z",
    fill: "#d1ab7c",
    fillOpacity: 0.851
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92v-1h1v1z",
    fill: "#dac8c8",
    fillOpacity: 0.055
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h-1v-1h1z",
    fill: "#e4c9a7",
    fillOpacity: 0.149
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v1h-1v-1z",
    fill: "#e6c08e",
    fillOpacity: 0.937
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92h1v1h-1z",
    fill: "#edc18b"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M28 93v-1h1v1z",
    fill: "#f0c997"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93h-1v-1h1z",
    fill: "#f1d0a5"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M30 92h1v1h-1z",
    fill: "#f0cb9d"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#ecc390"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#e9be88"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#efc68b"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#f6cc8f"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#ebbe80"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#d6a569"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#d3a26b"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v1h-1v-1z",
    fill: "#d4a670"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M102 93h-1v-1h1z",
    fill: "#d4a571"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v1h-1v-1z",
    fill: "#d6a675"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h1v1h-1z",
    fill: "#d4ae81",
    fillOpacity: 0.82
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92h1v1h-1z",
    fill: "#ccc",
    fillOpacity: 0.039
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94h-1v-1h1z",
    fill: "#e6cdac",
    fillOpacity: 0.122
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h1v1h-1z",
    fill: "#e5bf8d",
    fillOpacity: 0.918
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h1v1h-1z",
    fill: "#e9bd88"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M28 94v-1h1v1z",
    fill: "#eec694"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93v1h-1v-1z",
    fill: "#f1cfa6"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94h-1v-1h1z",
    fill: "#f0cea3"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93v1h-1v-1z",
    fill: "#edcb9f"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h1v1h-1z",
    fill: "#ecc797"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#f2c98d"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#f4c98b"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#e8b87b"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#d39f69"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#d2a26b"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#d1a26a"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#d1a069"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M102 94h-1v-1h1z",
    fill: "#d6a774"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94h-1v-1h1z",
    fill: "#d6a575"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94h-1v-1h1z",
    fill: "#d3ad81",
    fillOpacity: 0.796
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94v-1h1v1z",
    fill: "#ffdada",
    fillOpacity: 0.027
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94v1h-1v-1z",
    fill: "#e0ccad",
    fillOpacity: 0.098
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M24 95v-1h1v1z",
    fill: "#e5bd8c",
    fillOpacity: 0.898
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#ecc08a"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M28 95h-1v-1h1z",
    fill: "#e8bd88"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95h-1v-1h1z",
    fill: "#eec594"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#f3cfa0"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#efc896"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#ecc28b"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#ebbe89"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#edc287"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1z",
    fill: "#f1c78b"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#f4c78b"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#e9b97f"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#d4a169"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#d2a26a"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#d1a067"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94v1h-1v-1z",
    fill: "#daa978"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94h1v1h-1z",
    fill: "#d1aa82",
    fillOpacity: 0.741
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#e7d0b9",
    fillOpacity: 0.086
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M25 96h-1v-1h1z",
    fill: "#e6bc8c",
    fillOpacity: 0.89
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1z",
    fill: "#eabf89"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M30 95v1h-1v-1z",
    fill: "#f4d1a7"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1z",
    fill: "#efd1a3"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#f2d1a3"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#f0cb9c"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#eec695"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#eec58a"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h1v1h-1z",
    fill: "#edc486"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#f5cb90"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#e9bb80"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#dead74"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M103 95h1v1h-1z",
    fill: "#d1a980",
    fillOpacity: 0.698
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96v1h-1v-1z",
    fill: "#f0d4b8",
    fillOpacity: 0.071
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1z",
    fill: "#e5be8d",
    fillOpacity: 0.875
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96v1h-1v-1z",
    fill: "#ebbf88"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96h1v1h-1z",
    fill: "#e6bb85"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96h1v1h-1z",
    fill: "#eac190"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v-1h1v1z",
    fill: "#f3d0a6"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1z",
    fill: "#eecaa0"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96v1h-1v-1z",
    fill: "#edcfa3"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#efd0a6"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#eecda5"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#eecca3"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97h-1v-1h1z",
    fill: "#efcb98"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#eec793"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#ecc48b"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#edc487"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M102 96h1v1h-1z",
    fill: "#deac7b"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M103 96h1v1h-1z",
    fill: "#cfa67f",
    fillOpacity: 0.659
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97v1h-1v-1z",
    fill: "#e9e9bf",
    fillOpacity: 0.047
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97h1v1h-1z",
    fill: "#e6bf8d",
    fillOpacity: 0.847
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v1h-1v-1z",
    fill: "#ecc089"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h-1v-1h1z",
    fill: "#eabf8a"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98h-1v-1h1z",
    fill: "#e7bc86"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97h1v1h-1z",
    fill: "#f2d0a6"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#eecba4"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#f2d0a7"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#eccba0"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#edcca1"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#eecda1"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#f1c998"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#f4c78c"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1z",
    fill: "#dcab72"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M103 97h1v1h-1z",
    fill: "#cda57d",
    fillOpacity: 0.624
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M24 99h-1v-1h1z",
    fill: "#e2c6c6",
    fillOpacity: 0.035
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h-1v-1h1z",
    fill: "#e6bd8d",
    fillOpacity: 0.812
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M29 99h-1v-1h1z",
    fill: "#e9c190"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M31 99h-1v-1h1z",
    fill: "#f4d2a7"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h1v1h-1z",
    fill: "#efcea3"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#efcba2"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h-1v-1h1z",
    fill: "#edca9f"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#eac79c"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#eac79d"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#edcba2"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#f3cda4"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#efc691"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#f0c489"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-1z",
    fill: "#e9ba7f"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#e1b278"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#ddac71"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M104 98v1h-1v-1z",
    fill: "#cca984",
    fillOpacity: 0.573
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100h-1v-1h1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100v-1h1v1z",
    fill: "#e2ba8c",
    fillOpacity: 0.784
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100h-1v-1h1z",
    fill: "#e4b984"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v-1h1v1z",
    fill: "#e2b681"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M28 100v-1h1v1z",
    fill: "#e7bf8d"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100h-1v-1h1z",
    fill: "#eecda3"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M33 100h-1v-1h1z",
    fill: "#f0cfa4"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#eecba1"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#ebc79d"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#edc99d"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#eecda2"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#eec691"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#eec489"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#efc388"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1z",
    fill: "#eabb80"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M99 100h-1v-1h1z",
    fill: "#d9a971"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M103 99h1v1h-1z",
    fill: "#c6a986",
    fillOpacity: 0.514
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101h-1v-1h1z",
    fill: "#e0b788",
    fillOpacity: 0.757
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M25 100h1v1h-1z",
    fill: "#ebbe88"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v-1h1v1z",
    fill: "#e3b882"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1z",
    fill: "#f1cda3"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#efca9e"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#f1cfa5"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#f1c893"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#f3c58a"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M98 100h1v1h-1z",
    fill: "#d5a56d"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M100 101v-1h1v1z",
    fill: "#d5a671"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M102 101v-1h1v1z",
    fill: "#d7a673"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M103 100h1v1h-1z",
    fill: "#c5a481",
    fillOpacity: 0.455
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101v1h-1v-1z",
    fill: "#e0b586",
    fillOpacity: 0.678
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102v-1h1v1z",
    fill: "#e8bb85"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M28 102h-1v-1h1z",
    fill: "#e1b681"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M30 101v1h-1v-1z",
    fill: "#edc99f"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101v1h-1v-1z",
    fill: "#f3cea4"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#efcba1"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#eec99d"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#f7d2ac"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#eac086"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#e9bf85"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#e9ba80"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-1h1v1z",
    fill: "#d6a56e"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M98 101h1v1h-1z",
    fill: "#d2a36b"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M99 102v-1h1v1z",
    fill: "#d4a56d"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M103 102h-1v-1h1z",
    fill: "#d4a471"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M103 101h1v1h-1z",
    fill: "#c7a684",
    fillOpacity: 0.431
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M24 103v-1h1v1z",
    fill: "#e0b98b",
    fillOpacity: 0.388
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#e2b980"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h-1v-1h1z",
    fill: "#e3b980"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M28 103h-1v-1h1z",
    fill: "#e1b584"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M29 103h-1v-1h1z",
    fill: "#e3ba8b"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M30 102v1h-1v-1z",
    fill: "#efca9f"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M33 102v1h-1v-1z",
    fill: "#ecc79e"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v1z",
    fill: "#eac69c"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1z",
    fill: "#f4d0a6"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#eeca9d"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1z",
    fill: "#f2c68c"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#eec289"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#f1c389"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#d8a66d"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#ddab71"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M95 102v1h-1v-1z",
    fill: "#d4a36c"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M95 103v-1h1v1z",
    fill: "#d4a26b"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h-1v-1h1z",
    fill: "#d1a36a"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M99 102h1v1h-1z",
    fill: "#d1a46c"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M100 103v-1h1v1z",
    fill: "#d1a36d"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M102 102v1h-1v-1z",
    fill: "#d2a26d"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M104 103h-1v-1h1z",
    fill: "#c5a27d",
    fillOpacity: 0.4
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M25 103v1h-1v-1z",
    fill: "#d7c4b0",
    fillOpacity: 0.051
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104v-1h1v1z",
    fill: "#d6b381",
    fillOpacity: 0.757
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M26 104v-1h1v1z",
    fill: "#ebbb7e"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h1v1h-1z",
    fill: "#e6b481"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M29 104h-1v-1h1z",
    fill: "#e3ba89"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M30 104h-1v-1h1z",
    fill: "#eeca9e"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1z",
    fill: "#edc79e"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M35 104h-1v-1h1z",
    fill: "#efcaa0"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1z",
    fill: "#f4cfa5"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1z",
    fill: "#f0cca0"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#f0cea4"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#eec590"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#edbf86"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104h-1v-1h1z",
    fill: "#d4a368"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#d09f66"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h1v1h-1z",
    fill: "#d4a26e"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M101 104h-1v-1h1z",
    fill: "#d3a06e"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M102 104h-1v-1h1z",
    fill: "#d49e6b"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M102 103h1v1h-1z",
    fill: "#c6996b",
    fillOpacity: 0.996
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M104 103v1h-1v-1z",
    fill: "#b89b79",
    fillOpacity: 0.271
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104h1v1h-1z",
    fill: "#d1af8d",
    fillOpacity: 0.176
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M26 105v-1h1v1z",
    fill: "#deb07f",
    fillOpacity: 0.855
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105h-1v-1h1z",
    fill: "#ebb883"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105v-1h1v1z",
    fill: "#e0b884"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105v-1h1v1z",
    fill: "#eac69a"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105v-1h1v1z",
    fill: "#edc89f"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1z",
    fill: "#ecc69f"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#f0cba0"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#f2cda7"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M41 104v1h-1v-1z",
    fill: "#eac18c"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#eec287"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#f2c589"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#deac72"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#dbab71"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M91 105v-1h1v1z",
    fill: "#cd9c64"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M102 105h-1v-1h1z",
    fill: "#c89a6a",
    fillOpacity: 0.882
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M102 104h1v1h-1z",
    fill: "#be966e",
    fillOpacity: 0.451
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M104 105h-1v-1h1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M26 105h1v1h-1z",
    fill: "#ceaa8b",
    fillOpacity: 0.165
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105v1h-1v-1z",
    fill: "#d9b089",
    fillOpacity: 0.749
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M29 106h-1v-1h1z",
    fill: "#e1b784"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105h1v1h-1z",
    fill: "#ecc69b"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M31 106h-1v-1h1z",
    fill: "#eac59b"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105h1v1h-1z",
    fill: "#ebc69d"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-1h1z",
    fill: "#eac59a"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#ebc69c"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#ebc69b"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1z",
    fill: "#f1cca6"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#edc48f"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#f1c48a"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1z",
    fill: "#d5a56b"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105v1h-1v-1z",
    fill: "#cf9e65"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M96 106h-1v-1h1z",
    fill: "#cf9d64"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M98 105h1v1h-1z",
    fill: "#c79a66",
    fillOpacity: 0.969
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M100 105v1h-1v-1z",
    fill: "#c19b6b",
    fillOpacity: 0.765
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M101 105v1h-1v-1z",
    fill: "#bf9e71",
    fillOpacity: 0.424
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M102 105v1h-1v-1z",
    fill: "#bca07a",
    fillOpacity: 0.106
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M27 106h1v1h-1z",
    fill: "#d7b089",
    fillOpacity: 0.051
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M29 106v1h-1v-1z",
    fill: "#caa77b",
    fillOpacity: 0.478
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M29 107v-1h1v1z",
    fill: "#e3bf96",
    fillOpacity: 0.973
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M30 106h1v1h-1z",
    fill: "#edc69b"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M32 107h-1v-1h1z",
    fill: "#ebc59c"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M33 107h-1v-1h1z",
    fill: "#e9c49e"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106v1h-1v-1z",
    fill: "#ecc59e"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107h-1v-1h1z",
    fill: "#eec89e"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h1v1h-1z",
    fill: "#ecc89c"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106v1h-1v-1z",
    fill: "#eeca9c"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#eac699"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#eccb9e"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1z",
    fill: "#f3cea6"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#f0c387"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#e6b67c"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h-1v-1h1z",
    fill: "#d9a76d"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107v-1h1v1z",
    fill: "#d5a36a"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#d8a76c"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M89 106v1h-1v-1z",
    fill: "#d2a068"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M90 106v1h-1v-1z",
    fill: "#d19f66"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M95 106h1v1h-1z",
    fill: "#cb9c67",
    fillOpacity: 0.988
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M97 106v1h-1v-1z",
    fill: "#c49967",
    fillOpacity: 0.808
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M97 106h1v1h-1z",
    fill: "#c29565",
    fillOpacity: 0.514
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M99 106v1h-1v-1z",
    fill: "#b28a62",
    fillOpacity: 0.224
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M99 107v-1h1v1z",
    fill: "#6d4848",
    fillOpacity: 0.027
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M30 107v1h-1v-1z",
    fill: "#d8b998",
    fillOpacity: 0.42
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107v1h-1v-1z",
    fill: "#eecaa5",
    fillOpacity: 0.976
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h-1v-1h1z",
    fill: "#eac59c"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M34 108h-1v-1h1z",
    fill: "#e9c19b"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107v1h-1v-1z",
    fill: "#e8c299"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v-1h1v1z",
    fill: "#e9c69a"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108h-1v-1h1z",
    fill: "#ebc89b"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M38 107v1h-1v-1z",
    fill: "#e9c596"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#ebca9a"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#f2cca3"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#eac08f"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#e9bc84"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107v1h-1v-1z",
    fill: "#eec186"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108h-1v-1h1z",
    fill: "#ecbf84"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#edbf84"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107h1v1h-1z",
    fill: "#dca86f"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h1v1h-1z",
    fill: "#d1a064"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h1v1h-1z",
    fill: "#cd9f66"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M88 107v1h-1v-1z",
    fill: "#cea068"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h-1v-1h1z",
    fill: "#d0a168"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108v-1h1v1z",
    fill: "#d6a164"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M91 107h1v1h-1z",
    fill: "#d8a46a"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M93 108h-1v-1h1z",
    fill: "#ce9f6c"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M93 107h1v1h-1z",
    fill: "#c89c6c",
    fillOpacity: 0.859
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M94 107h1v1h-1z",
    fill: "#bf966a",
    fillOpacity: 0.584
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M95 108v-1h1v1z",
    fill: "#b59067",
    fillOpacity: 0.271
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M96 107h1v1h-1z",
    fill: "#89624e",
    fillOpacity: 0.051
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M31 108v1h-1v-1z",
    fill: "#e3c9ae",
    fillOpacity: 0.396
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M31 109v-1h1v1z",
    fill: "#e8caa6",
    fillOpacity: 0.953
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M32 108h1v1h-1z",
    fill: "#ebc89e"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h1v1h-1z",
    fill: "#e6c399"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v1h-1v-1z",
    fill: "#e6c29a"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108h1v1h-1z",
    fill: "#e8c59e"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108v1h-1v-1z",
    fill: "#e8c49d"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M38 109h-1v-1h1z",
    fill: "#e8c495"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v1h-1v-1z",
    fill: "#e9c798"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#f2cda4"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#ebc18f"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1z",
    fill: "#e3b67f"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1z",
    fill: "#d8a66b"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#cea063"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v-1h1v1z",
    fill: "#d3a368"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109h-1v-1h1z",
    fill: "#d7a86c"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h1v1h-1z",
    fill: "#d3a36b"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h1v1h-1z",
    fill: "#ca9e6a",
    fillOpacity: 0.882
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109h-1v-1h1z",
    fill: "#c59a6a",
    fillOpacity: 0.627
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109v-1h1v1z",
    fill: "#b8926c",
    fillOpacity: 0.314
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M94 108v1h-1v-1z",
    fill: "#a58c66",
    fillOpacity: 0.078
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M32 109v1h-1v-1z",
    fill: "#e4cdb7",
    fillOpacity: 0.306
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M33 109v1h-1v-1z",
    fill: "#e5c8a8",
    fillOpacity: 0.906
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v-1h1v1z",
    fill: "#ebcaa3"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110v-1h1v1z",
    fill: "#e8c6a0"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M36 110h-1v-1h1z",
    fill: "#ebc8a0"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M37 109h1v1h-1z",
    fill: "#eac597"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h-1v-1h1z",
    fill: "#eac899"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109h1v1h-1z",
    fill: "#f0cba2"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v1h-1v-1z",
    fill: "#ecc190"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#e2b57f"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#e9bc85"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#e9bc82"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1z",
    fill: "#ebbd82"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h1z",
    fill: "#d8a46c"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#cf9c63"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v1h-1v-1z",
    fill: "#d0a369"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h1v1h-1z",
    fill: "#c99e6b",
    fillOpacity: 0.914
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109v1h-1v-1z",
    fill: "#c59d6d",
    fillOpacity: 0.675
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M89 110v-1h1v1z",
    fill: "#bc9569",
    fillOpacity: 0.361
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v-1h1v1z",
    fill: "#aa8d67",
    fillOpacity: 0.106
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v1h-1v-1z",
    fill: "#e3c8b1",
    fillOpacity: 0.22
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111h-1v-1h1z",
    fill: "#e5cbab",
    fillOpacity: 0.835
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110h1v1h-1z",
    fill: "#e8c9a1"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M35 111v-1h1v1z",
    fill: "#e5c397"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v-1h1v1z",
    fill: "#e4c194"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M37 110h1v1h-1z",
    fill: "#eac697"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110v1h-1v-1z",
    fill: "#ecc899"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h1v1h-1z",
    fill: "#eec79f"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111v-1h1v1z",
    fill: "#e6b981"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v1h-1v-1z",
    fill: "#e6b881"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h1v1h-1z",
    fill: "#e9bb82"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M45 110v1h-1v-1z",
    fill: "#ebbd83"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fill: "#ebbe82"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h1v1h-1z",
    fill: "#e4b57a"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110v1h-1v-1z",
    fill: "#daa76d"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110h1v1h-1z",
    fill: "#d19e64"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#cf9b61"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111h-1v-1h1z",
    fill: "#d29f65"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#ce9b66"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#d39f68"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111v-1h1v1z",
    fill: "#d39e65"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M82 111h-1v-1h1z",
    fill: "#d49d63"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110h1v1h-1z",
    fill: "#d6a265"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h1v1h-1z",
    fill: "#d5a46b"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110v1h-1v-1z",
    fill: "#ca9c6a",
    fillOpacity: 0.937
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1z",
    fill: "#c69966",
    fillOpacity: 0.702
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M86 110h1v1h-1z",
    fill: "#bb986b",
    fillOpacity: 0.4
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110v1h-1v-1z",
    fill: "#ac8e69",
    fillOpacity: 0.133
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111v1h-1v-1z",
    fill: "#e1d2b4",
    fillOpacity: 0.133
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M34 112v-1h1v1z",
    fill: "#e3c7a6",
    fillOpacity: 0.737
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v1h-1v-1z",
    fill: "#e8c69d"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112h-1v-1h1z",
    fill: "#e2be94"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M37 111h1v1h-1z",
    fill: "#e7c497"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112h-1v-1h1z",
    fill: "#e9c496"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M40 112h-1v-1h1z",
    fill: "#eec69d"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M40 111h1v1h-1z",
    fill: "#eac18d"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M44 111v1h-1v-1z",
    fill: "#e8b981"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M44 112v-1h1v1z",
    fill: "#eabb83"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112h-1v-1h1z",
    fill: "#ce9c63"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h1v1h-1z",
    fill: "#d39d64"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h1v1h-1z",
    fill: "#d7a268"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v-1h1v1z",
    fill: "#c79762",
    fillOpacity: 0.973
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112h-1v-1h1z",
    fill: "#c09663",
    fillOpacity: 0.765
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M84 111v1h-1v-1z",
    fill: "#b89164",
    fillOpacity: 0.467
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#aa8567",
    fillOpacity: 0.165
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fillOpacity: 0.004
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M35 112v1h-1v-1z",
    fill: "#dfcfbf",
    fillOpacity: 0.063
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M36 113h-1v-1h1z",
    fill: "#dfc3a6",
    fillOpacity: 0.635
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112v1h-1v-1z",
    fill: "#e8c7a6"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M38 112v1h-1v-1z",
    fill: "#e4c29b"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112v1h-1v-1z",
    fill: "#e4c096"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h-1v-1h1z",
    fill: "#e8c19a"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113v-1h1v1z",
    fill: "#e9c18d"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M43 112h1v1h-1z",
    fill: "#e6b780"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113h-1v-1h1z",
    fill: "#ebbe84"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#d6a467"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#d8a669"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112v1h-1v-1z",
    fill: "#dba76c"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M79 112v1h-1v-1z",
    fill: "#d09c69",
    fillOpacity: 0.969
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113h-1v-1h1z",
    fill: "#c59968",
    fillOpacity: 0.796
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112h1v1h-1z",
    fill: "#b89367",
    fillOpacity: 0.522
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113h-1v-1h1z",
    fill: "#a7885c",
    fillOpacity: 0.227
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112v1h-1v-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.027
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M35 113h1v1h-1z",
    fill: "#ffffd4",
    fillOpacity: 0.024
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M36 114v-1h1v1z",
    fill: "#e2c7b0",
    fillOpacity: 0.522
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114h-1v-1h1z",
    fill: "#e4c6a4",
    fillOpacity: 0.992
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M38 113h1v1h-1z",
    fill: "#e6c49d"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114h-1v-1h1z",
    fill: "#e7bf9c"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#e7be8c"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M41 113h1v1h-1z",
    fill: "#e1b27a"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114v-1h1v1z",
    fill: "#e5b67d"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114h-1v-1h1z",
    fill: "#ebbc84"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#e8bb80"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#ebbe83"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M56 114v-1h1v1z",
    fill: "#d3a068"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114h-1v-1h1z",
    fill: "#d6a368"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h-1v-1h1z",
    fill: "#d4a163"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M75 114h-1v-1h1z",
    fill: "#d9a568"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M76 114h-1v-1h1z",
    fill: "#ca9d67",
    fillOpacity: 0.98
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M76 113h1v1h-1z",
    fill: "#c99c6c",
    fillOpacity: 0.8
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114v-1h1v1z",
    fill: "#c19569",
    fillOpacity: 0.522
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M78 114v-1h1v1z",
    fill: "#b18864",
    fillOpacity: 0.22
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113v1h-1v-1z",
    fill: "#664c4c",
    fillOpacity: 0.039
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115h-1v-1h1z",
    fill: "#e3c8aa",
    fillOpacity: 0.439
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v-1h1v1z",
    fill: "#e5c9a4",
    fillOpacity: 0.965
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114v1h-1v-1z",
    fill: "#edc8a1"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115h-1v-1h1z",
    fill: "#e7bc8c"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#deaf78"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114h1v1h-1z",
    fill: "#e1b27b"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114v1h-1v-1z",
    fill: "#e3b47d"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1z",
    fill: "#e9ba81"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M47 115v-1h1v1z",
    fill: "#e6b67b"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h1v1h-1z",
    fill: "#d09f64"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M55 115h-1v-1h1z",
    fill: "#d7a46a"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M61 114h1v1h-1z",
    fill: "#d5a367"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v1h-1v-1z",
    fill: "#d4a266"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v-1h1v1z",
    fill: "#d19f63"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114v1h-1v-1z",
    fill: "#d7a569"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M70 114v1h-1v-1z",
    fill: "#d4a064"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M71 115h-1v-1h1z",
    fill: "#d8a267"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M71 115v-1h1v1z",
    fill: "#d9a66c"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114v1h-1v-1z",
    fill: "#cea06a",
    fillOpacity: 0.996
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114v1h-1v-1z",
    fill: "#cb9e6b",
    fillOpacity: 0.831
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h1v1h-1z",
    fill: "#bf9769",
    fillOpacity: 0.549
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M75 115v-1h1v1z",
    fill: "#b28d65",
    fillOpacity: 0.247
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M76 115v-1h1v1z",
    fill: "#735c45",
    fillOpacity: 0.043
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116v-1h1v1z",
    fill: "#dfccaa",
    fillOpacity: 0.318
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#e9caa4",
    fillOpacity: 0.902
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M40 115h1v1h-1z",
    fill: "#eec394"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1z",
    fill: "#e0b17a"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M43 115v1h-1v-1z",
    fill: "#e2b37b"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116h-1v-1h1z",
    fill: "#e2b279"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115h1v1h-1z",
    fill: "#ecbb81"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v1h-1v-1z",
    fill: "#cd9d62"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M64 115v1h-1v-1z",
    fill: "#cb9b61"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M66 115h1v1h-1z",
    fill: "#d49f65"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M68 116h-1v-1h1z",
    fill: "#d8a56b"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M70 115h1v1h-1z",
    fill: "#cd9d6b",
    fillOpacity: 0.871
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M72 115v1h-1v-1z",
    fill: "#c5996b",
    fillOpacity: 0.604
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M72 116v-1h1v1z",
    fill: "#b28b65",
    fillOpacity: 0.286
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M73 116v-1h1v1z",
    fill: "#8f6f5f",
    fillOpacity: 0.063
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M39 116h1v1h-1z",
    fill: "#eccbae",
    fillOpacity: 0.212
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v1h-1v-1z",
    fill: "#e2be91",
    fillOpacity: 0.82
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117v-1h1v1z",
    fill: "#e3b176"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116v1h-1v-1z",
    fill: "#e3b177"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M44 117v-1h1v1z",
    fill: "#e3b47b"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M46 116v1h-1v-1z",
    fill: "#e8b77d"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M63 116v1h-1v-1z",
    fill: "#cf9e63"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M63 117v-1h1v1z",
    fill: "#ce9b61"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116v1h-1v-1z",
    fill: "#d7a269"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116h1v1h-1z",
    fill: "#d9a468"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M67 116h1v1h-1z",
    fill: "#ca9d6d",
    fillOpacity: 0.906
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M69 116v1h-1v-1z",
    fill: "#c0976d",
    fillOpacity: 0.659
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M70 116v1h-1v-1z",
    fill: "#b58f69",
    fillOpacity: 0.341
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M71 117h-1v-1h1z",
    fill: "#9b7963",
    fillOpacity: 0.09
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M41 118h-1v-1h1z",
    fill: "#dbb895",
    fillOpacity: 0.114
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M41 117h1v1h-1z",
    fill: "#d4af81",
    fillOpacity: 0.725
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118h-1v-1h1z",
    fill: "#dfb179"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M43 117h1v1h-1z",
    fill: "#e4b176"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M45 117v1h-1v-1z",
    fill: "#e0b078"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118v-1h1v1z",
    fill: "#e7b67d"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117v1h-1v-1z",
    fill: "#ebba80"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v-1h1v1z",
    fill: "#eab87e"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M61 118v-1h1v1z",
    fill: "#d8a265"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M62 117h1v1h-1z",
    fill: "#d7a165"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M63 117h1v1h-1z",
    fill: "#d2a069"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M65 118h-1v-1h1z",
    fill: "#c99a67",
    fillOpacity: 0.929
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M66 118h-1v-1h1z",
    fill: "#c29968",
    fillOpacity: 0.698
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M66 118v-1h1v1z",
    fill: "#b49064",
    fillOpacity: 0.388
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M68 118h-1v-1h1z",
    fill: "#9f7f57",
    fillOpacity: 0.125
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M41 119v-1h1v1z",
    fill: "#cfbf9f",
    fillOpacity: 0.063
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118v1h-1v-1z",
    fill: "#cfa779",
    fillOpacity: 0.608
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M43 118h1v1h-1z",
    fill: "#ddad78"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M45 119h-1v-1h1z",
    fill: "#e2af76"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v1h-1v-1z",
    fill: "#e8b980"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118h1v1h-1z",
    fill: "#e5b57b"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M56 118v1h-1v-1z",
    fill: "#d09d62"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M56 119v-1h1v1z",
    fill: "#cd9a5e"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M58 118v1h-1v-1z",
    fill: "#d09c61"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M59 118v1h-1v-1z",
    fill: "#d19e62"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M60 118v1h-1v-1z",
    fill: "#d7a469"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119h-1v-1h1z",
    fill: "#ca9c68",
    fillOpacity: 0.945
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M63 118v1h-1v-1z",
    fill: "#c09767",
    fillOpacity: 0.733
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M63 119v-1h1v1z",
    fill: "#ba946a",
    fillOpacity: 0.424
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M65 118v1h-1v-1z",
    fill: "#a38262",
    fillOpacity: 0.153
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M44 119v1h-1v-1z",
    fill: "#cea77d",
    fillOpacity: 0.478
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M45 119v1h-1v-1z",
    fill: "#dbab74",
    fillOpacity: 0.98
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M46 119v1h-1v-1z",
    fill: "#e5b079"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120v-1h1v1z",
    fill: "#e2b77c"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119v1h-1v-1z",
    fill: "#d1a165"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h1v1h-1z",
    fill: "#ce9b62"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M54 119h1v1h-1z",
    fill: "#d09d63"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M55 119h1v1h-1z",
    fill: "#d19d62"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M56 119h1v1h-1z",
    fill: "#d5a063"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M57 120v-1h1v1z",
    fill: "#d5a168"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M58 119h1v1h-1z",
    fill: "#c59662",
    fillOpacity: 0.973
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M59 119h1v1h-1z",
    fill: "#c29868",
    fillOpacity: 0.788
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M61 120h-1v-1h1z",
    fill: "#b69161",
    fillOpacity: 0.482
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119v1h-1v-1z",
    fill: "#a2825c",
    fillOpacity: 0.184
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M44 121v-1h1v1z",
    fill: "#bc9569",
    fillOpacity: 0.388
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M46 120v1h-1v-1z",
    fill: "#d8a976",
    fillOpacity: 0.945
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M48 120v1h-1v-1z",
    fill: "#e1b377"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M49 120v1h-1v-1z",
    fill: "#d1a166"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M49 121v-1h1v1z",
    fill: "#cfa064"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M52 120h1v1h-1z",
    fill: "#d29e64"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M54 121h-1v-1h1z",
    fill: "#d29b62"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M54 121v-1h1v1z",
    fill: "#d5a16a"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121h-1v-1h1z",
    fill: "#c79a68"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121v-1h1v1z",
    fill: "#c29768",
    fillOpacity: 0.843
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M57 120h1v1h-1z",
    fill: "#b28b60",
    fillOpacity: 0.537
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M59 120v1h-1v-1z",
    fill: "#a7835c",
    fillOpacity: 0.227
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M59 121v-1h1v1z",
    fill: "#555538",
    fillOpacity: 0.035
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v1h-1v-1z",
    fill: "#c7a07a",
    fillOpacity: 0.286
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121h1v1h-1z",
    fill: "#d5ad7c",
    fillOpacity: 0.894
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121v1h-1v-1z",
    fill: "#e7b87c"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122h-1v-1h1z",
    fill: "#ce9d5d"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122h-1v-1h1z",
    fill: "#d0a060"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M52 122h-1v-1h1z",
    fill: "#d1a468"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M53 121v1h-1v-1z",
    fill: "#ca9f69"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M53 121h1v1h-1z",
    fill: "#be9465",
    fillOpacity: 0.898
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122h-1v-1h1z",
    fill: "#b18a60",
    fillOpacity: 0.643
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M55 121h1v1h-1z",
    fill: "#a5825c",
    fillOpacity: 0.314
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M56 121h1v1h-1z",
    fill: "#78694b",
    fillOpacity: 0.067
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M47 123h-1v-1h1z",
    fill: "#d1ab85",
    fillOpacity: 0.239
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123h-1v-1h1z",
    fill: "#e3b782",
    fillOpacity: 0.867
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123v-1h1v1z",
    fill: "#ddab6d"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122v1h-1v-1z",
    fill: "#cf9e68"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122v1h-1v-1z",
    fill: "#c19566",
    fillOpacity: 0.91
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123v-1h1v1z",
    fill: "#b58f65",
    fillOpacity: 0.671
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M53 123h-1v-1h1z",
    fill: "#a3835d",
    fillOpacity: 0.373
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M54 123h-1v-1h1z",
    fill: "#91765b",
    fillOpacity: 0.11
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124h-1v-1h1z",
    fill: "#e1bb96",
    fillOpacity: 0.133
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124v-1h1v1z",
    fill: "#d6ad7d",
    fillOpacity: 0.416
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124h-1v-1h1z",
    fill: "#c09d70",
    fillOpacity: 0.337
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M51 124h-1v-1h1z",
    fill: "#907755",
    fillOpacity: 0.118
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardboardBox);
export default __webpack_public_path__ + "static/media/cardboard-box.9a3f3beb08848c77bad2496f8f6687b8.svg";
export { ForwardRef as ReactComponent };